// 不同国家对应的行业，首位是最新行业列表，之后的是为了兼容旧数据回显
export const tradeData = {
  Singapore: [
    {
      value: "[01111]Growing of leafy and fruit vegetables (non-hydroponics)",
      label: "[01111]Growing of leafy and fruit vegetables (non-hydroponics)",
    },
    {
      value: "[01112]Growing of mushrooms (non-hydroponics)",
      label: "[01112]Growing of mushrooms (non-hydroponics)",
    },
    {
      value: "[01119]Growing of food crops (non-hydroponics) n.e.c.",
      label: "[01119]Growing of food crops (non-hydroponics) n.e.c.",
    },
    {
      value: "[01120]Growing of leafy and fruit vegetables (hydroponics)",
      label: "[01120]Growing of leafy and fruit vegetables (hydroponics)",
    },
    {
      value: "[01130]Growing of fruits and nuts (except legumes)",
      label: "[01130]Growing of fruits and nuts (except legumes)",
    },
    {
      value: "[01141]Growing of orchids",
      label: "[01141]Growing of orchids",
    },
    {
      value: "[01142]Growing of ornamental plants",
      label: "[01142]Growing of ornamental plants",
    },
    {
      value: "[01149]Growing of nursery products n.e.c.",
      label: "[01149]Growing of nursery products n.e.c.",
    },
    {
      value: "[01190]Growing of other crops",
      label: "[01190]Growing of other crops",
    },
    {
      value: "[01410]Cattle and goat farms (for livestock and milk production)",
      label: "[01410]Cattle and goat farms (for livestock and milk production)",
    },
    {
      value: "[01421]Rearing of poultry (except layer farms)",
      label: "[01421]Rearing of poultry (except layer farms)",
    },
    {
      value: "[01422]Layer farms (chickens reared for eggs)",
      label: "[01422]Layer farms (chickens reared for eggs)",
    },
    {
      value: "[01491]Dog breeding",
      label: "[01491]Dog breeding",
    },
    {
      value: "[01492]Bird breeding",
      label: "[01492]Bird breeding",
    },
    {
      value: "[01499]Other animal production n.e.c.",
      label: "[01499]Other animal production n.e.c.",
    },
    {
      value: "[01500]Growing of crops combined with animal production (mixed farming)",
      label: "[01500]Growing of crops combined with animal production (mixed farming)",
    },
    {
      value: "[01600]Agricultural and animal husbandry service activities (except veterinary activities)",
      label: "[01600]Agricultural and animal husbandry service activities (except veterinary activities)",
    },
    {
      value: "[02000]Forestry, logging and related service activities",
      label: "[02000]Forestry, logging and related service activities",
    },
    {
      value: "[03101]Ocean, coastal and kelong fishing",
      label: "[03101]Ocean, coastal and kelong fishing",
    },
    {
      value: "[03109]Fishing n.e.c.",
      label: "[03109]Fishing n.e.c.",
    },
    {
      value: "[03201]Food fish farms and food fish hatcheries",
      label: "[03201]Food fish farms and food fish hatcheries",
    },
    {
      value: "[03202]Ornamental fish farms and ornamental fish hatcheries",
      label: "[03202]Ornamental fish farms and ornamental fish hatcheries",
    },
    {
      value: "[03209]Aquaculture n.e.c.",
      label: "[03209]Aquaculture n.e.c.",
    },
    {
      value: "[08101]Stone quarrying",
      label: "[08101]Stone quarrying",
    },
    {
      value: "[08102]Quarrying of sand and clay",
      label: "[08102]Quarrying of sand and clay",
    },
    {
      value: "[08900]Other mining and quarrying",
      label: "[08900]Other mining and quarrying",
    },
    {
      value: "[09001]Crude petroleum and natural gas production",
      label: "[09001]Crude petroleum and natural gas production",
    },
    {
      value:
        "[09002]Service activities incidental to oil and gas extraction (except surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities)",
      label:
        "[09002]Service activities incidental to oil and gas extraction (except surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities)",
    },
    {
      value: "[10101]Slaughtering of livestock and poultry",
      label: "[10101]Slaughtering of livestock and poultry",
    },
    {
      value: "[10102]Manufacture of sausage",
      label: "[10102]Manufacture of sausage",
    },
    {
      value: "[10103]Preparing, canning and preserving of livestock and livestock products",
      label: "[10103]Preparing, canning and preserving of livestock and livestock products",
    },
    {
      value: "[10104]Preparing, canning and preserving of poultry and poultry products",
      label: "[10104]Preparing, canning and preserving of poultry and poultry products",
    },
    {
      value: "[10109]Processing and preserving of meat and meat products n.e.c.",
      label: "[10109]Processing and preserving of meat and meat products n.e.c.",
    },
    {
      value: "[10200]Processing and preserving of seafood",
      label: "[10200]Processing and preserving of seafood",
    },
    {
      value: "[10301]Manufacture of jams",
      label: "[10301]Manufacture of jams",
    },
    {
      value: "[10302]Other canning and preserving of fruits and fruit juices",
      label: "[10302]Other canning and preserving of fruits and fruit juices",
    },
    {
      value: "[10303]Other canning and preserving of vegetables and vegetable juices",
      label: "[10303]Other canning and preserving of vegetables and vegetable juices",
    },
    {
      value: "[10401]Manufacture of edible vegetable and animal oils and fats",
      label: "[10401]Manufacture of edible vegetable and animal oils and fats",
    },
    {
      value: "[10402]Manufacture of inedible vegetable and animal oils and fats",
      label: "[10402]Manufacture of inedible vegetable and animal oils and fats",
    },
    {
      value: "[10409]Manufacture of vegetable and animal oils and fats n.e.c.",
      label: "[10409]Manufacture of vegetable and animal oils and fats n.e.c.",
    },
    {
      value: "[10501]Manufacture of condensed and evaporated milk; pasteurising and bottling of fluid milk",
      label: "[10501]Manufacture of condensed and evaporated milk; pasteurising and bottling of fluid milk",
    },
    {
      value: "[10502]Manufacture of milk powder",
      label: "[10502]Manufacture of milk powder",
    },
    {
      value: "[10503]Manufacture of ice-cream",
      label: "[10503]Manufacture of ice-cream",
    },
    {
      value: "[10509]Manufacture of dairy products n.e.c.",
      label: "[10509]Manufacture of dairy products n.e.c.",
    },
    {
      value: "[10611]Rice milling",
      label: "[10611]Rice milling",
    },
    {
      value: "[10612]Wheat milling",
      label: "[10612]Wheat milling",
    },
    {
      value: "[10619]Manufacture of grain mill products n.e.c.",
      label: "[10619]Manufacture of grain mill products n.e.c.",
    },
    {
      value: "[10620]Manufacture of starches and starch products",
      label: "[10620]Manufacture of starches and starch products",
    },
    {
      value: "[10711]Manufacture of biscuits",
      label: "[10711]Manufacture of biscuits",
    },
    {
      value: "[10712]Manufacture of bread, cakes and confectionery (except frozen bakery products)",
      label: "[10712]Manufacture of bread, cakes and confectionery (except frozen bakery products)",
    },
    {
      value: "[10719]Manufacture of bakery products n.e.c.",
      label: "[10719]Manufacture of bakery products n.e.c.",
    },
    {
      value: "[10720]Manufacture of sugar and sugar products",
      label: "[10720]Manufacture of sugar and sugar products",
    },
    {
      value: "[10731]Manufacture of cocoa and chocolate powder from beans",
      label: "[10731]Manufacture of cocoa and chocolate powder from beans",
    },
    {
      value: "[10732]Manufacture of chocolate and chocolate products",
      label: "[10732]Manufacture of chocolate and chocolate products",
    },
    {
      value: "[10733]Manufacture of non-chocolate confectionery",
      label: "[10733]Manufacture of non-chocolate confectionery",
    },
    {
      value: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products",
      label: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products",
    },
    {
      value: "[10750]Manufacture of prepared meals and dishes",
      label: "[10750]Manufacture of prepared meals and dishes",
    },
    {
      value: "[10761]Manufacture of instant beverages",
      label: "[10761]Manufacture of instant beverages",
    },
    {
      value: "[10762]Processing of coffee seeds",
      label: "[10762]Processing of coffee seeds",
    },
    {
      value: "[10763]Manufacture of coffee powder",
      label: "[10763]Manufacture of coffee powder",
    },
    {
      value: "[10764]Manufacture of tea; processing of tea leaves",
      label: "[10764]Manufacture of tea; processing of tea leaves",
    },
    {
      value: "[10791]Manufacture of sauces",
      label: "[10791]Manufacture of sauces",
    },
    {
      value: "[10792]Manufacture of soya bean products (except soy-based meat alternatives, sauce and milk)",
      label: "[10792]Manufacture of soya bean products (except soy-based meat alternatives, sauce and milk)",
    },
    {
      value: "[10793]Manufacture and processing of spices",
      label: "[10793]Manufacture and processing of spices",
    },
    {
      value: "[10794]Manufacture of chips, crackers and other titbits (except biscuits and confectionery)",
      label: "[10794]Manufacture of chips, crackers and other titbits (except biscuits and confectionery)",
    },
    {
      value: "[10795]Manufacture of plant-based/microbial-fermented/cell-cultivated food products",
      label: "[10795]Manufacture of plant-based/microbial-fermented/cell-cultivated food products",
    },
    {
      value: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives)",
      label: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives)",
    },
    {
      value: "[10800]Manufacture of prepared animal feeds",
      label: "[10800]Manufacture of prepared animal feeds",
    },
    {
      value: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials",
      label: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials",
    },
    {
      value: "[11020]Manufacture of wines",
      label: "[11020]Manufacture of wines",
    },
    {
      value: "[11030]Manufacture of malt liquors and malt",
      label: "[11030]Manufacture of malt liquors and malt",
    },
    {
      value: "[11041]Manufacture of soft drinks and mineral waters",
      label: "[11041]Manufacture of soft drinks and mineral waters",
    },
    {
      value: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages",
      label: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages",
    },
    {
      value: "[11043]Manufacture of ice (except dry ice)",
      label: "[11043]Manufacture of ice (except dry ice)",
    },
    {
      value: "[12001]Manufacture of cigarettes",
      label: "[12001]Manufacture of cigarettes",
    },
    {
      value: "[12009]Manufacture of tobacco products n.e.c.",
      label: "[12009]Manufacture of tobacco products n.e.c.",
    },
    {
      value: "[13100]Spinning, weaving and finishing of textiles",
      label: "[13100]Spinning, weaving and finishing of textiles",
    },
    {
      value: "[13910]Manufacture of knitted and crocheted fabrics and laces",
      label: "[13910]Manufacture of knitted and crocheted fabrics and laces",
    },
    {
      value: "[13921]Manufacture of made-up household textile articles",
      label: "[13921]Manufacture of made-up household textile articles",
    },
    {
      value: "[13929]Manufacture of made-up textile articles n.e.c  (except apparel)",
      label: "[13929]Manufacture of made-up textile articles n.e.c  (except apparel)",
    },
    {
      value: "[13930]Manufacture of carpets and rugs",
      label: "[13930]Manufacture of carpets and rugs",
    },
    {
      value: "[13940]Manufacture of cordage, rope, twine and netting",
      label: "[13940]Manufacture of cordage, rope, twine and netting",
    },
    {
      value: "[13990]Manufacture of other textiles n.e.c.",
      label: "[13990]Manufacture of other textiles n.e.c.",
    },
    {
      value: "[14101]Manufacture of outer garments",
      label: "[14101]Manufacture of outer garments",
    },
    {
      value: "[14102]Manufacture of brassieres and other undergarments",
      label: "[14102]Manufacture of brassieres and other undergarments",
    },
    {
      value: "[14103]Tailoring and dressmaking to individual order",
      label: "[14103]Tailoring and dressmaking to individual order",
    },
    {
      value: "[14109]Manufacture of wearing apparel n.e.c. (except fur apparel)",
      label: "[14109]Manufacture of wearing apparel n.e.c. (except fur apparel)",
    },
    {
      value: "[14200]Manufacture of fur apparel and articles of fur",
      label: "[14200]Manufacture of fur apparel and articles of fur",
    },
    {
      value: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
      label: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
    },
    {
      value: "[15121]Manufacture of luggage, bags, brief cases and the like",
      label: "[15121]Manufacture of luggage, bags, brief cases and the like",
    },
    {
      value: "[15122]Manufacture of handbags",
      label: "[15122]Manufacture of handbags",
    },
    {
      value: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c.",
      label: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c.",
    },
    {
      value: "[15200]Manufacture of footwear",
      label: "[15200]Manufacture of footwear",
    },
    {
      value: "[16101]Sawmilling",
      label: "[16101]Sawmilling",
    },
    {
      value: "[16102]Preservation of wood",
      label: "[16102]Preservation of wood",
    },
    {
      value: "[16109]Sawmilling and planing of wood n.e.c.",
      label: "[16109]Sawmilling and planing of wood n.e.c.",
    },
    {
      value: "[16211]Manufacture of plywood and veneer",
      label: "[16211]Manufacture of plywood and veneer",
    },
    {
      value: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c.",
      label: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c.",
    },
    {
      value: "[16291]Manufacture of wooden window, door and other millwork (except prefabricated wooden building structures)",
      label: "[16291]Manufacture of wooden window, door and other millwork (except prefabricated wooden building structures)",
    },
    {
      value: "[16292]Manufacture of household and kitchen wooden ware (except wooden footwear)",
      label: "[16292]Manufacture of household and kitchen wooden ware (except wooden footwear)",
    },
    {
      value: "[16293]Manufacture of wooden containers",
      label: "[16293]Manufacture of wooden containers",
    },
    {
      value: "[16294]Rattan processing",
      label: "[16294]Rattan processing",
    },
    {
      value: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c.",
      label: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c.",
    },
    {
      value: "[17010]Manufacture of pulp, paper and paperboard",
      label: "[17010]Manufacture of pulp, paper and paperboard",
    },
    {
      value: "[17021]Manufacture of corrugated paper and paperboard",
      label: "[17021]Manufacture of corrugated paper and paperboard",
    },
    {
      value: "[17022]Manufacture of containers and boxes of paper and paperboard",
      label: "[17022]Manufacture of containers and boxes of paper and paperboard",
    },
    {
      value: "[17091]Manufacture of joss paper and other related ceremonial paper products",
      label: "[17091]Manufacture of joss paper and other related ceremonial paper products",
    },
    {
      value: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products",
      label: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products",
    },
    {
      value: "[17093]Manufacture of paper cups, plates and utensils",
      label: "[17093]Manufacture of paper cups, plates and utensils",
    },
    {
      value: "[17094]Manufacture of unprinted cards, envelopes and stationery",
      label: "[17094]Manufacture of unprinted cards, envelopes and stationery",
    },
    {
      value: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
      label: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
    },
    {
      value: "[18111]Printing of periodicals, books and magazines",
      label: "[18111]Printing of periodicals, books and magazines",
    },
    {
      value: "[18112]Commercial printing",
      label: "[18112]Commercial printing",
    },
    {
      value: "[18113]Silk screen/metal printing",
      label: "[18113]Silk screen/metal printing",
    },
    {
      value: "[18121]Bookbinding",
      label: "[18121]Bookbinding",
    },
    {
      value: "[18122]Colour separation",
      label: "[18122]Colour separation",
    },
    {
      value: "[18129]Service activities related to printing n.e.c.",
      label: "[18129]Service activities related to printing n.e.c.",
    },
    {
      value: "[18200]Reproduction of recorded media/phonograph records/magnetic tapes/compact discs/non-customised software",
      label: "[18200]Reproduction of recorded media/phonograph records/magnetic tapes/compact discs/non-customised software",
    },
    {
      value: "[19100]Manufacture of coke oven products",
      label: "[19100]Manufacture of coke oven products",
    },
    {
      value: "[19201]Petroleum refineries",
      label: "[19201]Petroleum refineries",
    },
    {
      value: "[19202]Manufacture of petroleum lubricating oil",
      label: "[19202]Manufacture of petroleum lubricating oil",
    },
    {
      value: "[19209]Manufacture of refined petroleum products n.e.c.",
      label: "[19209]Manufacture of refined petroleum products n.e.c.",
    },
    {
      value: "[20111]Manufacture of industrial gases and dry ice",
      label: "[20111]Manufacture of industrial gases and dry ice",
    },
    {
      value: "[20112]Manufacture of basic industrial acids and alkalis",
      label: "[20112]Manufacture of basic industrial acids and alkalis",
    },
    {
      value: "[20113]Manufacture of basic chemicals (except fertilisers and nitrogen)",
      label: "[20113]Manufacture of basic chemicals (except fertilisers and nitrogen)",
    },
    {
      value: "[20114]Manufacture of solvents",
      label: "[20114]Manufacture of solvents",
    },
    {
      value: "[20119]Manufacture of basic chemicals n.e.c.",
      label: "[20119]Manufacture of basic chemicals n.e.c.",
    },
    {
      value: "[20120]Manufacture of fertilisers and nitrogen compounds",
      label: "[20120]Manufacture of fertilisers and nitrogen compounds",
    },
    {
      value: "[20131]Manufacture of petrochemical primary products",
      label: "[20131]Manufacture of petrochemical primary products",
    },
    {
      value: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks",
      label: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks",
    },
    {
      value: "[20133]Manufacture of synthetic rubber",
      label: "[20133]Manufacture of synthetic rubber",
    },
    {
      value: "[20210]Manufacture of pesticides and other agro-chemical products",
      label: "[20210]Manufacture of pesticides and other agro-chemical products",
    },
    {
      value: "[20221]Manufacture of paints",
      label: "[20221]Manufacture of paints",
    },
    {
      value: "[20222]Manufacture of varnishes and lacquers",
      label: "[20222]Manufacture of varnishes and lacquers",
    },
    {
      value: "[20223]Manufacture of printing ink, prepared pigments and dyes",
      label: "[20223]Manufacture of printing ink, prepared pigments and dyes",
    },
    {
      value: "[20229]Manufacture of paints, varnishes and similar coatings, printing ink and mastics n.e.c.",
      label: "[20229]Manufacture of paints, varnishes and similar coatings, printing ink and mastics n.e.c.",
    },
    {
      value: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations",
      label: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations",
    },
    {
      value: "[20232]Manufacture of perfumes and fragrances",
      label: "[20232]Manufacture of perfumes and fragrances",
    },
    {
      value: "[20233]Manufacture of cosmetics and toiletries",
      label: "[20233]Manufacture of cosmetics and toiletries",
    },
    {
      value: "[20234]Manufacture of waxes and polishes and deodorising preparations",
      label: "[20234]Manufacture of waxes and polishes and deodorising preparations",
    },
    {
      value: "[20241]Manufacture of food chemicals and additives",
      label: "[20241]Manufacture of food chemicals and additives",
    },
    {
      value: "[20242]Manufacture of additives for mineral oil",
      label: "[20242]Manufacture of additives for mineral oil",
    },
    {
      value: "[20249]Manufacture of additives n.e.c.",
      label: "[20249]Manufacture of additives n.e.c.",
    },
    {
      value: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds",
      label: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds",
    },
    {
      value: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates",
      label: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates",
    },
    {
      value: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals",
      label: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals",
    },
    {
      value: "[20294]Manufacture of writing and drawing inks",
      label: "[20294]Manufacture of writing and drawing inks",
    },
    {
      value: "[20295]Manufacture of photographic film, paper, plate and chemicals",
      label: "[20295]Manufacture of photographic film, paper, plate and chemicals",
    },
    {
      value: "[20296]Manufacture of adhesives and sealants",
      label: "[20296]Manufacture of adhesives and sealants",
    },
    {
      value: "[20297]Manufacture of catalysts and catalyst regeneration",
      label: "[20297]Manufacture of catalysts and catalyst regeneration",
    },
    {
      value: "[20298]Manufacture of biofuels",
      label: "[20298]Manufacture of biofuels",
    },
    {
      value: "[20299]Manufacture of other chemical products n.e.c.",
      label: "[20299]Manufacture of other chemical products n.e.c.",
    },
    {
      value: "[20300]Manufacture of man-made fibres (except glass)",
      label: "[20300]Manufacture of man-made fibres (except glass)",
    },
    {
      value: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use",
      label: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use",
    },
    {
      value: "[21012]Manufacture of pharmaceutical products and preparations for human use",
      label: "[21012]Manufacture of pharmaceutical products and preparations for human use",
    },
    {
      value: "[21013]Manufacture of pharmaceutical products for veterinary use",
      label: "[21013]Manufacture of pharmaceutical products for veterinary use",
    },
    {
      value: "[21021]Manufacture of vaccines for human use",
      label: "[21021]Manufacture of vaccines for human use",
    },
    {
      value: "[21022]Manufacture of other biological products and preparations for human use",
      label: "[21022]Manufacture of other biological products and preparations for human use",
    },
    {
      value: "[21023]Manufacture of biological products and preparations for veterinary use",
      label: "[21023]Manufacture of biological products and preparations for veterinary use",
    },
    {
      value: "[21030]Manufacture of Traditional Chinese Medicine",
      label: "[21030]Manufacture of Traditional Chinese Medicine",
    },
    {
      value: "[22111]Processing, grading and packing of rubber; processing of rubber latex",
      label: "[22111]Processing, grading and packing of rubber; processing of rubber latex",
    },
    {
      value: "[22119]Processing of natural gums n.e.c.",
      label: "[22119]Processing of natural gums n.e.c.",
    },
    {
      value: "[22121]Manufacture of tyres and tubes",
      label: "[22121]Manufacture of tyres and tubes",
    },
    {
      value: "[22122]Retreading and vulcanising of tyres",
      label: "[22122]Retreading and vulcanising of tyres",
    },
    {
      value: "[22191]Manufacture of foam rubber products (except foam rubber mattresses)",
      label: "[22191]Manufacture of foam rubber products (except foam rubber mattresses)",
    },
    {
      value: "[22192]Manufacture of rubber automotive parts",
      label: "[22192]Manufacture of rubber automotive parts",
    },
    {
      value: "[22193]Manufacture of industrial and mechanical rubber goods",
      label: "[22193]Manufacture of industrial and mechanical rubber goods",
    },
    {
      value: "[22194]Manufacture of rubber floorings",
      label: "[22194]Manufacture of rubber floorings",
    },
    {
      value: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys)",
      label: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys)",
    },
    {
      value: "[22211]Manufacture of plastic tableware, household and kitchen ware (except disposable utensils)",
      label: "[22211]Manufacture of plastic tableware, household and kitchen ware (except disposable utensils)",
    },
    {
      value: "[22212]Manufacture of styrofoam and plastic disposable utensils",
      label: "[22212]Manufacture of styrofoam and plastic disposable utensils",
    },
    {
      value: "[22213]Manufacture of plastic sheet, film and articles thereof",
      label: "[22213]Manufacture of plastic sheet, film and articles thereof",
    },
    {
      value: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use)",
      label: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use)",
    },
    {
      value: "[22215]Manufacture of plastic pipes and tubes",
      label: "[22215]Manufacture of plastic pipes and tubes",
    },
    {
      value: "[22216]Manufacture of plastic precision engineering parts",
      label: "[22216]Manufacture of plastic precision engineering parts",
    },
    {
      value: "[22217]Manufacture of PVC files, holders and albums",
      label: "[22217]Manufacture of PVC files, holders and albums",
    },
    {
      value: "[22218]Manufacture of plastic cable ties",
      label: "[22218]Manufacture of plastic cable ties",
    },
    {
      value: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys)",
      label: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys)",
    },
    {
      value: "[22220]Plastic product services",
      label: "[22220]Plastic product services",
    },
    {
      value: "[23100]Manufacture of glass and glass products",
      label: "[23100]Manufacture of glass and glass products",
    },
    {
      value: "[23910]Manufacture of clay products",
      label: "[23910]Manufacture of clay products",
    },
    {
      value: "[23930]Manufacture of other porcelain and ceramic products",
      label: "[23930]Manufacture of other porcelain and ceramic products",
    },
    {
      value: "[23940]Manufacture of cement, lime and plaster",
      label: "[23940]Manufacture of cement, lime and plaster",
    },
    {
      value: "[23951]Manufacture of ready-mix concrete",
      label: "[23951]Manufacture of ready-mix concrete",
    },
    {
      value: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components)",
      label: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components)",
    },
    {
      value: "[23960]Cutting, shaping and finishing of stone",
      label: "[23960]Cutting, shaping and finishing of stone",
    },
    {
      value: "[23991]Manufacture of fibreglass and fibreglass products",
      label: "[23991]Manufacture of fibreglass and fibreglass products",
    },
    {
      value: "[23992]Manufacture of other insulation products",
      label: "[23992]Manufacture of other insulation products",
    },
    {
      value: "[23993]Manufacture of non-structural pre-cast components",
      label: "[23993]Manufacture of non-structural pre-cast components",
    },
    {
      value: "[23994]Manufacture of asphalt premix",
      label: "[23994]Manufacture of asphalt premix",
    },
    {
      value: "[23999]Manufacture of other non-metallic mineral products n.e.c.",
      label: "[23999]Manufacture of other non-metallic mineral products n.e.c.",
    },
    {
      value: "[24101]Iron and steel rolling mills",
      label: "[24101]Iron and steel rolling mills",
    },
    {
      value: "[24102]Manufacture of ferrous metal alloys",
      label: "[24102]Manufacture of ferrous metal alloys",
    },
    {
      value: "[24109]Manufacture of basic iron and steel n.e.c.",
      label: "[24109]Manufacture of basic iron and steel n.e.c.",
    },
    {
      value: "[24201]Manufacture of non-ferrous metal alloys",
      label: "[24201]Manufacture of non-ferrous metal alloys",
    },
    {
      value: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c.",
      label: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c.",
    },
    {
      value: "[24310]Iron and steel foundries",
      label: "[24310]Iron and steel foundries",
    },
    {
      value: "[24320]Non-ferrous metal foundries",
      label: "[24320]Non-ferrous metal foundries",
    },
    {
      value: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings",
      label: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings",
    },
    {
      value: "[25112]Manufacture of metal strips and slabs",
      label: "[25112]Manufacture of metal strips and slabs",
    },
    {
      value: "[25113]Manufacture of metal pipes and tubes",
      label: "[25113]Manufacture of metal pipes and tubes",
    },
    {
      value: "[25114]Manufacture of steel structural component",
      label: "[25114]Manufacture of steel structural component",
    },
    {
      value: "[25119]Manufacture of structural metal products n.e.c.",
      label: "[25119]Manufacture of structural metal products n.e.c.",
    },
    {
      value: "[25120]Manufacture/repair of tanks, reservoirs and containers of metal",
      label: "[25120]Manufacture/repair of tanks, reservoirs and containers of metal",
    },
    {
      value: "[25131]Manufacture/repair of heating boilers, radiators and correctors",
      label: "[25131]Manufacture/repair of heating boilers, radiators and correctors",
    },
    {
      value: "[25139]Manufacture/repair of steam generators n.e.c. (except central heating hot water boilers)",
      label: "[25139]Manufacture/repair of steam generators n.e.c. (except central heating hot water boilers)",
    },
    {
      value: "[25200]Manufacture/repair of weapons and ammunition",
      label: "[25200]Manufacture/repair of weapons and ammunition",
    },
    {
      value: "[25911]Iron and steel and non-ferrous forgings",
      label: "[25911]Iron and steel and non-ferrous forgings",
    },
    {
      value: "[25912]Manufacture of leadframe",
      label: "[25912]Manufacture of leadframe",
    },
    {
      value: "[25913]Metal stampings (except metal caps)",
      label: "[25913]Metal stampings (except metal caps)",
    },
    {
      value: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c.",
      label: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c.",
    },
    {
      value: "[25921]Electroplating and plating of metals and formed products",
      label: "[25921]Electroplating and plating of metals and formed products",
    },
    {
      value: "[25922]Polishing of metals and formed products",
      label: "[25922]Polishing of metals and formed products",
    },
    {
      value: "[25923]Rustproofing of metals and formed products",
      label: "[25923]Rustproofing of metals and formed products",
    },
    {
      value: "[25924]Heat treatment for metals",
      label: "[25924]Heat treatment for metals",
    },
    {
      value: "[25929]Metal product services n.e.c.",
      label: "[25929]Metal product services n.e.c.",
    },
    {
      value: "[25931]Manufacture of table, kitchen and other cutlery",
      label: "[25931]Manufacture of table, kitchen and other cutlery",
    },
    {
      value: "[25932]Manufacture of hand and edge tools",
      label: "[25932]Manufacture of hand and edge tools",
    },
    {
      value: "[25939]Manufacture of general hardware n.e.c.",
      label: "[25939]Manufacture of general hardware n.e.c.",
    },
    {
      value: "[25941]Manufacture of uninsulated wire",
      label: "[25941]Manufacture of uninsulated wire",
    },
    {
      value: "[25949]Manufacture of metal wire and cable products n.e.c.",
      label: "[25949]Manufacture of metal wire and cable products n.e.c.",
    },
    {
      value: "[25951]Manufacture of tinplate cans",
      label: "[25951]Manufacture of tinplate cans",
    },
    {
      value: "[25952]Manufacture of other tinplate and zinc articles",
      label: "[25952]Manufacture of other tinplate and zinc articles",
    },
    {
      value: "[25959]Manufacture of metal cans, containers and related products n.e.c.",
      label: "[25959]Manufacture of metal cans, containers and related products n.e.c.",
    },
    {
      value: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass",
      label: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass",
    },
    {
      value: "[25992]Manufacture of plumbing, heating and related products (except electric)",
      label: "[25992]Manufacture of plumbing, heating and related products (except electric)",
    },
    {
      value: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products",
      label: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products",
    },
    {
      value: "[25994]Manufacture of pipe fittings",
      label: "[25994]Manufacture of pipe fittings",
    },
    {
      value: "[25995]Manufacture of springs",
      label: "[25995]Manufacture of springs",
    },
    {
      value: "[25996]Manufacture of kitchen and household utensils",
      label: "[25996]Manufacture of kitchen and household utensils",
    },
    {
      value: "[25997]Manufacture of metal precision components",
      label: "[25997]Manufacture of metal precision components",
    },
    {
      value: "[25998]Slitting, shearing and pasting of metal sheeting",
      label: "[25998]Slitting, shearing and pasting of metal sheeting",
    },
    {
      value: "[25999]Manufacture of other fabricated metal products n.e.c.",
      label: "[25999]Manufacture of other fabricated metal products n.e.c.",
    },
    {
      value: "[26111]Manufacture of discrete devices",
      label: "[26111]Manufacture of discrete devices",
    },
    {
      value: "[26112]Semiconductor wafer fabrication",
      label: "[26112]Semiconductor wafer fabrication",
    },
    {
      value: "[26113]Assembly and testing of semiconductors",
      label: "[26113]Assembly and testing of semiconductors",
    },
    {
      value: "[26114]Manufacture of solar wafers",
      label: "[26114]Manufacture of solar wafers",
    },
    {
      value: "[26115]Manufacture of solar cells",
      label: "[26115]Manufacture of solar cells",
    },
    {
      value: "[26119]Manufacture of semiconductor devices n.e.c.",
      label: "[26119]Manufacture of semiconductor devices n.e.c.",
    },
    {
      value: "[26121]Manufacture of capacitors",
      label: "[26121]Manufacture of capacitors",
    },
    {
      value: "[26122]Manufacture of printed circuit boards without electronic parts",
      label: "[26122]Manufacture of printed circuit boards without electronic parts",
    },
    {
      value: "[26123]Manufacture of printed circuit boards with electronic parts",
      label: "[26123]Manufacture of printed circuit boards with electronic parts",
    },
    {
      value: "[26124]Manufacture of piezo-electric devices",
      label: "[26124]Manufacture of piezo-electric devices",
    },
    {
      value: "[26125]Manufacture of electronic display devices (except light emitting diodes)",
      label: "[26125]Manufacture of electronic display devices (except light emitting diodes)",
    },
    {
      value: "[26126]Manufacture of electronic connectors",
      label: "[26126]Manufacture of electronic connectors",
    },
    {
      value: "[26129]Manufacture of other electronic components and boards n.e.c.",
      label: "[26129]Manufacture of other electronic components and boards n.e.c.",
    },
    {
      value: "[26201]Manufacture of computers and data processing equipment (except computer peripheral equipment)",
      label: "[26201]Manufacture of computers and data processing equipment (except computer peripheral equipment)",
    },
    {
      value: "[26202]Manufacture of disk drives",
      label: "[26202]Manufacture of disk drives",
    },
    {
      value: "[26203]Manufacture of printers",
      label: "[26203]Manufacture of printers",
    },
    {
      value: "[26204]Manufacture of smart cards and related products",
      label: "[26204]Manufacture of smart cards and related products",
    },
    {
      value: "[26209]Manufacture of computers and peripheral equipment n.e.c.",
      label: "[26209]Manufacture of computers and peripheral equipment n.e.c.",
    },
    {
      value: "[26301]Manufacture of telecommunications apparatus",
      label: "[26301]Manufacture of telecommunications apparatus",
    },
    {
      value: "[26302]Manufacture of networking products",
      label: "[26302]Manufacture of networking products",
    },
    {
      value: "[26303]Manufacture of wireless communications equipment",
      label: "[26303]Manufacture of wireless communications equipment",
    },
    {
      value: "[26304]Manufacture of electronic security systems",
      label: "[26304]Manufacture of electronic security systems",
    },
    {
      value: "[26309]Manufacture of communications equipment n.e.c.",
      label: "[26309]Manufacture of communications equipment n.e.c.",
    },
    {
      value: "[26400]Manufacture of consumer electronics",
      label: "[26400]Manufacture of consumer electronics",
    },
    {
      value: "[26511]Manufacture/repair of engineering and scientific instruments",
      label: "[26511]Manufacture/repair of engineering and scientific instruments",
    },
    {
      value: "[26512]Manufacture/repair of measuring devices",
      label: "[26512]Manufacture/repair of measuring devices",
    },
    {
      value: "[26513]Manufacture/repair of process control equipment and related products",
      label: "[26513]Manufacture/repair of process control equipment and related products",
    },
    {
      value: "[26520]Manufacture of watches and clocks",
      label: "[26520]Manufacture of watches and clocks",
    },
    {
      value: "[26601]Manufacture/repair of electrotherapeutic devices",
      label: "[26601]Manufacture/repair of electrotherapeutic devices",
    },
    {
      value: "[26602]Manufacture/repair of irradiation and electromedical equipment and instruments",
      label: "[26602]Manufacture/repair of irradiation and electromedical equipment and instruments",
    },
    {
      value: "[26701]Manufacture of photographic equipment and parts",
      label: "[26701]Manufacture of photographic equipment and parts",
    },
    {
      value: "[26709]Manufacture of optical instruments and photographic equipment n.e.c.",
      label: "[26709]Manufacture of optical instruments and photographic equipment n.e.c.",
    },
    {
      value: "[26801]Manufacture of disk media",
      label: "[26801]Manufacture of disk media",
    },
    {
      value: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs",
      label: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs",
    },
    {
      value: "[27101]Manufacture/repair of electric motors",
      label: "[27101]Manufacture/repair of electric motors",
    },
    {
      value: "[27102]Manufacture/repair of electric generators",
      label: "[27102]Manufacture/repair of electric generators",
    },
    {
      value: "[27103]Manufacture/repair of transformers",
      label: "[27103]Manufacture/repair of transformers",
    },
    {
      value: "[27104]Manufacture/repair of switchgear and switchboard apparatus",
      label: "[27104]Manufacture/repair of switchgear and switchboard apparatus",
    },
    {
      value: "[27109]Manufacture/repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c.",
      label: "[27109]Manufacture/repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c.",
    },
    {
      value: "[27201]Manufacture of primary batteries",
      label: "[27201]Manufacture of primary batteries",
    },
    {
      value: "[27202]Manufacture of secondary batteries",
      label: "[27202]Manufacture of secondary batteries",
    },
    {
      value: "[27321]Manufacture of telecommunications cables and wires",
      label: "[27321]Manufacture of telecommunications cables and wires",
    },
    {
      value: "[27322]Manufacture of electric power cables and wires",
      label: "[27322]Manufacture of electric power cables and wires",
    },
    {
      value: "[27323]Manufacture of wire and cable assemblies and harnesses",
      label: "[27323]Manufacture of wire and cable assemblies and harnesses",
    },
    {
      value: "[27329]Manufacture of electronic and electric wires and cables n.e.c.",
      label: "[27329]Manufacture of electronic and electric wires and cables n.e.c.",
    },
    {
      value: "[27330]Manufacture/repair of wiring devices",
      label: "[27330]Manufacture/repair of wiring devices",
    },
    {
      value: "[27400]Manufacture/repair of electric lamps and lighting equipment",
      label: "[27400]Manufacture/repair of electric lamps and lighting equipment",
    },
    {
      value: "[27501]Manufacture of electrical household appliances",
      label: "[27501]Manufacture of electrical household appliances",
    },
    {
      value: "[27509]Manufacture of domestic appliances n.e.c.",
      label: "[27509]Manufacture of domestic appliances n.e.c.",
    },
    {
      value: "[27900]Manufacture of other electrical equipment, apparatus, appliances and supplies",
      label: "[27900]Manufacture of other electrical equipment, apparatus, appliances and supplies",
    },
    {
      value: "[28111]Manufacture/repair of engines and turbines (except aircraft, vehicle, cycle and marine engines)",
      label: "[28111]Manufacture/repair of engines and turbines (except aircraft, vehicle, cycle and marine engines)",
    },
    {
      value: "[28112]Manufacture/repair of marine engine",
      label: "[28112]Manufacture/repair of marine engine",
    },
    {
      value: "[28121]Manufacture/repair of pumps",
      label: "[28121]Manufacture/repair of pumps",
    },
    {
      value: "[28122]Manufacture/repair of taps, cocks and valves",
      label: "[28122]Manufacture/repair of taps, cocks and valves",
    },
    {
      value: "[28129]Manufacture/repair of pumps, compressors, taps and valves n.e.c.",
      label: "[28129]Manufacture/repair of pumps, compressors, taps and valves n.e.c.",
    },
    {
      value: "[28141]Manufacture of bearings",
      label: "[28141]Manufacture of bearings",
    },
    {
      value: "[28142]Manufacture/repair of gears, gearing and driving elements",
      label: "[28142]Manufacture/repair of gears, gearing and driving elements",
    },
    {
      value: "[28150]Manufacture/repair of ovens, furnaces and furnace burners",
      label: "[28150]Manufacture/repair of ovens, furnaces and furnace burners",
    },
    {
      value: "[28161]Manufacture/repair of lifting and hoisting machinery (except electrical)",
      label: "[28161]Manufacture/repair of lifting and hoisting machinery (except electrical)",
    },
    {
      value: "[28162]Manufacture/repair of lifts and escalators",
      label: "[28162]Manufacture/repair of lifts and escalators",
    },
    {
      value: "[28169]Manufacture/repair of lifting and handling equipment n.e.c.",
      label: "[28169]Manufacture/repair of lifting and handling equipment n.e.c.",
    },
    {
      value: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
      label: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
    },
    {
      value: "[28172]Repair and maintenance of office machinery and equipment",
      label: "[28172]Repair and maintenance of office machinery and equipment",
    },
    {
      value: "[28181]Manufacture/repair of industrial robots",
      label: "[28181]Manufacture/repair of industrial robots",
    },
    {
      value: "[28182]Manufacture/repair of service robots",
      label: "[28182]Manufacture/repair of service robots",
    },
    {
      value: "[28189]Manufacture/repair of robots n.e.c.",
      label: "[28189]Manufacture/repair of robots n.e.c.",
    },
    {
      value: "[28191]Manufacture/repair of refrigerating, air-conditioning and ventilating machinery and equipment (except household refrigerators)",
      label: "[28191]Manufacture/repair of refrigerating, air-conditioning and ventilating machinery and equipment (except household refrigerators)",
    },
    {
      value: "[28192]Manufacture/repair of separation/mixing equipment",
      label: "[28192]Manufacture/repair of separation/mixing equipment",
    },
    {
      value: "[28193]Manufacture/repair of solar modules and panels",
      label: "[28193]Manufacture/repair of solar modules and panels",
    },
    {
      value: "[28194]Manufacture/repair of welding and soldering equipment",
      label: "[28194]Manufacture/repair of welding and soldering equipment",
    },
    {
      value: "[28195]Manufacture/repair of packaging machinery",
      label: "[28195]Manufacture/repair of packaging machinery",
    },
    {
      value: "[28199]Manufacture/repair of other general purpose machinery and equipment n.e.c. (except electrical and electronic)",
      label: "[28199]Manufacture/repair of other general purpose machinery and equipment n.e.c. (except electrical and electronic)",
    },
    {
      value: "[28210]Manufacture/repair of agricultural and forestry machinery",
      label: "[28210]Manufacture/repair of agricultural and forestry machinery",
    },
    {
      value: "[28221]Manufacture/repair of machinery and machine-tools - metal cutting types",
      label: "[28221]Manufacture/repair of machinery and machine-tools - metal cutting types",
    },
    {
      value: "[28222]Manufacture/repair of machinery and machine-tools - metal forming types",
      label: "[28222]Manufacture/repair of machinery and machine-tools - metal forming types",
    },
    {
      value: "[28223]Manufacture/repair of dies, moulds, tools, jigs and fixtures",
      label: "[28223]Manufacture/repair of dies, moulds, tools, jigs and fixtures",
    },
    {
      value: "[28224]Manufacture/repair of machine tool accessories",
      label: "[28224]Manufacture/repair of machine tool accessories",
    },
    {
      value: "[28229]Manufacture/repair of metal-forming machinery and machine tools n.e.c.",
      label: "[28229]Manufacture/repair of metal-forming machinery and machine tools n.e.c.",
    },
    {
      value: "[28241]Manufacture/repair of oil rigs",
      label: "[28241]Manufacture/repair of oil rigs",
    },
    {
      value: "[28242]Manufacture/repair of other oilfield and gasfield machinery and equipment",
      label: "[28242]Manufacture/repair of other oilfield and gasfield machinery and equipment",
    },
    {
      value: "[28243]Manufacture/repair of construction machinery and parts",
      label: "[28243]Manufacture/repair of construction machinery and parts",
    },
    {
      value: "[28249]Manufacture/repair of machinery for mining, quarrying and construction n.e.c.",
      label: "[28249]Manufacture/repair of machinery for mining, quarrying and construction n.e.c.",
    },
    {
      value: "[28251]Manufacture/repair of machinery for food products processing",
      label: "[28251]Manufacture/repair of machinery for food products processing",
    },
    {
      value: "[28252]Manufacture/repair of machinery for beverage production",
      label: "[28252]Manufacture/repair of machinery for beverage production",
    },
    {
      value: "[28253]Manufacture/repair of machinery for tobacco processing",
      label: "[28253]Manufacture/repair of machinery for tobacco processing",
    },
    {
      value: "[28260]Manufacture/repair of machinery for textile, apparel and leather production",
      label: "[28260]Manufacture/repair of machinery for textile, apparel and leather production",
    },
    {
      value: "[28271]Manufacture of probe cards",
      label: "[28271]Manufacture of probe cards",
    },
    {
      value: "[28272]Manufacture of bonding tools",
      label: "[28272]Manufacture of bonding tools",
    },
    {
      value: "[28273]Manufacture/repair of semiconductor assembly and testing equipment",
      label: "[28273]Manufacture/repair of semiconductor assembly and testing equipment",
    },
    {
      value: "[28274]Manufacture/repair of semiconductor foundry equipment",
      label: "[28274]Manufacture/repair of semiconductor foundry equipment",
    },
    {
      value: "[28291]Manufacture/repair of water/waste water treatment equipment",
      label: "[28291]Manufacture/repair of water/waste water treatment equipment",
    },
    {
      value: "[28292]Manufacture/repair of plastic processing machinery",
      label: "[28292]Manufacture/repair of plastic processing machinery",
    },
    {
      value: "[28293]Manufacture/repair of additive manufacturing (AM) equipment",
      label: "[28293]Manufacture/repair of additive manufacturing (AM) equipment",
    },
    {
      value: "[28299]Manufacture/repair of other special purpose machinery n.e.c.",
      label: "[28299]Manufacture/repair of other special purpose machinery n.e.c.",
    },
    {
      value: "[28300]Installation of industrial machinery and equipment, mechanical engineering works",
      label: "[28300]Installation of industrial machinery and equipment, mechanical engineering works",
    },
    {
      value: "[29100]Manufacture and assembly of motor vehicles (except motorcycles and scooters)",
      label: "[29100]Manufacture and assembly of motor vehicles (except motorcycles and scooters)",
    },
    {
      value: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers",
      label: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers",
    },
    {
      value: "[29300]Manufacture of parts and accessories for motor vehicles",
      label: "[29300]Manufacture of parts and accessories for motor vehicles",
    },
    {
      value: "[30110]Building and repairing of ships, tankers, off-shore structures and other ocean-going vessels",
      label: "[30110]Building and repairing of ships, tankers, off-shore structures and other ocean-going vessels",
    },
    {
      value: "[30120]Building and repair of pleasure crafts, lighters and boats",
      label: "[30120]Building and repair of pleasure crafts, lighters and boats",
    },
    {
      value: "[30200]Manufacture/repair of railway and tramway locomotives and rolling stock",
      label: "[30200]Manufacture/repair of railway and tramway locomotives and rolling stock",
    },
    {
      value: "[30301]Manufacture and assembly of aircraft and spacecraft",
      label: "[30301]Manufacture and assembly of aircraft and spacecraft",
    },
    {
      value: "[30302]Repair and servicing of aircraft and spacecraft",
      label: "[30302]Repair and servicing of aircraft and spacecraft",
    },
    {
      value: "[30400]Manufacture/repair of military fighting vehicles",
      label: "[30400]Manufacture/repair of military fighting vehicles",
    },
    {
      value: "[30910]Manufacture and assembly of motorcycles and scooters",
      label: "[30910]Manufacture and assembly of motorcycles and scooters",
    },
    {
      value: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages",
      label: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages",
    },
    {
      value: "[30990]Manufacture/repair of other transport equipment n.e.c.",
      label: "[30990]Manufacture/repair of other transport equipment n.e.c.",
    },
    {
      value: "[31001]Manufacture of furniture and fixtures of wood",
      label: "[31001]Manufacture of furniture and fixtures of wood",
    },
    {
      value: "[31002]Manufacture of furniture of rattan and cane",
      label: "[31002]Manufacture of furniture of rattan and cane",
    },
    {
      value: "[31003]Manufacture of furniture and fixtures primarily of metal",
      label: "[31003]Manufacture of furniture and fixtures primarily of metal",
    },
    {
      value: "[31004]Manufacture of furniture of other materials (except primarily of stone, ceramic or concrete)",
      label: "[31004]Manufacture of furniture of other materials (except primarily of stone, ceramic or concrete)",
    },
    {
      value: "[31005]Manufacture of window and door screens and shades",
      label: "[31005]Manufacture of window and door screens and shades",
    },
    {
      value: "[31006]Manufacture of mattresses",
      label: "[31006]Manufacture of mattresses",
    },
    {
      value: "[31009]Manufacture of furniture n.e.c.",
      label: "[31009]Manufacture of furniture n.e.c.",
    },
    {
      value: "[32111]Manufacture of jewellery (except costume jewellery)",
      label: "[32111]Manufacture of jewellery (except costume jewellery)",
    },
    {
      value: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery)",
      label: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery)",
    },
    {
      value: "[32120]Manufacture of costume jewellery and related articles",
      label: "[32120]Manufacture of costume jewellery and related articles",
    },
    {
      value: "[32200]Manufacture of musical instruments",
      label: "[32200]Manufacture of musical instruments",
    },
    {
      value: "[32300]Manufacture of sporting and athletic goods",
      label: "[32300]Manufacture of sporting and athletic goods",
    },
    {
      value: "[32400]Manufacture of games and toys",
      label: "[32400]Manufacture of games and toys",
    },
    {
      value: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies",
      label: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies",
    },
    {
      value: "[32502]Manufacture of medical disposables and surgical supplies",
      label: "[32502]Manufacture of medical disposables and surgical supplies",
    },
    {
      value: "[32503]Manufacture of implantables and artificial limbs",
      label: "[32503]Manufacture of implantables and artificial limbs",
    },
    {
      value: "[32504]Manufacture of ophthalmic goods",
      label: "[32504]Manufacture of ophthalmic goods",
    },
    {
      value: "[32509]Manufacture of medical and dental instruments and supplies n.e.c.",
      label: "[32509]Manufacture of medical and dental instruments and supplies n.e.c.",
    },
    {
      value: "[32901]Manufacture of signs and advertising displays",
      label: "[32901]Manufacture of signs and advertising displays",
    },
    {
      value: "[32909]Other manufacturing industries n.e.c.",
      label: "[32909]Other manufacturing industries n.e.c.",
    },
    {
      value: "[35101]Generation of electricity from non-renewable sources",
      label: "[35101]Generation of electricity from non-renewable sources",
    },
    {
      value: "[35102]Generation of electricity from renewable sources",
      label: "[35102]Generation of electricity from renewable sources",
    },
    {
      value: "[35103]Transmission, distribution and sale of electricity",
      label: "[35103]Transmission, distribution and sale of electricity",
    },
    {
      value: "[35200]Manufacture of gas; distribution of gaseous fuels through mains; processing of natural gas",
      label: "[35200]Manufacture of gas; distribution of gaseous fuels through mains; processing of natural gas",
    },
    {
      value: "[35300]Supply of air or water for cooling or heating purposes",
      label: "[35300]Supply of air or water for cooling or heating purposes",
    },
    {
      value: "[35400]Activities of brokers and agents for electric power and natural gas",
      label: "[35400]Activities of brokers and agents for electric power and natural gas",
    },
    {
      value: "[36000]Collection, purification and distribution of water",
      label: "[36000]Collection, purification and distribution of water",
    },
    {
      value: "[37000]Operation of sewer systems",
      label: "[37000]Operation of sewer systems",
    },
    {
      value: "[38100]Collection of waste",
      label: "[38100]Collection of waste",
    },
    {
      value: "[38200]Treatment and disposal of waste",
      label: "[38200]Treatment and disposal of waste",
    },
    {
      value: "[38301]Recycling of metal waste and scrap",
      label: "[38301]Recycling of metal waste and scrap",
    },
    {
      value: "[38309]Recycling of non-metal waste n.e.c.",
      label: "[38309]Recycling of non-metal waste n.e.c.",
    },
    {
      value: "[39000]Carbon capture activities",
      label: "[39000]Carbon capture activities",
    },
    {
      value: "[41001]General contractors for building construction and major upgrading works",
      label: "[41001]General contractors for building construction and major upgrading works",
    },
    {
      value: "[41002]Structural repair contractors",
      label: "[41002]Structural repair contractors",
    },
    {
      value: "[41009]Construction of buildings n.e.c.",
      label: "[41009]Construction of buildings n.e.c.",
    },
    {
      value: "[42100]Civil engineering general contractors",
      label: "[42100]Civil engineering general contractors",
    },
    {
      value: "[42200]Road, railway and associated viaduct, bridge and tunnel construction",
      label: "[42200]Road, railway and associated viaduct, bridge and tunnel construction",
    },
    {
      value: "[42301]Water and gas pipe-line and sewer construction",
      label: "[42301]Water and gas pipe-line and sewer construction",
    },
    {
      value: "[42302]Communications and power line construction",
      label: "[42302]Communications and power line construction",
    },
    {
      value: "[42901]Land reclamation works",
      label: "[42901]Land reclamation works",
    },
    {
      value: "[42902]Dam and drainage construction",
      label: "[42902]Dam and drainage construction",
    },
    {
      value: "[42903]Marine construction",
      label: "[42903]Marine construction",
    },
    {
      value: "[42909]Construction of other civil engineering projects n.e.c.",
      label: "[42909]Construction of other civil engineering projects n.e.c.",
    },
    {
      value: "[43110]Wrecking and demolition works",
      label: "[43110]Wrecking and demolition works",
    },
    {
      value: "[43121]Soil investigation, treatment and stabilisation",
      label: "[43121]Soil investigation, treatment and stabilisation",
    },
    {
      value: "[43122]Excavation and earthmoving works",
      label: "[43122]Excavation and earthmoving works",
    },
    {
      value: "[43129]Site preparation n.e.c.",
      label: "[43129]Site preparation n.e.c.",
    },
    {
      value: "[43210]Electrical works",
      label: "[43210]Electrical works",
    },
    {
      value: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems",
      label: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems",
    },
    {
      value: "[43291]Installation and erection of building equipment",
      label: "[43291]Installation and erection of building equipment",
    },
    {
      value: "[43292]Installation of building automated systems for remote monitoring",
      label: "[43292]Installation of building automated systems for remote monitoring",
    },
    {
      value: "[43293]Installation of awning and window shades",
      label: "[43293]Installation of awning and window shades",
    },
    {
      value: "[43294]Installation of thermal and sound insulation",
      label: "[43294]Installation of thermal and sound insulation",
    },
    {
      value: "[43295]Signcraft installation",
      label: "[43295]Signcraft installation",
    },
    {
      value: "[43299]Other construction installation n.e.c.",
      label: "[43299]Other construction installation n.e.c.",
    },
    {
      value: "[43301]Renovation contractors",
      label: "[43301]Renovation contractors",
    },
    {
      value: "[43302]Tile setting and plastering",
      label: "[43302]Tile setting and plastering",
    },
    {
      value: "[43303]Joinery and other woodworks",
      label: "[43303]Joinery and other woodworks",
    },
    {
      value: "[43304]Painting and decorating",
      label: "[43304]Painting and decorating",
    },
    {
      value: "[43305]Glass and glazing works; mirror and shower screen installation",
      label: "[43305]Glass and glazing works; mirror and shower screen installation",
    },
    {
      value: "[43306]Curtain walling/cladding works",
      label: "[43306]Curtain walling/cladding works",
    },
    {
      value: "[43307]Installation of doors, gates, grilles and windows",
      label: "[43307]Installation of doors, gates, grilles and windows",
    },
    {
      value: "[43309]Building completion and finishing n.e.c.",
      label: "[43309]Building completion and finishing n.e.c.",
    },
    {
      value: "[43901]Foundation works; micropiling, conventional piling and underpinning",
      label: "[43901]Foundation works; micropiling, conventional piling and underpinning",
    },
    {
      value: "[43902]Brick laying, stone setting and cement works",
      label: "[43902]Brick laying, stone setting and cement works",
    },
    {
      value: "[43903]Roofing works; timber carcassing",
      label: "[43903]Roofing works; timber carcassing",
    },
    {
      value: "[43904]Production of pre-cast components",
      label: "[43904]Production of pre-cast components",
    },
    {
      value: "[43905]Scaffolding works",
      label: "[43905]Scaffolding works",
    },
    {
      value: "[43906]Sandblasting/shotblasting works (except ships)",
      label: "[43906]Sandblasting/shotblasting works (except ships)",
    },
    {
      value: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules",
      label: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules",
    },
    {
      value: "[43909]Other specialised construction activities n.e.c.",
      label: "[43909]Other specialised construction activities n.e.c.",
    },
    {
      value: "[46100]Wholesale on a fee or commission basis",
      label: "[46100]Wholesale on a fee or commission basis",
    },
    {
      value: "[46211]Wholesale of cut flowers and plants",
      label: "[46211]Wholesale of cut flowers and plants",
    },
    {
      value: "[46212]Wholesale of aquarium fishes and related accessories/products",
      label: "[46212]Wholesale of aquarium fishes and related accessories/products",
    },
    {
      value: "[46213]Wholesale of pet birds and animals and related accessories/products",
      label: "[46213]Wholesale of pet birds and animals and related accessories/products",
    },
    {
      value: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (except tropical produce)",
      label: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (except tropical produce)",
    },
    {
      value: "[46221]Wholesale of rubber",
      label: "[46221]Wholesale of rubber",
    },
    {
      value: "[46222]Wholesale of pepper and other spices",
      label: "[46222]Wholesale of pepper and other spices",
    },
    {
      value: "[46223]Wholesale of coffee, cocoa and tea",
      label: "[46223]Wholesale of coffee, cocoa and tea",
    },
    {
      value: "[46224]Wholesale of coconut",
      label: "[46224]Wholesale of coconut",
    },
    {
      value: "[46225]Wholesale of palm oil",
      label: "[46225]Wholesale of palm oil",
    },
    {
      value: "[46229]Wholesale of tropical produce n.e.c.",
      label: "[46229]Wholesale of tropical produce n.e.c.",
    },
    {
      value: "[46301]Wholesale of fruits and vegetables",
      label: "[46301]Wholesale of fruits and vegetables",
    },
    {
      value: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood",
      label: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood",
    },
    {
      value: "[46303]Wholesale of a general line of groceries",
      label: "[46303]Wholesale of a general line of groceries",
    },
    {
      value: "[46304]Wholesale of confectionery and bakery products",
      label: "[46304]Wholesale of confectionery and bakery products",
    },
    {
      value: "[46305]Wholesale of ice-cream",
      label: "[46305]Wholesale of ice-cream",
    },
    {
      value: "[46306]Wholesale of health supplements",
      label: "[46306]Wholesale of health supplements",
    },
    {
      value: "[46307]Wholesale of liquor, soft drinks and beverages",
      label: "[46307]Wholesale of liquor, soft drinks and beverages",
    },
    {
      value: "[46308]Wholesale of tobacco products",
      label: "[46308]Wholesale of tobacco products",
    },
    {
      value: "[46309]Wholesale of food, beverages and tobacco n.e.c.",
      label: "[46309]Wholesale of food, beverages and tobacco n.e.c.",
    },
    {
      value: "[46411]Wholesale of textiles and leathers",
      label: "[46411]Wholesale of textiles and leathers",
    },
    {
      value: "[46412]Wholesale of adults' clothing",
      label: "[46412]Wholesale of adults' clothing",
    },
    {
      value: "[46413]Wholesale of children and infants' clothing",
      label: "[46413]Wholesale of children and infants' clothing",
    },
    {
      value: "[46414]Wholesale of footwear",
      label: "[46414]Wholesale of footwear",
    },
    {
      value: "[46415]Wholesale of bags, luggage and travel accessories",
      label: "[46415]Wholesale of bags, luggage and travel accessories",
    },
    {
      value: "[46416]Wholesale of sewing and clothing accessories",
      label: "[46416]Wholesale of sewing and clothing accessories",
    },
    {
      value: "[46421]Wholesale of jewellery made from precious metals and stones",
      label: "[46421]Wholesale of jewellery made from precious metals and stones",
    },
    {
      value: "[46422]Wholesale of costume jewellery",
      label: "[46422]Wholesale of costume jewellery",
    },
    {
      value: "[46423]Wholesale of watches and clocks",
      label: "[46423]Wholesale of watches and clocks",
    },
    {
      value: "[46424]Wholesale of personal care products",
      label: "[46424]Wholesale of personal care products",
    },
    {
      value: "[46429]Wholesale of personal effects n.e.c.",
      label: "[46429]Wholesale of personal effects n.e.c.",
    },
    {
      value: "[46431]Wholesale of furniture",
      label: "[46431]Wholesale of furniture",
    },
    {
      value: "[46432]Wholesale of furnishings",
      label: "[46432]Wholesale of furnishings",
    },
    {
      value: "[46433]Wholesale of lighting and lighting accessories",
      label: "[46433]Wholesale of lighting and lighting accessories",
    },
    {
      value: "[46434]Wholesale of crockery, cutlery and kitchen utensils",
      label: "[46434]Wholesale of crockery, cutlery and kitchen utensils",
    },
    {
      value: "[46435]Wholesale of household electrical appliances and equipment",
      label: "[46435]Wholesale of household electrical appliances and equipment",
    },
    {
      value: "[46436]Wholesale of audio and video equipment (except electrical and electronic components)",
      label: "[46436]Wholesale of audio and video equipment (except electrical and electronic components)",
    },
    {
      value: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c.",
      label: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c.",
    },
    {
      value: "[46441]Wholesale of sporting goods and equipment",
      label: "[46441]Wholesale of sporting goods and equipment",
    },
    {
      value: "[46442]Wholesale of music and video recordings",
      label: "[46442]Wholesale of music and video recordings",
    },
    {
      value: "[46443]Wholesale of toys and games",
      label: "[46443]Wholesale of toys and games",
    },
    {
      value: "[46444]Wholesale of computer games",
      label: "[46444]Wholesale of computer games",
    },
    {
      value: "[46445]Wholesale of musical instruments and scores",
      label: "[46445]Wholesale of musical instruments and scores",
    },
    {
      value: "[46449]Wholesale of sporting and other recreational goods n.e.c.",
      label: "[46449]Wholesale of sporting and other recreational goods n.e.c.",
    },
    {
      value: "[46451]Wholesale of antiques and works of art",
      label: "[46451]Wholesale of antiques and works of art",
    },
    {
      value: "[46452]Wholesale of handicrafts and gifts",
      label: "[46452]Wholesale of handicrafts and gifts",
    },
    {
      value: "[46453]Wholesale of artificial flowers and plants",
      label: "[46453]Wholesale of artificial flowers and plants",
    },
    {
      value: "[46459]Wholesale of handicrafts and fancy goods n.e.c.",
      label: "[46459]Wholesale of handicrafts and fancy goods n.e.c.",
    },
    {
      value: "[46461]Wholesale of medicinal and pharmaceutical products (Western)",
      label: "[46461]Wholesale of medicinal and pharmaceutical products (Western)",
    },
    {
      value: "[46462]Wholesale of medicine and herbs (except Western)",
      label: "[46462]Wholesale of medicine and herbs (except Western)",
    },
    {
      value: "[46471]Wholesale of paper and paper products",
      label: "[46471]Wholesale of paper and paper products",
    },
    {
      value: "[46472]Wholesale of packaging materials",
      label: "[46472]Wholesale of packaging materials",
    },
    {
      value: "[46473]Wholesale of stationery",
      label: "[46473]Wholesale of stationery",
    },
    {
      value: "[46474]Wholesale of books and magazines",
      label: "[46474]Wholesale of books and magazines",
    },
    {
      value: "[46479]Wholesale of paper, paper-related products, stationery, cellophane products and packaging materials n.e.c.",
      label: "[46479]Wholesale of paper, paper-related products, stationery, cellophane products and packaging materials n.e.c.",
    },
    {
      value: "[46491]Wholesale of optical equipment and supplies (except binoculars)",
      label: "[46491]Wholesale of optical equipment and supplies (except binoculars)",
    },
    {
      value: "[46492]Wholesale of photographic equipment and supplies",
      label: "[46492]Wholesale of photographic equipment and supplies",
    },
    {
      value: "[46499]Wholesale of other household goods n.e.c.",
      label: "[46499]Wholesale of other household goods n.e.c.",
    },
    {
      value: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment)",
      label: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment)",
    },
    {
      value: "[46512]Wholesale of computer software (except games and cybersecurity software)",
      label: "[46512]Wholesale of computer software (except games and cybersecurity software)",
    },
    {
      value: "[46513]Wholesale of computer accessories",
      label: "[46513]Wholesale of computer accessories",
    },
    {
      value: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment",
      label: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment",
    },
    {
      value: "[46521]Wholesale of telecommunications equipment (except handphones)",
      label: "[46521]Wholesale of telecommunications equipment (except handphones)",
    },
    {
      value: "[46522]Wholesale of electronic components",
      label: "[46522]Wholesale of electronic components",
    },
    {
      value: "[46523]Wholesale of handphones and related telecommunications and peripheral equipment",
      label: "[46523]Wholesale of handphones and related telecommunications and peripheral equipment",
    },
    {
      value: "[46530]Wholesale of agricultural machinery, equipment and supplies",
      label: "[46530]Wholesale of agricultural machinery, equipment and supplies",
    },
    {
      value: "[46541]Wholesale of industrial machinery and equipment",
      label: "[46541]Wholesale of industrial machinery and equipment",
    },
    {
      value: "[46542]Wholesale of construction equipment",
      label: "[46542]Wholesale of construction equipment",
    },
    {
      value: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment",
      label: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment",
    },
    {
      value: "[46544]Wholesale of electrical and wiring accessories",
      label: "[46544]Wholesale of electrical and wiring accessories",
    },
    {
      value: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c.",
      label: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c.",
    },
    {
      value: "[46551]Wholesale of marine equipment and accessories",
      label: "[46551]Wholesale of marine equipment and accessories",
    },
    {
      value: "[46552]Wholesale of aircraft equipment and supplies",
      label: "[46552]Wholesale of aircraft equipment and supplies",
    },
    {
      value: "[46559]Wholesale of transport equipment n.e.c. (except motor vehicles and motorcycles)",
      label: "[46559]Wholesale of transport equipment n.e.c. (except motor vehicles and motorcycles)",
    },
    {
      value: "[46561]Wholesale of motor vehicles (except motorcycles and scooters)",
      label: "[46561]Wholesale of motor vehicles (except motorcycles and scooters)",
    },
    {
      value: "[46562]Wholesale of motorcycles and scooters",
      label: "[46562]Wholesale of motorcycles and scooters",
    },
    {
      value: "[46563]Wholesale of parts and accessories for motor vehicles",
      label: "[46563]Wholesale of parts and accessories for motor vehicles",
    },
    {
      value: "[46591]Wholesale of office machines and equipment",
      label: "[46591]Wholesale of office machines and equipment",
    },
    {
      value: "[46592]Wholesale of medical, professional, scientific and precision equipment",
      label: "[46592]Wholesale of medical, professional, scientific and precision equipment",
    },
    {
      value: "[46593]Wholesale of commercial food service equipment",
      label: "[46593]Wholesale of commercial food service equipment",
    },
    {
      value: "[46594]Wholesale of service establishment equipment and supplies",
      label: "[46594]Wholesale of service establishment equipment and supplies",
    },
    {
      value: "[46595]Wholesale of security and safety equipment",
      label: "[46595]Wholesale of security and safety equipment",
    },
    {
      value: "[46599]Wholesale of other machinery and equipment n.e.c.",
      label: "[46599]Wholesale of other machinery and equipment n.e.c.",
    },
    {
      value: "[46610]Wholesale of fuels and related products",
      label: "[46610]Wholesale of fuels and related products",
    },
    {
      value: "[46620]Wholesale of metals and metal ores (except general hardware)",
      label: "[46620]Wholesale of metals and metal ores (except general hardware)",
    },
    {
      value: "[46631]Wholesale of logs, sawn timber, plywood and related products",
      label: "[46631]Wholesale of logs, sawn timber, plywood and related products",
    },
    {
      value: "[46632]Wholesale of general hardware",
      label: "[46632]Wholesale of general hardware",
    },
    {
      value: "[46633]Wholesale of structural clay and concrete products",
      label: "[46633]Wholesale of structural clay and concrete products",
    },
    {
      value: "[46634]Wholesale of paints",
      label: "[46634]Wholesale of paints",
    },
    {
      value: "[46635]Wholesale of glass",
      label: "[46635]Wholesale of glass",
    },
    {
      value: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
      label: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
    },
    {
      value: "[46641]Wholesale of basic industrial chemicals (except fertilisers)",
      label: "[46641]Wholesale of basic industrial chemicals (except fertilisers)",
    },
    {
      value: "[46642]Wholesale of chemical fertilisers",
      label: "[46642]Wholesale of chemical fertilisers",
    },
    {
      value: "[46643]Wholesale of petrochemical products",
      label: "[46643]Wholesale of petrochemical products",
    },
    {
      value: "[46649]Wholesale of chemicals and chemical products n.e.c.",
      label: "[46649]Wholesale of chemicals and chemical products n.e.c.",
    },
    {
      value: "[46651]Wholesale of scrap, junk and waste dealers",
      label: "[46651]Wholesale of scrap, junk and waste dealers",
    },
    {
      value: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c.",
      label: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c.",
    },
    {
      value: "[46661]Ship chandlers",
      label: "[46661]Ship chandlers",
    },
    {
      value: "[46662]Ship bunkering",
      label: "[46662]Ship bunkering",
    },
    {
      value: "[46900]Wholesale trade of a variety of goods without a dominant product",
      label: "[46900]Wholesale trade of a variety of goods without a dominant product",
    },
    {
      value: "[47101]Supermarkets and hypermarkets",
      label: "[47101]Supermarkets and hypermarkets",
    },
    {
      value: "[47102]Mini-marts, convenience stores and provision shops",
      label: "[47102]Mini-marts, convenience stores and provision shops",
    },
    {
      value: "[47103]Department stores",
      label: "[47103]Department stores",
    },
    {
      value: "[47109]Retail sale in non-specialised stores n.e.c.",
      label: "[47109]Retail sale in non-specialised stores n.e.c.",
    },
    {
      value: "[47211]Retail sale of fruits and vegetables",
      label: "[47211]Retail sale of fruits and vegetables",
    },
    {
      value: "[47212]Retail sale of meat, poultry, eggs and seafood",
      label: "[47212]Retail sale of meat, poultry, eggs and seafood",
    },
    {
      value: "[47213]Retail sale of confectionery and bakery products (not manufactured on site)",
      label: "[47213]Retail sale of confectionery and bakery products (not manufactured on site)",
    },
    {
      value: "[47214]Retail sale of health supplements",
      label: "[47214]Retail sale of health supplements",
    },
    {
      value: "[47219]Retail sale of food n.e.c.",
      label: "[47219]Retail sale of food n.e.c.",
    },
    {
      value: "[47220]Retail sale of beverages",
      label: "[47220]Retail sale of beverages",
    },
    {
      value: "[47230]Retail sale of tobacco products",
      label: "[47230]Retail sale of tobacco products",
    },
    {
      value: "[47311]Retail sale of motor vehicles (except motorcycles and scooters)",
      label: "[47311]Retail sale of motor vehicles (except motorcycles and scooters)",
    },
    {
      value: "[47312]Retail sale of motorcycles and scooters",
      label: "[47312]Retail sale of motorcycles and scooters",
    },
    {
      value: "[47313]Retail sale of tyres and batteries for motor vehicles",
      label: "[47313]Retail sale of tyres and batteries for motor vehicles",
    },
    {
      value: "[47314]Retail sale of parts and accessories for motor vehicles",
      label: "[47314]Retail sale of parts and accessories for motor vehicles",
    },
    {
      value: "[47320]Retail sale of automotive fuel",
      label: "[47320]Retail sale of automotive fuel",
    },
    {
      value: "[47411]Retail sale of handphones and related telecommunications and peripheral equipment",
      label: "[47411]Retail sale of handphones and related telecommunications and peripheral equipment",
    },
    {
      value:
        "[47412]Retail sale of computer hardware and peripheral equipment, and computer software (except games and cybersecurity hardware and software)",
      label:
        "[47412]Retail sale of computer hardware and peripheral equipment, and computer software (except games and cybersecurity hardware and software)",
    },
    {
      value: "[47413]Retail sale of computer games",
      label: "[47413]Retail sale of computer games",
    },
    {
      value: "[47414]Retail sale of computer and office equipment consumables",
      label: "[47414]Retail sale of computer and office equipment consumables",
    },
    {
      value: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment",
      label: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment",
    },
    {
      value: "[47510]Retail sale of textiles",
      label: "[47510]Retail sale of textiles",
    },
    {
      value: "[47521]Retail sale of paints",
      label: "[47521]Retail sale of paints",
    },
    {
      value: "[47522]Retail sale of hardware",
      label: "[47522]Retail sale of hardware",
    },
    {
      value: "[47529]Retail sale of hardware, paint and glass n.e.c.",
      label: "[47529]Retail sale of hardware, paint and glass n.e.c.",
    },
    {
      value: "[47531]Retail sale of furniture",
      label: "[47531]Retail sale of furniture",
    },
    {
      value: "[47532]Retail sale of furnishings",
      label: "[47532]Retail sale of furnishings",
    },
    {
      value: "[47533]Retail sale of lighting and lighting accessories",
      label: "[47533]Retail sale of lighting and lighting accessories",
    },
    {
      value: "[47534]Retail sale of crockery, cutlery and kitchen utensils",
      label: "[47534]Retail sale of crockery, cutlery and kitchen utensils",
    },
    {
      value: "[47535]Retail sale of household electrical appliances and equipment",
      label: "[47535]Retail sale of household electrical appliances and equipment",
    },
    {
      value: "[47536]Retail sale of security and safety equipment",
      label: "[47536]Retail sale of security and safety equipment",
    },
    {
      value: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c.",
      label: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c.",
    },
    {
      value: "[47610]Retail sale of books, newspapers and stationery",
      label: "[47610]Retail sale of books, newspapers and stationery",
    },
    {
      value: "[47620]Retail sale of music and video recordings",
      label: "[47620]Retail sale of music and video recordings",
    },
    {
      value: "[47630]Retail sale of sports apparel and equipment",
      label: "[47630]Retail sale of sports apparel and equipment",
    },
    {
      value: "[47640]Retail sale of games and toys",
      label: "[47640]Retail sale of games and toys",
    },
    {
      value: "[47650]Retail sale of musical instruments and scores",
      label: "[47650]Retail sale of musical instruments and scores",
    },
    {
      value: "[47711]Retail sale of clothing for adults",
      label: "[47711]Retail sale of clothing for adults",
    },
    {
      value: "[47712]Retail sale of children and infants' clothing",
      label: "[47712]Retail sale of children and infants' clothing",
    },
    {
      value: "[47713]Retail sale of footwear",
      label: "[47713]Retail sale of footwear",
    },
    {
      value: "[47714]Retail sale of bags, luggage and travel accessories",
      label: "[47714]Retail sale of bags, luggage and travel accessories",
    },
    {
      value: "[47715]Retail sale of sewing and clothing accessories",
      label: "[47715]Retail sale of sewing and clothing accessories",
    },
    {
      value: "[47719]Retail sale of clothing, footwear and leather articles n.e.c.",
      label: "[47719]Retail sale of clothing, footwear and leather articles n.e.c.",
    },
    {
      value: "[47721]Retail sale of personal care products",
      label: "[47721]Retail sale of personal care products",
    },
    {
      value: "[47722]Pharmacies and drug stores (Western)",
      label: "[47722]Pharmacies and drug stores (Western)",
    },
    {
      value: "[47723]Chinese medicine shops",
      label: "[47723]Chinese medicine shops",
    },
    {
      value: "[47729]Retail sale of pharmaceutical and medical goods n.e.c.",
      label: "[47729]Retail sale of pharmaceutical and medical goods n.e.c.",
    },
    {
      value: "[47731]Retail sale of jewellery made from precious metals and stones",
      label: "[47731]Retail sale of jewellery made from precious metals and stones",
    },
    {
      value: "[47732]Retail sale of costume jewellery",
      label: "[47732]Retail sale of costume jewellery",
    },
    {
      value: "[47733]Retail sale of watches and clocks",
      label: "[47733]Retail sale of watches and clocks",
    },
    {
      value: "[47739]Retail sale of personal effects n.e.c.",
      label: "[47739]Retail sale of personal effects n.e.c.",
    },
    {
      value: "[47741]Retail sale of antiques and works of art",
      label: "[47741]Retail sale of antiques and works of art",
    },
    {
      value: "[47742]Retail sale of handicrafts, collectibles and gifts",
      label: "[47742]Retail sale of handicrafts, collectibles and gifts",
    },
    {
      value: "[47743]Retail sale of cut flowers",
      label: "[47743]Retail sale of cut flowers",
    },
    {
      value: "[47744]Retail sale of artificial flowers and plants",
      label: "[47744]Retail sale of artificial flowers and plants",
    },
    {
      value: "[47745]Retail sale of aquarium fishes and related accessories/products",
      label: "[47745]Retail sale of aquarium fishes and related accessories/products",
    },
    {
      value: "[47746]Retail sale of pet birds and animals and related accessories/products",
      label: "[47746]Retail sale of pet birds and animals and related accessories/products",
    },
    {
      value: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c.",
      label: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c.",
    },
    {
      value: "[47751]Retail sale of spectacles and other optical goods",
      label: "[47751]Retail sale of spectacles and other optical goods",
    },
    {
      value: "[47752]Retail sale of cameras and other photographic goods",
      label: "[47752]Retail sale of cameras and other photographic goods",
    },
    {
      value: "[47759]Retail sale of optical and photographic goods n.e.c.",
      label: "[47759]Retail sale of optical and photographic goods n.e.c.",
    },
    {
      value: "[47761]Retail sale of joss paper and other ceremonial products",
      label: "[47761]Retail sale of joss paper and other ceremonial products",
    },
    {
      value: "[47762]Retail sale of liquefied petroleum gas (LPG)",
      label: "[47762]Retail sale of liquefied petroleum gas (LPG)",
    },
    {
      value: "[47769]Retail sale of other goods n.e.c.",
      label: "[47769]Retail sale of other goods n.e.c.",
    },
    {
      value: "[47770]Retail sale of second-hand goods in stores",
      label: "[47770]Retail sale of second-hand goods in stores",
    },
    {
      value: "[47801]Stalls selling uncooked food",
      label: "[47801]Stalls selling uncooked food",
    },
    {
      value: "[47802]Stalls selling other goods (except uncooked food)",
      label: "[47802]Stalls selling other goods (except uncooked food)",
    },
    {
      value: "[49101]Railroad services",
      label: "[49101]Railroad services",
    },
    {
      value: "[49102]Mass rapid transit systems",
      label: "[49102]Mass rapid transit systems",
    },
    {
      value: "[49211]Public bus services (scheduled services)",
      label: "[49211]Public bus services (scheduled services)",
    },
    {
      value: "[49212]Chartered bus services",
      label: "[49212]Chartered bus services",
    },
    {
      value: "[49213]Inter-country bus services",
      label: "[49213]Inter-country bus services",
    },
    {
      value: "[49214]Street-hail and ride-hail service providers",
      label: "[49214]Street-hail and ride-hail service providers",
    },
    {
      value: "[49215]Rental and leasing of cars with driver (except street-hail and ride-hail service providers)",
      label: "[49215]Rental and leasing of cars with driver (except street-hail and ride-hail service providers)",
    },
    {
      value: "[49220]Aerial cableways",
      label: "[49220]Aerial cableways",
    },
    {
      value: "[49231]Freight transport by road",
      label: "[49231]Freight transport by road",
    },
    {
      value: "[49232]Moving services",
      label: "[49232]Moving services",
    },
    {
      value: "[49233]Rental and leasing of freight land transport vehicle with driver",
      label: "[49233]Rental and leasing of freight land transport vehicle with driver",
    },
    {
      value: "[49300]Transport via pipelines",
      label: "[49300]Transport via pipelines",
    },
    {
      value: "[50011]International cruise services",
      label: "[50011]International cruise services",
    },
    {
      value: "[50012]Other sight-seeing cruise services",
      label: "[50012]Other sight-seeing cruise services",
    },
    {
      value: "[50013]Passenger ferry services",
      label: "[50013]Passenger ferry services",
    },
    {
      value: "[50014]Chartering of ships and boats with crew (passenger)",
      label: "[50014]Chartering of ships and boats with crew (passenger)",
    },
    {
      value: "[50021]Shipping companies and chartering of ships/boats with crew (freight)",
      label: "[50021]Shipping companies and chartering of ships/boats with crew (freight)",
    },
    {
      value: "[50022]Operators and charterers of barges, tugboats and bumboats (freight)",
      label: "[50022]Operators and charterers of barges, tugboats and bumboats (freight)",
    },
    {
      value: "[50023]Branches of foreign shipping lines",
      label: "[50023]Branches of foreign shipping lines",
    },
    {
      value: "[51001]Airlines (passenger)",
      label: "[51001]Airlines (passenger)",
    },
    {
      value: "[51002]Airlines (freight)",
      label: "[51002]Airlines (freight)",
    },
    {
      value: "[51003]Branches of foreign airlines (passenger)",
      label: "[51003]Branches of foreign airlines (passenger)",
    },
    {
      value: "[51004]Branches of foreign airlines (freight)",
      label: "[51004]Branches of foreign airlines (freight)",
    },
    {
      value: "[51005]Aircraft chartering with operator",
      label: "[51005]Aircraft chartering with operator",
    },
    {
      value: "[52101]General warehousing",
      label: "[52101]General warehousing",
    },
    {
      value: "[52102]Refrigerated warehousing and storage",
      label: "[52102]Refrigerated warehousing and storage",
    },
    {
      value: "[52103]Storage for dangerous goods",
      label: "[52103]Storage for dangerous goods",
    },
    {
      value: "[52109]Specialised storage n.e.c.",
      label: "[52109]Specialised storage n.e.c.",
    },
    {
      value: "[52211]Carpark management and operation services",
      label: "[52211]Carpark management and operation services",
    },
    {
      value: "[52212]Motor vehicle towing services",
      label: "[52212]Motor vehicle towing services",
    },
    {
      value: "[52219]Supporting services to land transport n.e.c.",
      label: "[52219]Supporting services to land transport n.e.c.",
    },
    {
      value: "[52221]Representative offices of foreign shipping lines",
      label: "[52221]Representative offices of foreign shipping lines",
    },
    {
      value: "[52222]Shipping agencies (freight)",
      label: "[52222]Shipping agencies (freight)",
    },
    {
      value: "[52223]Port operators",
      label: "[52223]Port operators",
    },
    {
      value: "[52224]Lighterage services",
      label: "[52224]Lighterage services",
    },
    {
      value: "[52225]Salvaging of distressed vessels and cargos",
      label: "[52225]Salvaging of distressed vessels and cargos",
    },
    {
      value: "[52226]Ship management services",
      label: "[52226]Ship management services",
    },
    {
      value: "[52227]Ship brokering services",
      label: "[52227]Ship brokering services",
    },
    {
      value: "[52229]Supporting services to water transport n.e.c.",
      label: "[52229]Supporting services to water transport n.e.c.",
    },
    {
      value: "[52231]Representative offices of foreign airlines",
      label: "[52231]Representative offices of foreign airlines",
    },
    {
      value: "[52232]Airline agencies (freight)",
      label: "[52232]Airline agencies (freight)",
    },
    {
      value: "[52233]Airport operation services",
      label: "[52233]Airport operation services",
    },
    {
      value: "[52234]Airport terminal services",
      label: "[52234]Airport terminal services",
    },
    {
      value: "[52239]Supporting services to air transport n.e.c.",
      label: "[52239]Supporting services to air transport n.e.c.",
    },
    {
      value: "[52241]Container depot services",
      label: "[52241]Container depot services",
    },
    {
      value: "[52242]Industrial cargo lifting and moving services (except for use in construction industry)",
      label: "[52242]Industrial cargo lifting and moving services (except for use in construction industry)",
    },
    {
      value: "[52243]Stevedoring services",
      label: "[52243]Stevedoring services",
    },
    {
      value: "[52251]Classification societies",
      label: "[52251]Classification societies",
    },
    {
      value: "[52252]Marine surveying services (except classification societies)",
      label: "[52252]Marine surveying services (except classification societies)",
    },
    {
      value: "[52291]Cargo surveying services",
      label: "[52291]Cargo surveying services",
    },
    {
      value: "[52292]Freight transport arrangement",
      label: "[52292]Freight transport arrangement",
    },
    {
      value: "[53100]National post activities",
      label: "[53100]National post activities",
    },
    {
      value: "[53200]Courier activities (except national post activities)",
      label: "[53200]Courier activities (except national post activities)",
    },
    {
      value: "[55101]Hotels",
      label: "[55101]Hotels",
    },
    {
      value: "[55109]Short term accommodation activities n.e.c.",
      label: "[55109]Short term accommodation activities n.e.c.",
    },
    {
      value: "[55900]Hostels and dormitories for students, workers and other individuals",
      label: "[55900]Hostels and dormitories for students, workers and other individuals",
    },
    {
      value: "[56111]Restaurants",
      label: "[56111]Restaurants",
    },
    {
      value: "[56112]Cafes",
      label: "[56112]Cafes",
    },
    {
      value: "[56121]Fast food outlets",
      label: "[56121]Fast food outlets",
    },
    {
      value: "[56122]Operators of food courts, hawker centres, coffee shops and canteens (with mainly food and beverage income)",
      label: "[56122]Operators of food courts, hawker centres, coffee shops and canteens (with mainly food and beverage income)",
    },
    {
      value: "[56123]Food and drinks kiosks mainly for takeaway and delivery",
      label: "[56123]Food and drinks kiosks mainly for takeaway and delivery",
    },
    {
      value: "[56130]Pubs",
      label: "[56130]Pubs",
    },
    {
      value: "[56140]Stalls selling cooked food and prepared drinks",
      label: "[56140]Stalls selling cooked food and prepared drinks",
    },
    {
      value: "[56200]Food caterers",
      label: "[56200]Food caterers",
    },
    {
      value: "[58110]Publishing of books, brochures, musical books and other publications",
      label: "[58110]Publishing of books, brochures, musical books and other publications",
    },
    {
      value: "[58120]Publishing of directories and mailing lists",
      label: "[58120]Publishing of directories and mailing lists",
    },
    {
      value: "[58131]Publishing of news",
      label: "[58131]Publishing of news",
    },
    {
      value: "[58132]Publishing of journals, periodicals and magazines",
      label: "[58132]Publishing of journals, periodicals and magazines",
    },
    {
      value: "[58190]Other publishing activities",
      label: "[58190]Other publishing activities",
    },
    {
      value: "[58201]Publishing of games software/applications",
      label: "[58201]Publishing of games software/applications",
    },
    {
      value: "[58202]Publishing of software/applications (non-games)",
      label: "[58202]Publishing of software/applications (non-games)",
    },
    {
      value: "[59111]Movie production",
      label: "[59111]Movie production",
    },
    {
      value: "[59112]Production of advertisements, corporate videos and event videos",
      label: "[59112]Production of advertisements, corporate videos and event videos",
    },
    {
      value: "[59113]Production of dramas, variety shows and documentaries",
      label: "[59113]Production of dramas, variety shows and documentaries",
    },
    {
      value: "[59114]Animation production",
      label: "[59114]Animation production",
    },
    {
      value: "[59119]Movie, video, television and other programme production activities n.e.c.",
      label: "[59119]Movie, video, television and other programme production activities n.e.c.",
    },
    {
      value: "[59120]Movie, video, television and other programme post-production activities",
      label: "[59120]Movie, video, television and other programme post-production activities",
    },
    {
      value: "[59131]Movie distribution",
      label: "[59131]Movie distribution",
    },
    {
      value: "[59132]Distribution of television programmes",
      label: "[59132]Distribution of television programmes",
    },
    {
      value: "[59139]Movie, video, television and other programme distribution activities n.e.c.",
      label: "[59139]Movie, video, television and other programme distribution activities n.e.c.",
    },
    {
      value: "[59140]Movie projection activities",
      label: "[59140]Movie projection activities",
    },
    {
      value: "[59201]Sound recording production",
      label: "[59201]Sound recording production",
    },
    {
      value: "[59202]Music publishing and distribution activities",
      label: "[59202]Music publishing and distribution activities",
    },
    {
      value: "[60100]Radio programme production and broadcasting",
      label: "[60100]Radio programme production and broadcasting",
    },
    {
      value: "[60200]Television programming and broadcasting",
      label: "[60200]Television programming and broadcasting",
    },
    {
      value: "[60301]News agency activities",
      label: "[60301]News agency activities",
    },
    {
      value: "[60302]Operation of social network sites and other content distribution activities (except publishing)",
      label: "[60302]Operation of social network sites and other content distribution activities (except publishing)",
    },
    {
      value: "[61010]Telecommunications network operation",
      label: "[61010]Telecommunications network operation",
    },
    {
      value: "[61020]Telecommunications resellers/third party telecommunications providers",
      label: "[61020]Telecommunications resellers/third party telecommunications providers",
    },
    {
      value: "[61090]Other telecommunication services",
      label: "[61090]Other telecommunication services",
    },
    {
      value: "[62011]Development of software and applications (except games and cybersecurity)",
      label: "[62011]Development of software and applications (except games and cybersecurity)",
    },
    {
      value: "[62012]Development of computer games",
      label: "[62012]Development of computer games",
    },
    {
      value: "[62013]Development of software for cybersecurity",
      label: "[62013]Development of software for cybersecurity",
    },
    {
      value: "[62021]Information technology consultancy (except cybersecurity)",
      label: "[62021]Information technology consultancy (except cybersecurity)",
    },
    {
      value: "[62022]Information technology cybersecurity consultancy",
      label: "[62022]Information technology cybersecurity consultancy",
    },
    {
      value: "[62023]Computer facilities management activities",
      label: "[62023]Computer facilities management activities",
    },
    {
      value: "[62090]Other information technology and computer service activities",
      label: "[62090]Other information technology and computer service activities",
    },
    {
      value: "[63111]Data centres",
      label: "[63111]Data centres",
    },
    {
      value: "[63112]Hosting services by non-data centres",
      label: "[63112]Hosting services by non-data centres",
    },
    {
      value: "[63119]Data analytics, processing, hosting and related activities n.e.c.",
      label: "[63119]Data analytics, processing, hosting and related activities n.e.c.",
    },
    {
      value:
        "[63201]Online marketplaces operating on a fee or commission basis for goods and food sold by third-party; Online marketplaces operating on a fee or commission basis for food delivery services",
      label:
        "[63201]Online marketplaces operating on a fee or commission basis for goods and food sold by third-party; Online marketplaces operating on a fee or commission basis for food delivery services",
    },
    {
      value: "[63202]Online marketplaces operating on a fee or commission basis for health services provided by third-party",
      label: "[63202]Online marketplaces operating on a fee or commission basis for health services provided by third-party",
    },
    {
      value: "[63203]Online marketplaces operating on a fee or commission basis for education services provided by third-party",
      label: "[63203]Online marketplaces operating on a fee or commission basis for education services provided by third-party",
    },
    {
      value: "[63204]Online marketplaces operating on a fee or commission basis for travel and accommodation services provided by third-party",
      label: "[63204]Online marketplaces operating on a fee or commission basis for travel and accommodation services provided by third-party",
    },
    {
      value: "[63205]Online marketplaces operating on a fee or commission basis for real estate services provided by third-party",
      label: "[63205]Online marketplaces operating on a fee or commission basis for real estate services provided by third-party",
    },
    {
      value: "[63209]Online marketplaces operating on a fee or commission basis for other services provided by third-party",
      label: "[63209]Online marketplaces operating on a fee or commission basis for other services provided by third-party",
    },
    {
      value: "[63901]Internet search engines",
      label: "[63901]Internet search engines",
    },
    {
      value: "[63909]Other information service activities n.e.c.",
      label: "[63909]Other information service activities n.e.c.",
    },
    {
      value: "[64110]Central bank",
      label: "[64110]Central bank",
    },
    {
      value: "[64120]Full banks",
      label: "[64120]Full banks",
    },
    {
      value: "[64130]Wholesale banks",
      label: "[64130]Wholesale banks",
    },
    {
      value: "[64140]Merchant banks",
      label: "[64140]Merchant banks",
    },
    {
      value: "[64150]Finance companies (with deposit taking functions)",
      label: "[64150]Finance companies (with deposit taking functions)",
    },
    {
      value: "[64201]Holding companies of firms engaged in financial and insurance activities",
      label: "[64201]Holding companies of firms engaged in financial and insurance activities",
    },
    {
      value: "[64202]Holding companies of firms engaged in non-financial and insurance activities",
      label: "[64202]Holding companies of firms engaged in non-financial and insurance activities",
    },
    {
      value: "[64300]Trusts, funds and similar financial entities (except those with rental income)",
      label: "[64300]Trusts, funds and similar financial entities (except those with rental income)",
    },
    {
      value: "[64910]Financial leasing companies",
      label: "[64910]Financial leasing companies",
    },
    {
      value: "[64921]Thrift and loan societies and credit associations",
      label: "[64921]Thrift and loan societies and credit associations",
    },
    {
      value: "[64922]Credit card services",
      label: "[64922]Credit card services",
    },
    {
      value: "[64923]Mutual benefits organisations",
      label: "[64923]Mutual benefits organisations",
    },
    {
      value: "[64924]Money-lending",
      label: "[64924]Money-lending",
    },
    {
      value: "[64925]Pawnbrokerage",
      label: "[64925]Pawnbrokerage",
    },
    {
      value: "[64929]Other credit granting n.e.c.",
      label: "[64929]Other credit granting n.e.c.",
    },
    {
      value: "[64991]Factoring companies",
      label: "[64991]Factoring companies",
    },
    {
      value: "[64992]Representative offices of foreign banks",
      label: "[64992]Representative offices of foreign banks",
    },
    {
      value: "[64993]Remittance services",
      label: "[64993]Remittance services",
    },
    {
      value: "[64994]Treasury centres",
      label: "[64994]Treasury centres",
    },
    {
      value: "[64999]Other financial service activities n.e.c. (except insurance and pension funding activities)",
      label: "[64999]Other financial service activities n.e.c. (except insurance and pension funding activities)",
    },
    {
      value: "[65110]Life insurance",
      label: "[65110]Life insurance",
    },
    {
      value: "[65121]Marine insurance",
      label: "[65121]Marine insurance",
    },
    {
      value: "[65122]Captive insurance",
      label: "[65122]Captive insurance",
    },
    {
      value: "[65123]Import, export and credit insurance",
      label: "[65123]Import, export and credit insurance",
    },
    {
      value: "[65124]General insurance (except marine and import, export and credit insurance)",
      label: "[65124]General insurance (except marine and import, export and credit insurance)",
    },
    {
      value: "[65201]Life reinsurance",
      label: "[65201]Life reinsurance",
    },
    {
      value: "[65202]General reinsurance",
      label: "[65202]General reinsurance",
    },
    {
      value: "[65300]Provident funding and pension funding",
      label: "[65300]Provident funding and pension funding",
    },
    {
      value: "[66110]Securities and commodities exchange",
      label: "[66110]Securities and commodities exchange",
    },
    {
      value: "[66121]Stock, share and bond brokers and dealers",
      label: "[66121]Stock, share and bond brokers and dealers",
    },
    {
      value: "[66122]Foreign exchange brokers and dealers",
      label: "[66122]Foreign exchange brokers and dealers",
    },
    {
      value: "[66123]Gold bullion brokers and dealers",
      label: "[66123]Gold bullion brokers and dealers",
    },
    {
      value: "[66124]Commodity and futures brokers and dealers (except gold)",
      label: "[66124]Commodity and futures brokers and dealers (except gold)",
    },
    {
      value: "[66125]Carbon credit brokers/traders",
      label: "[66125]Carbon credit brokers/traders",
    },
    {
      value: "[66126]Money-changing services",
      label: "[66126]Money-changing services",
    },
    {
      value: "[66129]Security dealings and commodity contracts brokerage activities n.e.c.",
      label: "[66129]Security dealings and commodity contracts brokerage activities n.e.c.",
    },
    {
      value: "[66191]Trustee, fiduciary and custody services",
      label: "[66191]Trustee, fiduciary and custody services",
    },
    {
      value: "[66192]Corporate finance advisory services",
      label: "[66192]Corporate finance advisory services",
    },
    {
      value: "[66193]Clearing and settlement of financial instruments",
      label: "[66193]Clearing and settlement of financial instruments",
    },
    {
      value: "[66194]Activities auxiliary to fund management activities",
      label: "[66194]Activities auxiliary to fund management activities",
    },
    {
      value: "[66195]Transaction/payment processing services",
      label: "[66195]Transaction/payment processing services",
    },
    {
      value: "[66199]Other activities auxiliary to financial service activities n.e.c.",
      label: "[66199]Other activities auxiliary to financial service activities n.e.c.",
    },
    {
      value: "[66210]Risk and damage evaluation",
      label: "[66210]Risk and damage evaluation",
    },
    {
      value: "[66221]Insurance agencies and agents",
      label: "[66221]Insurance agencies and agents",
    },
    {
      value: "[66222]Insurance brokers",
      label: "[66222]Insurance brokers",
    },
    {
      value: "[66291]Representative offices of foreign insurers and professional reinsurers",
      label: "[66291]Representative offices of foreign insurers and professional reinsurers",
    },
    {
      value: "[66292]Captive managers",
      label: "[66292]Captive managers",
    },
    {
      value: "[66299]Other activities auxiliary to insurance and pension funding n.e.c.",
      label: "[66299]Other activities auxiliary to insurance and pension funding n.e.c.",
    },
    {
      value: "[66301]Traditional/long-only asset/portfolio management",
      label: "[66301]Traditional/long-only asset/portfolio management",
    },
    {
      value: "[66302]Hedge fund management",
      label: "[66302]Hedge fund management",
    },
    {
      value: "[66303]Property fund/REIT management",
      label: "[66303]Property fund/REIT management",
    },
    {
      value: "[66304]Private equity firms",
      label: "[66304]Private equity firms",
    },
    {
      value: "[66305]Venture capital activities",
      label: "[66305]Venture capital activities",
    },
    {
      value: "[66306]Single/multiple family offices activities",
      label: "[66306]Single/multiple family offices activities",
    },
    {
      value: "[66307]Private debt funds",
      label: "[66307]Private debt funds",
    },
    {
      value: "[66309]Fund management activities n.e.c.",
      label: "[66309]Fund management activities n.e.c.",
    },
    {
      value: "[68101]Real estate developers",
      label: "[68101]Real estate developers",
    },
    {
      value: "[68102]Operating of serviced apartments",
      label: "[68102]Operating of serviced apartments",
    },
    {
      value: "[68103]Letting and operating of self-owned or leased real estate property (except food courts, hawker centres, coffee shops and canteens)",
      label: "[68103]Letting and operating of self-owned or leased real estate property (except food courts, hawker centres, coffee shops and canteens)",
    },
    {
      value: "[68104]Letting and operating of self-owned or leased food courts, hawker centres, coffee shops and canteens (with mainly rental income)",
      label: "[68104]Letting and operating of self-owned or leased food courts, hawker centres, coffee shops and canteens (with mainly rental income)",
    },
    {
      value: "[68105]Collective portfolio investment funds with rental income",
      label: "[68105]Collective portfolio investment funds with rental income",
    },
    {
      value: "[68106]Management of self-owned strata titled property",
      label: "[68106]Management of self-owned strata titled property",
    },
    {
      value: "[68201]Real estate agencies and valuation services",
      label: "[68201]Real estate agencies and valuation services",
    },
    {
      value: "[68202]Town councils",
      label: "[68202]Town councils",
    },
    {
      value: "[68203]Residential, commercial and industrial real estate management (except town councils)",
      label: "[68203]Residential, commercial and industrial real estate management (except town councils)",
    },
    {
      value: "[68209]Real estate activities on a fee or commission basis n.e.c.",
      label: "[68209]Real estate activities on a fee or commission basis n.e.c.",
    },
    {
      value: "[69101]Legal activities",
      label: "[69101]Legal activities",
    },
    {
      value: "[69102]Arbitration and mediation services",
      label: "[69102]Arbitration and mediation services",
    },
    {
      value: "[69201]Accounting, auditing and tax consultancy services",
      label: "[69201]Accounting, auditing and tax consultancy services",
    },
    {
      value: "[69202]Book-keeping services",
      label: "[69202]Book-keeping services",
    },
    {
      value: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices",
      label: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices",
    },
    {
      value: "[70102]Business representative offices",
      label: "[70102]Business representative offices",
    },
    {
      value: "[70201]Management consultancy services",
      label: "[70201]Management consultancy services",
    },
    {
      value: "[70202]Management consultancy services for healthcare organisations",
      label: "[70202]Management consultancy services for healthcare organisations",
    },
    {
      value: "[70203]Management consultancy services for hotels",
      label: "[70203]Management consultancy services for hotels",
    },
    {
      value: "[70204]Human resource consultancy services",
      label: "[70204]Human resource consultancy services",
    },
    {
      value: "[70205]Public relations, marketing and brand consultancy services",
      label: "[70205]Public relations, marketing and brand consultancy services",
    },
    {
      value: "[70206]Port, shipping and maritime-related consultancy services",
      label: "[70206]Port, shipping and maritime-related consultancy services",
    },
    {
      value: "[70209]Management consultancy services n.e.c.",
      label: "[70209]Management consultancy services n.e.c.",
    },
    {
      value: "[71111]Architectural services",
      label: "[71111]Architectural services",
    },
    {
      value: "[71112]Landscape design and landscape architecture",
      label: "[71112]Landscape design and landscape architecture",
    },
    {
      value: "[71113]Quantity surveying services",
      label: "[71113]Quantity surveying services",
    },
    {
      value: "[71114]Land surveying services",
      label: "[71114]Land surveying services",
    },
    {
      value: "[71119]Other surveying services n.e.c.",
      label: "[71119]Other surveying services n.e.c.",
    },
    {
      value: "[71121]General building engineering design and consultancy services",
      label: "[71121]General building engineering design and consultancy services",
    },
    {
      value: "[71122]Process and industrial plant engineering design and consultancy services",
      label: "[71122]Process and industrial plant engineering design and consultancy services",
    },
    {
      value: "[71123]Engineering design and consultancy services in energy management and clean energy systems",
      label: "[71123]Engineering design and consultancy services in energy management and clean energy systems",
    },
    {
      value: "[71124]Environmental engineering design and consultancy services (except clean energy)",
      label: "[71124]Environmental engineering design and consultancy services (except clean energy)",
    },
    {
      value: "[71125]Infrastructure engineering design and consultancy services",
      label: "[71125]Infrastructure engineering design and consultancy services",
    },
    {
      value: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities",
      label: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities",
    },
    {
      value: "[71129]Engineering design and consultancy activities n.e.c.",
      label: "[71129]Engineering design and consultancy activities n.e.c.",
    },
    {
      value: "[71200]Technical testing and analysis services; certification of products and services",
      label: "[71200]Technical testing and analysis services; certification of products and services",
    },
    {
      value: "[72101]Research and experimental development on biotechnology (except medical and veterinary science)",
      label: "[72101]Research and experimental development on biotechnology (except medical and veterinary science)",
    },
    {
      value: "[72102]Research and experimental development on electronics (except medical and veterinary science)",
      label: "[72102]Research and experimental development on electronics (except medical and veterinary science)",
    },
    {
      value: "[72103]Research and experimental development on chemicals (except medical and veterinary science)",
      label: "[72103]Research and experimental development on chemicals (except medical and veterinary science)",
    },
    {
      value: "[72104]Research and experimental development on engineering",
      label: "[72104]Research and experimental development on engineering",
    },
    {
      value: "[72105]Research and experimental development on environment and clean technologies (except biotechnology)",
      label: "[72105]Research and experimental development on environment and clean technologies (except biotechnology)",
    },
    {
      value: "[72106]Research and experimental development on medical and veterinary sciences",
      label: "[72106]Research and experimental development on medical and veterinary sciences",
    },
    {
      value: "[72109]Research and experimental development on natural sciences n.e.c.",
      label: "[72109]Research and experimental development on natural sciences n.e.c.",
    },
    {
      value: "[72200]Research and experimental development on social sciences and humanities",
      label: "[72200]Research and experimental development on social sciences and humanities",
    },
    {
      value: "[73100]Advertising activities",
      label: "[73100]Advertising activities",
    },
    {
      value: "[73200]Market research and public opinion polling",
      label: "[73200]Market research and public opinion polling",
    },
    {
      value: "[74111]Electronics-related industrial design services",
      label: "[74111]Electronics-related industrial design services",
    },
    {
      value: "[74112]Transport-related industrial design services",
      label: "[74112]Transport-related industrial design services",
    },
    {
      value: "[74113]Furniture design services",
      label: "[74113]Furniture design services",
    },
    {
      value: "[74119]Industrial design activities n.e.c.",
      label: "[74119]Industrial design activities n.e.c.",
    },
    {
      value: "[74191]Interior design services",
      label: "[74191]Interior design services",
    },
    {
      value: "[74192]Art and graphic design services",
      label: "[74192]Art and graphic design services",
    },
    {
      value: "[74193]Fashion and accessories design services",
      label: "[74193]Fashion and accessories design services",
    },
    {
      value: "[74194]Exhibition stand design services",
      label: "[74194]Exhibition stand design services",
    },
    {
      value: "[74199]Other specialised design activities n.e.c.",
      label: "[74199]Other specialised design activities n.e.c.",
    },
    {
      value: "[74200]Photographic activities",
      label: "[74200]Photographic activities",
    },
    {
      value: "[74901]Translation services",
      label: "[74901]Translation services",
    },
    {
      value: "[74902]Brokerage and consultancy services of intellectual property assets",
      label: "[74902]Brokerage and consultancy services of intellectual property assets",
    },
    {
      value: "[74903]Agrotechnology consultancy services",
      label: "[74903]Agrotechnology consultancy services",
    },
    {
      value: "[74904]Sustainability consultancy services",
      label: "[74904]Sustainability consultancy services",
    },
    {
      value: "[74905]Agents for artistes, athletes, models and other performers",
      label: "[74905]Agents for artistes, athletes, models and other performers",
    },
    {
      value: "[74909]Other professional, scientific and technical activities n.e.c.",
      label: "[74909]Other professional, scientific and technical activities n.e.c.",
    },
    {
      value: "[75000]Veterinary activities",
      label: "[75000]Veterinary activities",
    },
    {
      value: "[77101]Renting and leasing of private cars without driver",
      label: "[77101]Renting and leasing of private cars without driver",
    },
    {
      value: "[77102]Renting and leasing of bicycles and inline/roller skates",
      label: "[77102]Renting and leasing of bicycles and inline/roller skates",
    },
    {
      value: "[77109]Renting and leasing of land transport equipment without driver n.e.c. (except cars)",
      label: "[77109]Renting and leasing of land transport equipment without driver n.e.c. (except cars)",
    },
    {
      value: "[77210]Renting and leasing of recreational and sports goods",
      label: "[77210]Renting and leasing of recreational and sports goods",
    },
    {
      value: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use",
      label: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use",
    },
    {
      value: "[77292]Renting of costumes and other attire",
      label: "[77292]Renting of costumes and other attire",
    },
    {
      value: "[77299]Renting and leasing of other personal and household goods n.e.c.",
      label: "[77299]Renting and leasing of other personal and household goods n.e.c.",
    },
    {
      value: "[77310]Renting of water transport equipment and floating structures without operator",
      label: "[77310]Renting of water transport equipment and floating structures without operator",
    },
    {
      value: "[77320]Renting of air transport equipment without operator",
      label: "[77320]Renting of air transport equipment without operator",
    },
    {
      value: "[77330]Renting of construction and civil engineering machinery and equipment without operator",
      label: "[77330]Renting of construction and civil engineering machinery and equipment without operator",
    },
    {
      value: "[77341]Renting of computers and peripheral equipment without operator",
      label: "[77341]Renting of computers and peripheral equipment without operator",
    },
    {
      value: "[77342]Renting of office machinery and equipment without operator",
      label: "[77342]Renting of office machinery and equipment without operator",
    },
    {
      value: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment without operator",
      label: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment without operator",
    },
    {
      value: "[77392]Renting of industrial machinery and equipment without operator",
      label: "[77392]Renting of industrial machinery and equipment without operator",
    },
    {
      value: "[77399]Renting of other machinery, equipment and tangible goods without operator n.e.c.",
      label: "[77399]Renting of other machinery, equipment and tangible goods without operator n.e.c.",
    },
    {
      value: "[77400]Leasing of non-financial intangible assets",
      label: "[77400]Leasing of non-financial intangible assets",
    },
    {
      value: "[78101]IT manpower contracting services",
      label: "[78101]IT manpower contracting services",
    },
    {
      value: "[78102]Manpower contracting services (except IT manpower)",
      label: "[78102]Manpower contracting services (except IT manpower)",
    },
    {
      value: "[78103]Domestic worker employment placement agencies",
      label: "[78103]Domestic worker employment placement agencies",
    },
    {
      value: "[78104]Employment agencies (except domestic worker employment placement agencies)",
      label: "[78104]Employment agencies (except domestic worker employment placement agencies)",
    },
    {
      value: "[78300]Management of human resource functions",
      label: "[78300]Management of human resource functions",
    },
    {
      value: "[79101]Travel agencies and tour operators (mainly inbound)",
      label: "[79101]Travel agencies and tour operators (mainly inbound)",
    },
    {
      value: "[79102]Travel agencies and tour operators (mainly outbound)",
      label: "[79102]Travel agencies and tour operators (mainly outbound)",
    },
    {
      value: "[80100]Private security activities",
      label: "[80100]Private security activities",
    },
    {
      value: "[80200]Detective and investigation activities",
      label: "[80200]Detective and investigation activities",
    },
    {
      value: "[81211]General cleaning services (except household cleaning)",
      label: "[81211]General cleaning services (except household cleaning)",
    },
    {
      value: "[81212]Domestic/household cleaning services",
      label: "[81212]Domestic/household cleaning services",
    },
    {
      value: "[81291]Pest control services not in connection with agriculture",
      label: "[81291]Pest control services not in connection with agriculture",
    },
    {
      value: "[81292]Cleaning, maintenance and/or treatment of swimming pools, spa pools, water playgrounds and fountains",
      label: "[81292]Cleaning, maintenance and/or treatment of swimming pools, spa pools, water playgrounds and fountains",
    },
    {
      value: "[81299]Other cleaning services n.e.c.",
      label: "[81299]Other cleaning services n.e.c.",
    },
    {
      value: "[81300]Landscape service activities (except landscape design and architecture)",
      label: "[81300]Landscape service activities (except landscape design and architecture)",
    },
    {
      value: "[82110]Office administrative services on a fee or contract basis",
      label: "[82110]Office administrative services on a fee or contract basis",
    },
    {
      value: "[82191]Stenographic and secretarial services",
      label: "[82191]Stenographic and secretarial services",
    },
    {
      value: "[82192]Duplicating and photo-copying services",
      label: "[82192]Duplicating and photo-copying services",
    },
    {
      value: "[82199]Other specialised office support activities n.e.c.",
      label: "[82199]Other specialised office support activities n.e.c.",
    },
    {
      value: "[82200]Call centres",
      label: "[82200]Call centres",
    },
    {
      value: "[82301]Exhibition organisers",
      label: "[82301]Exhibition organisers",
    },
    {
      value: "[82302]Convention/conference/corporate meeting organisers",
      label: "[82302]Convention/conference/corporate meeting organisers",
    },
    {
      value: "[82303]Event organisers (except concerts, sports/fitness event organisers and wedding planners)",
      label: "[82303]Event organisers (except concerts, sports/fitness event organisers and wedding planners)",
    },
    {
      value: "[82304]Exhibition stand contractors",
      label: "[82304]Exhibition stand contractors",
    },
    {
      value: "[82305]Concert organisers",
      label: "[82305]Concert organisers",
    },
    {
      value: "[82911]Debt collection services",
      label: "[82911]Debt collection services",
    },
    {
      value: "[82912]Credit rating agencies",
      label: "[82912]Credit rating agencies",
    },
    {
      value: "[82920]Packaging activities",
      label: "[82920]Packaging activities",
    },
    {
      value: "[82991]Activities of auction houses",
      label: "[82991]Activities of auction houses",
    },
    {
      value: "[82999]Other business support service activities",
      label: "[82999]Other business support service activities",
    },
    {
      value: "[84110]Executive, legislative and other general public administration",
      label: "[84110]Executive, legislative and other general public administration",
    },
    {
      value: "[84120]Public administration of economic, social and environmental programmes",
      label: "[84120]Public administration of economic, social and environmental programmes",
    },
    {
      value: "[84210]Foreign affairs",
      label: "[84210]Foreign affairs",
    },
    {
      value: "[84221]Armed forces",
      label: "[84221]Armed forces",
    },
    {
      value: "[84229]Defence activities n.e.c.",
      label: "[84229]Defence activities n.e.c.",
    },
    {
      value: "[84231]Judiciary and related services",
      label: "[84231]Judiciary and related services",
    },
    {
      value: "[84232]Police",
      label: "[84232]Police",
    },
    {
      value: "[84233]Prisons",
      label: "[84233]Prisons",
    },
    {
      value: "[84234]Other places of detention, correction and rehabilitation",
      label: "[84234]Other places of detention, correction and rehabilitation",
    },
    {
      value: "[84235]Civil defence",
      label: "[84235]Civil defence",
    },
    {
      value: "[84239]Public order and safety activities n.e.c.",
      label: "[84239]Public order and safety activities n.e.c.",
    },
    {
      value: "[85100]Pre-primary education; child care with pre-primary education services",
      label: "[85100]Pre-primary education; child care with pre-primary education services",
    },
    {
      value: "[85200]Primary education",
      label: "[85200]Primary education",
    },
    {
      value: "[85310]Secondary schools; combined primary and secondary schools",
      label: "[85310]Secondary schools; combined primary and secondary schools",
    },
    {
      value: "[85320]Technical and vocational (secondary and post-secondary non-tertiary) education",
      label: "[85320]Technical and vocational (secondary and post-secondary non-tertiary) education",
    },
    {
      value:
        "[85331]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary); combined secondary schools and post-secondary non-tertiary schools",
      label:
        "[85331]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary); combined secondary schools and post-secondary non-tertiary schools",
    },
    {
      value: "[85332]Commercial schools offering general secondary and post-secondary non-tertiary education programmes",
      label: "[85332]Commercial schools offering general secondary and post-secondary non-tertiary education programmes",
    },
    {
      value: "[85340]International and foreign system schools",
      label: "[85340]International and foreign system schools",
    },
    {
      value: "[85350]Schools for special needs",
      label: "[85350]Schools for special needs",
    },
    {
      value: "[85360]Specialised education schools",
      label: "[85360]Specialised education schools",
    },
    {
      value: "[85401]Polytechnics",
      label: "[85401]Polytechnics",
    },
    {
      value: "[85402]Universities",
      label: "[85402]Universities",
    },
    {
      value: "[85403]Teachers' training institute",
      label: "[85403]Teachers' training institute",
    },
    {
      value: "[85404]Commercial schools offering tertiary education programmes",
      label: "[85404]Commercial schools offering tertiary education programmes",
    },
    {
      value:
        "[85501]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management",
      label:
        "[85501]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management",
    },
    {
      value: "[85502]Training courses for healthcare, education, community and social services",
      label: "[85502]Training courses for healthcare, education, community and social services",
    },
    {
      value:
        "[85503]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies and travel-related reservation services",
      label:
        "[85503]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies and travel-related reservation services",
    },
    {
      value: "[85504]Training courses for manufacturing",
      label: "[85504]Training courses for manufacturing",
    },
    {
      value: "[85505]Training courses for information and communications, finance and professional services",
      label: "[85505]Training courses for information and communications, finance and professional services",
    },
    {
      value: "[85506]Training courses for wholesale trade, logistics and transport",
      label: "[85506]Training courses for wholesale trade, logistics and transport",
    },
    {
      value: "[85507]Training courses for sports and games",
      label: "[85507]Training courses for sports and games",
    },
    {
      value: "[85508]Training courses for music, dancing, art, speech and drama",
      label: "[85508]Training courses for music, dancing, art, speech and drama",
    },
    {
      value: "[85509]Training courses n.e.c.",
      label: "[85509]Training courses n.e.c.",
    },
    {
      value: "[85601]Student recruitment agencies",
      label: "[85601]Student recruitment agencies",
    },
    {
      value: "[85602]Examination and accreditation agencies for education services",
      label: "[85602]Examination and accreditation agencies for education services",
    },
    {
      value: "[85609]Educational support services n.e.c.",
      label: "[85609]Educational support services n.e.c.",
    },
    {
      value: "[86101]Acute hospitals",
      label: "[86101]Acute hospitals",
    },
    {
      value: "[86102]Community hospitals",
      label: "[86102]Community hospitals",
    },
    {
      value: "[86109]Hospital activities n.e.c.",
      label: "[86109]Hospital activities n.e.c.",
    },
    {
      value: "[86201]Clinics and other general medical services (Western)",
      label: "[86201]Clinics and other general medical services (Western)",
    },
    {
      value: "[86202]Clinics and other general medical services (Non-Western)",
      label: "[86202]Clinics and other general medical services (Non-Western)",
    },
    {
      value: "[86203]Specialised medical services",
      label: "[86203]Specialised medical services",
    },
    {
      value: "[86204]Dental services",
      label: "[86204]Dental services",
    },
    {
      value: "[86901]Medical laboratories",
      label: "[86901]Medical laboratories",
    },
    {
      value: "[86902]Medical diagnostic imaging centres",
      label: "[86902]Medical diagnostic imaging centres",
    },
    {
      value: "[86903]Ambulance and medical evacuation services",
      label: "[86903]Ambulance and medical evacuation services",
    },
    {
      value: "[86904]Home healthcare services",
      label: "[86904]Home healthcare services",
    },
    {
      value: "[86905]Dialysis services",
      label: "[86905]Dialysis services",
    },
    {
      value: "[86909]Other health services n.e.c.",
      label: "[86909]Other health services n.e.c.",
    },
    {
      value: "[87010]Nursing and personal care facilities",
      label: "[87010]Nursing and personal care facilities",
    },
    {
      value: "[87021]Residential care services for the elderly",
      label: "[87021]Residential care services for the elderly",
    },
    {
      value: "[87022]Residential care services for children",
      label: "[87022]Residential care services for children",
    },
    {
      value: "[87029]Other residential care services n.e.c.",
      label: "[87029]Other residential care services n.e.c.",
    },
    {
      value: "[88101]Social services for the elderly",
      label: "[88101]Social services for the elderly",
    },
    {
      value: "[88102]Social services for persons with disabilities",
      label: "[88102]Social services for persons with disabilities",
    },
    {
      value: "[88911]Infant care services; child minding services for pre-school children",
      label: "[88911]Infant care services; child minding services for pre-school children",
    },
    {
      value: "[88912]Student care services; child minding services for school-going children",
      label: "[88912]Student care services; child minding services for school-going children",
    },
    {
      value: "[88913]Social services for children and youths",
      label: "[88913]Social services for children and youths",
    },
    {
      value: "[88919]Social services without accommodation for children, youth and families n.e.c.",
      label: "[88919]Social services without accommodation for children, youth and families n.e.c.",
    },
    {
      value: "[88920]Community development councils",
      label: "[88920]Community development councils",
    },
    {
      value: "[88991]Job training and vocational rehabilitation services",
      label: "[88991]Job training and vocational rehabilitation services",
    },
    {
      value: "[88992]Charitable and other supporting activities aimed at humanitarian work",
      label: "[88992]Charitable and other supporting activities aimed at humanitarian work",
    },
    {
      value: "[88999]Other social services without accommodation n.e.c.",
      label: "[88999]Other social services without accommodation n.e.c.",
    },
    {
      value: "[90110]Literary creation and musical composition activities",
      label: "[90110]Literary creation and musical composition activities",
    },
    {
      value: "[90120]Visual arts creation activities",
      label: "[90120]Visual arts creation activities",
    },
    {
      value: "[90190]Other arts creation activities",
      label: "[90190]Other arts creation activities",
    },
    {
      value: "[90201]Production of live theatrical presentations",
      label: "[90201]Production of live theatrical presentations",
    },
    {
      value: "[90202]Orchestras, musical bands, choirs and dance performance activities",
      label: "[90202]Orchestras, musical bands, choirs and dance performance activities",
    },
    {
      value: "[90209]Activities of performing arts n.e.c.",
      label: "[90209]Activities of performing arts n.e.c.",
    },
    {
      value: "[90310]Arts facilities/venue operation",
      label: "[90310]Arts facilities/venue operation",
    },
    {
      value: "[90390]Other support activities to arts and performing arts",
      label: "[90390]Other support activities to arts and performing arts",
    },
    {
      value: "[91100]Libraries and archives activities",
      label: "[91100]Libraries and archives activities",
    },
    {
      value: "[91201]Museums",
      label: "[91201]Museums",
    },
    {
      value: "[91209]Operation of historical sites and buildings n.e.c.",
      label: "[91209]Operation of historical sites and buildings n.e.c.",
    },
    {
      value: "[91300]Conservation, restoration and other support activities for cultural heritage",
      label: "[91300]Conservation, restoration and other support activities for cultural heritage",
    },
    {
      value: "[91400]Botanical and zoological gardens and nature reserves activities (except landscaping and nature tours)",
      label: "[91400]Botanical and zoological gardens and nature reserves activities (except landscaping and nature tours)",
    },
    {
      value: "[92001]Horse-racing and other betting activities",
      label: "[92001]Horse-racing and other betting activities",
    },
    {
      value: "[92002]Casinos",
      label: "[92002]Casinos",
    },
    {
      value: "[93111]Fitness centres and gymnasiums",
      label: "[93111]Fitness centres and gymnasiums",
    },
    {
      value: "[93112]Sports/fitness event organisers",
      label: "[93112]Sports/fitness event organisers",
    },
    {
      value: "[93119]Operation of sports facilities n.e.c.",
      label: "[93119]Operation of sports facilities n.e.c.",
    },
    {
      value: "[93120]Activities of sports clubs/associations and related activities",
      label: "[93120]Activities of sports clubs/associations and related activities",
    },
    {
      value: "[93201]Amusement theme parks, adventure and family attractions",
      label: "[93201]Amusement theme parks, adventure and family attractions",
    },
    {
      value: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres",
      label: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres",
    },
    {
      value: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges",
      label: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges",
    },
    {
      value: "[93204]Recreation clubs",
      label: "[93204]Recreation clubs",
    },
    {
      value: "[93209]Other amusement and recreation activities n.e.c.",
      label: "[93209]Other amusement and recreation activities n.e.c.",
    },
    {
      value: "[94110]Activities of business and employers' membership organisations",
      label: "[94110]Activities of business and employers' membership organisations",
    },
    {
      value: "[94120]Activities of professional membership organisations",
      label: "[94120]Activities of professional membership organisations",
    },
    {
      value: "[94200]Activities of trade unions and platform work associations",
      label: "[94200]Activities of trade unions and platform work associations",
    },
    {
      value: "[94911]Churches",
      label: "[94911]Churches",
    },
    {
      value: "[94912]Mosques",
      label: "[94912]Mosques",
    },
    {
      value: "[94913]Buddhist/Taoist temples",
      label: "[94913]Buddhist/Taoist temples",
    },
    {
      value: "[94914]Hindu/Sikh temples",
      label: "[94914]Hindu/Sikh temples",
    },
    {
      value: "[94919]Activities of religious organisations n.e.c.",
      label: "[94919]Activities of religious organisations n.e.c.",
    },
    {
      value: "[94920]Activities of political organisations",
      label: "[94920]Activities of political organisations",
    },
    {
      value: "[94991]Philanthropic trusts, foundations and related activities",
      label: "[94991]Philanthropic trusts, foundations and related activities",
    },
    {
      value: "[94992]Ethnic associations",
      label: "[94992]Ethnic associations",
    },
    {
      value: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities",
      label: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities",
    },
    {
      value: "[94994]Student/alumni bodies and related associations",
      label: "[94994]Student/alumni bodies and related associations",
    },
    {
      value: "[94995]Organisations for the protection of the environment and animals",
      label: "[94995]Organisations for the protection of the environment and animals",
    },
    {
      value: "[94996]Community and grassroots organisations",
      label: "[94996]Community and grassroots organisations",
    },
    {
      value: "[94999]Activities of other membership organisations n.e.c.",
      label: "[94999]Activities of other membership organisations n.e.c.",
    },
    {
      value: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals",
      label: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals",
    },
    {
      value: "[95120]Repair of communications equipment",
      label: "[95120]Repair of communications equipment",
    },
    {
      value: "[95210]Repair of audio and video equipment",
      label: "[95210]Repair of audio and video equipment",
    },
    {
      value: "[95220]Repair of domestic electrical/electronic appliances (except audio and video equipment)",
      label: "[95220]Repair of domestic electrical/electronic appliances (except audio and video equipment)",
    },
    {
      value: "[95230]Repair of footwear and leather goods",
      label: "[95230]Repair of footwear and leather goods",
    },
    {
      value: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures",
      label: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures",
    },
    {
      value: "[95291]Repair of bicycles and tricycles",
      label: "[95291]Repair of bicycles and tricycles",
    },
    {
      value: "[95292]Repair of watches and clocks",
      label: "[95292]Repair of watches and clocks",
    },
    {
      value: "[95293]Repair of jewellery",
      label: "[95293]Repair of jewellery",
    },
    {
      value: "[95299]Repair of other personal and household goods n.e.c.",
      label: "[95299]Repair of other personal and household goods n.e.c.",
    },
    {
      value: "[95301]Repair and maintenance of motor vehicles",
      label: "[95301]Repair and maintenance of motor vehicles",
    },
    {
      value: "[95302]Car washing and related services",
      label: "[95302]Car washing and related services",
    },
    {
      value: "[95303]Motor vehicles inspection and valuation services",
      label: "[95303]Motor vehicles inspection and valuation services",
    },
    {
      value: "[96011]Laundry and dry cleaning services (except self-operated laundries)",
      label: "[96011]Laundry and dry cleaning services (except self-operated laundries)",
    },
    {
      value: "[96012]Self-operated laundries",
      label: "[96012]Self-operated laundries",
    },
    {
      value: "[96021]Hairdressing salons/shops",
      label: "[96021]Hairdressing salons/shops",
    },
    {
      value: "[96022]Beauty salons and spas",
      label: "[96022]Beauty salons and spas",
    },
    {
      value: "[96023]Manicure and pedicure services",
      label: "[96023]Manicure and pedicure services",
    },
    {
      value: "[96024]Massage parlours and foot reflexology",
      label: "[96024]Massage parlours and foot reflexology",
    },
    {
      value: "[96029]Beauty and other personal care services n.e.c.",
      label: "[96029]Beauty and other personal care services n.e.c.",
    },
    {
      value: "[96030]Funeral and related activities",
      label: "[96030]Funeral and related activities",
    },
    {
      value: "[96040]Wedding and related activities",
      label: "[96040]Wedding and related activities",
    },
    {
      value: "[96091]Friendship, match-making and dating services",
      label: "[96091]Friendship, match-making and dating services",
    },
    {
      value: "[96092]Social escort services",
      label: "[96092]Social escort services",
    },
    {
      value: "[96093]Astrology, palmistry and other fortune telling services",
      label: "[96093]Astrology, palmistry and other fortune telling services",
    },
    {
      value: "[96094]Training of pets",
      label: "[96094]Training of pets",
    },
    {
      value: "[96095]Care services for pets and animals",
      label: "[96095]Care services for pets and animals",
    },
    {
      value: "[96099]Other personal service activities n.e.c.",
      label: "[96099]Other personal service activities n.e.c.",
    },
    {
      value: "[97001]Activities of households as employers of domestic workers",
      label: "[97001]Activities of households as employers of domestic workers",
    },
    {
      value: "[97002]Activities of households as employers of other domestic personnel",
      label: "[97002]Activities of households as employers of other domestic personnel",
    },
    {
      value: "[99010]Foreign embassies and trade representative offices",
      label: "[99010]Foreign embassies and trade representative offices",
    },
    {
      value: "[99020]Foreign armed forces",
      label: "[99020]Foreign armed forces",
    },
    {
      value: "[99090]Other extra-territorial organisations and bodies",
      label: "[99090]Other extra-territorial organisations and bodies",
    },
  ],
  Malaysia: [
    // {
    //   value: "[00000]NOT APPLICABLE",
    //   "label": "[00000]NOT APPLICABLE",
    // },
    {
      value: "[01111]Growing of maize",
      label: "[01111]Growing of maize",
    },
    {
      value: "[01112]Growing of leguminous crops",
      label: "[01112]Growing of leguminous crops",
    },
    {
      value: "[01113]Growing of oil seeds",
      label: "[01113]Growing of oil seeds",
    },
    {
      value: "[01119]Growing of other cereals n.e.c.",
      label: "[01119]Growing of other cereals n.e.c.",
    },
    {
      value: "[01120]Growing of paddy",
      label: "[01120]Growing of paddy",
    },
    {
      value: "[01131]Growing of leafy or stem vegetables",
      label: "[01131]Growing of leafy or stem vegetables",
    },
    {
      value: "[01132]Growing of fruits bearing vegetables",
      label: "[01132]Growing of fruits bearing vegetables",
    },
    {
      value: "[01133]Growing of melons",
      label: "[01133]Growing of melons",
    },
    {
      value: "[01134]Growing of mushrooms and truffles",
      label: "[01134]Growing of mushrooms and truffles",
    },
    {
      value: "[01135]Growing of vegetables seeds, except beet seeds",
      label: "[01135]Growing of vegetables seeds, except beet seeds",
    },
    {
      value: "[01136]Growing of other vegetables",
      label: "[01136]Growing of other vegetables",
    },
    {
      value: "[01137]Growing of sugar beet",
      label: "[01137]Growing of sugar beet",
    },
    {
      value: "[01138]Growing of roots, tubers, bulb or tuberous vegetables",
      label: "[01138]Growing of roots, tubers, bulb or tuberous vegetables",
    },
    {
      value: "[01140]Growing of sugar cane",
      label: "[01140]Growing of sugar cane",
    },
    {
      value: "[01150]Growing of tobacco",
      label: "[01150]Growing of tobacco",
    },
    {
      value: "[01160]Growing of fibre crops",
      label: "[01160]Growing of fibre crops",
    },
    {
      value: "[01191]Growing of flowers",
      label: "[01191]Growing of flowers",
    },
    {
      value: "[01192]Growing of flower seeds",
      label: "[01192]Growing of flower seeds",
    },
    {
      value: "[01193]Growing of sago (rumbia)",
      label: "[01193]Growing of sago (rumbia)",
    },
    {
      value: "[01199]Growing of other non-perennial crops n.e.c.",
      label: "[01199]Growing of other non-perennial crops n.e.c.",
    },
    {
      value: "[01210]Growing of grapes",
      label: "[01210]Growing of grapes",
    },
    {
      value: "[01221]Growing of banana",
      label: "[01221]Growing of banana",
    },
    {
      value: "[01222]Growing of mango",
      label: "[01222]Growing of mango",
    },
    {
      value: "[01223]Growing of durian",
      label: "[01223]Growing of durian",
    },
    {
      value: "[01224]Growing of rambutan",
      label: "[01224]Growing of rambutan",
    },
    {
      value: "[01225]Growing of star fruit",
      label: "[01225]Growing of star fruit",
    },
    {
      value: "[01226]Growing of papaya",
      label: "[01226]Growing of papaya",
    },
    {
      value: "[01227]Growing of pineapple",
      label: "[01227]Growing of pineapple",
    },
    {
      value: "[01228]Growing of pitaya (dragon fruit)",
      label: "[01228]Growing of pitaya (dragon fruit)",
    },
    {
      value: "[01229]Growing of other tropical and subtropical fruits n.e.c.",
      label: "[01229]Growing of other tropical and subtropical fruits n.e.c.",
    },
    {
      value: "[01231]Growing of pomelo",
      label: "[01231]Growing of pomelo",
    },
    {
      value: "[01232]Growing of lemon and limes",
      label: "[01232]Growing of lemon and limes",
    },
    {
      value: "[01233]Growing of tangerines and mandarin",
      label: "[01233]Growing of tangerines and mandarin",
    },
    {
      value: "[01239]Growing of other citrus fruits n.e.c.",
      label: "[01239]Growing of other citrus fruits n.e.c.",
    },
    {
      value: "[01241]Growing of guava",
      label: "[01241]Growing of guava",
    },
    {
      value: "[01249]Growing of other pome fruits and stones fruits n.e.c.",
      label: "[01249]Growing of other pome fruits and stones fruits n.e.c.",
    },
    {
      value: "[01251]Growing of berries",
      label: "[01251]Growing of berries",
    },
    {
      value: "[01252]Growing of fruit seeds",
      label: "[01252]Growing of fruit seeds",
    },
    {
      value: "[01253]Growing of edible nuts",
      label: "[01253]Growing of edible nuts",
    },
    {
      value: "[01259]Growing of other tree and bush fruits",
      label: "[01259]Growing of other tree and bush fruits",
    },
    {
      value: "[01261]Growing of oil palm (estate)",
      label: "[01261]Growing of oil palm (estate)",
    },
    {
      value: "[01262]Growing of oil palm (smallholdings)",
      label: "[01262]Growing of oil palm (smallholdings)",
    },
    {
      value: "[01263]Growing of coconut (estate and smallholdings)",
      label: "[01263]Growing of coconut (estate and smallholdings)",
    },
    {
      value: "[01269]Growing of other oleaginous fruits n.e.c.",
      label: "[01269]Growing of other oleaginous fruits n.e.c.",
    },
    {
      value: "[01271]Growing of coffee",
      label: "[01271]Growing of coffee",
    },
    {
      value: "[01272]Growing of tea",
      label: "[01272]Growing of tea",
    },
    {
      value: "[01273]Growing of cocoa",
      label: "[01273]Growing of cocoa",
    },
    {
      value: "[01279]Growing of other beverage crops n.e.c.",
      label: "[01279]Growing of other beverage crops n.e.c.",
    },
    {
      value: "[01281]Growing of pepper (piper nigrum)",
      label: "[01281]Growing of pepper (piper nigrum)",
    },
    {
      value: "[01282]Growing of chilies and pepper (capsicum spp.)",
      label: "[01282]Growing of chilies and pepper (capsicum spp.)",
    },
    {
      value: "[01283]Growing of nutmeg",
      label: "[01283]Growing of nutmeg",
    },
    {
      value: "[01284]Growing of ginger",
      label: "[01284]Growing of ginger",
    },
    {
      value: "[01285]Growing of plants used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes",
      label: "[01285]Growing of plants used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes",
    },
    {
      value: "[01289]Growing of other spices and aromatic crops n.e.c.",
      label: "[01289]Growing of other spices and aromatic crops n.e.c.",
    },
    {
      value: "[01291]Growing  of rubber trees (estate)",
      label: "[01291]Growing  of rubber trees (estate)",
    },
    {
      value: "[01292]Growing of rubber trees (smallholdings)",
      label: "[01292]Growing of rubber trees (smallholdings)",
    },
    {
      value: "[01293]Growing of trees for extraction of sap",
      label: "[01293]Growing of trees for extraction of sap",
    },
    {
      value: "[01294]Growing of nipa palm",
      label: "[01294]Growing of nipa palm",
    },
    {
      value: "[01295]Growing of areca",
      label: "[01295]Growing of areca",
    },
    {
      value: "[01296]Growing of roselle",
      label: "[01296]Growing of roselle",
    },
    {
      value: "[01299]Growing of other perennial crops n.e.c.",
      label: "[01299]Growing of other perennial crops n.e.c.",
    },
    {
      value: "[01301]Growing of plants for planting",
      label: "[01301]Growing of plants for planting",
    },
    {
      value: "[01302]Growing of plants for ornamental purposes",
      label: "[01302]Growing of plants for ornamental purposes",
    },
    {
      value: "[01303]Growing of live plants for bulbs, tubers and roots; cuttings and slips; mushroom spawn",
      label: "[01303]Growing of live plants for bulbs, tubers and roots; cuttings and slips; mushroom spawn",
    },
    {
      value: "[01304]Operation of tree nurseries",
      label: "[01304]Operation of tree nurseries",
    },
    {
      value: "[01411]Raising, breeding and production of cattle or buffaloes",
      label: "[01411]Raising, breeding and production of cattle or buffaloes",
    },
    {
      value: "[01412]Production of raw milk from cows or buffaloes",
      label: "[01412]Production of raw milk from cows or buffaloes",
    },
    {
      value: "[01413]Production of bovine semen",
      label: "[01413]Production of bovine semen",
    },
    {
      value: "[01420]Raising and breeding of horses, asses, mules or hinnes",
      label: "[01420]Raising and breeding of horses, asses, mules or hinnes",
    },
    {
      value: "[01430]Raising and breeding of camels (dromedary) and camelids",
      label: "[01430]Raising and breeding of camels (dromedary) and camelids",
    },
    {
      value: "[01441]Raising, breeding and production of sheep and goats",
      label: "[01441]Raising, breeding and production of sheep and goats",
    },
    {
      value: "[01442]Production of raw sheep or goat’s milk",
      label: "[01442]Production of raw sheep or goat’s milk",
    },
    {
      value: "[01443]Production of raw wool",
      label: "[01443]Production of raw wool",
    },
    {
      value: "[01450]Raising, breeding and production of swine/pigs",
      label: "[01450]Raising, breeding and production of swine/pigs",
    },
    {
      value: "[01461]Raising, breeding and production of chicken, broiler",
      label: "[01461]Raising, breeding and production of chicken, broiler",
    },
    {
      value: "[01462]Raising, breeding and production of ducks",
      label: "[01462]Raising, breeding and production of ducks",
    },
    {
      value: "[01463]Raising, breeding and production of geese",
      label: "[01463]Raising, breeding and production of geese",
    },
    {
      value: "[01464]Raising, breeding and production of quails",
      label: "[01464]Raising, breeding and production of quails",
    },
    {
      value: "[01465]Raising and breeding of other poultry n.e.c.",
      label: "[01465]Raising and breeding of other poultry n.e.c.",
    },
    {
      value: "[01466]Production of chicken eggs",
      label: "[01466]Production of chicken eggs",
    },
    {
      value: "[01467]Production of duck eggs",
      label: "[01467]Production of duck eggs",
    },
    {
      value: "[01468]Production of other poultry eggs n.e.c.",
      label: "[01468]Production of other poultry eggs n.e.c.",
    },
    {
      value: "[01469]Operation of poultry hatcheries",
      label: "[01469]Operation of poultry hatcheries",
    },
    {
      value: "[01491]Raising, breeding and production of semi-domesticated",
      label: "[01491]Raising, breeding and production of semi-domesticated",
    },
    {
      value: "[01492]Production of fur skins, reptile or bird’s skin from ranching operation",
      label: "[01492]Production of fur skins, reptile or bird’s skin from ranching operation",
    },
    {
      value: "[01493]Operation of worm farms, land mollusc farms, snail farms",
      label: "[01493]Operation of worm farms, land mollusc farms, snail farms",
    },
    {
      value: "[01494]Raising of silk worms and production of silk worm cocoons",
      label: "[01494]Raising of silk worms and production of silk worm cocoons",
    },
    {
      value: "[01495]Bee keeping and production of honey and beeswax",
      label: "[01495]Bee keeping and production of honey and beeswax",
    },
    {
      value: "[01496]Raising and breeding of pet animals",
      label: "[01496]Raising and breeding of pet animals",
    },
    {
      value: "[01497]Raising and breeding of swiflet",
      label: "[01497]Raising and breeding of swiflet",
    },
    {
      value: "[01499]Raising of diverse/other animals n.e.c.",
      label: "[01499]Raising of diverse/other animals n.e.c.",
    },
    {
      value: "[01500]Mixed Farming",
      label: "[01500]Mixed Farming",
    },
    {
      value: "[01610]Agricultural activities for crops production on a fee or contract basis",
      label: "[01610]Agricultural activities for crops production on a fee or contract basis",
    },
    {
      value: "[01620]Agricultural activities for animal production on a fee or contract basis",
      label: "[01620]Agricultural activities for animal production on a fee or contract basis",
    },
    {
      value: "[01631]Preparation of crops for primary markets",
      label: "[01631]Preparation of crops for primary markets",
    },
    {
      value: "[01632]Preparation of tobacco leaves",
      label: "[01632]Preparation of tobacco leaves",
    },
    {
      value: "[01633]Preparation of cocoa beans",
      label: "[01633]Preparation of cocoa beans",
    },
    {
      value: "[01634]Sun-drying of fruits and vegetables",
      label: "[01634]Sun-drying of fruits and vegetables",
    },
    {
      value: "[01640]Seed processing for propagation",
      label: "[01640]Seed processing for propagation",
    },
    {
      value: "[01701]Hunting and trapping on a commercial basis",
      label: "[01701]Hunting and trapping on a commercial basis",
    },
    {
      value: "[01702]Taking of animals (dead or alive)",
      label: "[01702]Taking of animals (dead or alive)",
    },
    {
      value: "[02101]Planting, replanting, transplanting, thinning and conserving of forests and timber tracts",
      label: "[02101]Planting, replanting, transplanting, thinning and conserving of forests and timber tracts",
    },
    {
      value: "[02102]Growing of coppice, pulpwood and fire wood",
      label: "[02102]Growing of coppice, pulpwood and fire wood",
    },
    {
      value: "[02103]Operation of forest tree nurseries",
      label: "[02103]Operation of forest tree nurseries",
    },
    {
      value: "[02104]Collection and raising of wildings (peat swamp forest tree species)",
      label: "[02104]Collection and raising of wildings (peat swamp forest tree species)",
    },
    {
      value: "[02105]Forest plantation",
      label: "[02105]Forest plantation",
    },
    {
      value: "[02201]Production of round wood for forest-based manufacturing industries",
      label: "[02201]Production of round wood for forest-based manufacturing industries",
    },
    {
      value: "[02202]Production of round wood used in an unprocessed form",
      label: "[02202]Production of round wood used in an unprocessed form",
    },
    {
      value: "[02203]Production of charcoal in the forest (using traditional methods)",
      label: "[02203]Production of charcoal in the forest (using traditional methods)",
    },
    {
      value: "[02204]Rubber wood logging",
      label: "[02204]Rubber wood logging",
    },
    {
      value: "[02301]Collection of rattan, bamboo",
      label: "[02301]Collection of rattan, bamboo",
    },
    {
      value: "[02302]Bird’s nest collection",
      label: "[02302]Bird’s nest collection",
    },
    {
      value: "[02303]Wild sago palm collection",
      label: "[02303]Wild sago palm collection",
    },
    {
      value: "[02309]Gathering of non-wood forest products n.e.c.",
      label: "[02309]Gathering of non-wood forest products n.e.c.",
    },
    {
      value: "[02401]Carrying out part of the forestry and forest plantation operation on a fee or contract basis for forestry service activities",
      label: "[02401]Carrying out part of the forestry and forest plantation operation on a fee or contract basis for forestry service activities",
    },
    {
      value: "[02402]Carrying out part of the forestry operation on a fee or contract basis for logging service activities",
      label: "[02402]Carrying out part of the forestry operation on a fee or contract basis for logging service activities",
    },
    {
      value: "[03111]Fishing on a commercial basis in ocean and coastal waters",
      label: "[03111]Fishing on a commercial basis in ocean and coastal waters",
    },
    {
      value: "[03112]Collection of marine crustaceans and molluscs",
      label: "[03112]Collection of marine crustaceans and molluscs",
    },
    {
      value: "[03113]Taking of aquatic animals: sea squirts, tunicates, sea urchins",
      label: "[03113]Taking of aquatic animals: sea squirts, tunicates, sea urchins",
    },
    {
      value: "[03114]Activities of vessels engaged both in fishing and in processing and preserving of fish",
      label: "[03114]Activities of vessels engaged both in fishing and in processing and preserving of fish",
    },
    {
      value: "[03115]Gathering of other marine organisms and materials (natural pearls, sponges, coral and algae)",
      label: "[03115]Gathering of other marine organisms and materials (natural pearls, sponges, coral and algae)",
    },
    {
      value: "[03119]Marine fishing n.e.c.",
      label: "[03119]Marine fishing n.e.c.",
    },
    {
      value: "[03121]Fishing on a commercial basis in inland waters",
      label: "[03121]Fishing on a commercial basis in inland waters",
    },
    {
      value: "[03122]Taking of freshwater crustaceans and molluscs",
      label: "[03122]Taking of freshwater crustaceans and molluscs",
    },
    {
      value: "[03123]Taking of freshwater aquatic animals",
      label: "[03123]Taking of freshwater aquatic animals",
    },
    {
      value: "[03124]Gathering of freshwater flora and fauna",
      label: "[03124]Gathering of freshwater flora and fauna",
    },
    {
      value: "[03129]Freshwater fishing n.e.c.",
      label: "[03129]Freshwater fishing n.e.c.",
    },
    {
      value: "[03211]Fish farming in sea water",
      label: "[03211]Fish farming in sea water",
    },
    {
      value: "[03212]Production of bivalve spat (oyster, mussel), lobster lings, shrimp post-larvae, fish fry and fingerlings",
      label: "[03212]Production of bivalve spat (oyster, mussel), lobster lings, shrimp post-larvae, fish fry and fingerlings",
    },
    {
      value: "[03213]Growing of laver and other edible seaweeds",
      label: "[03213]Growing of laver and other edible seaweeds",
    },
    {
      value: "[03214]Culture of crustaceans, bivalves, other molluscs and other aquatic animals in sea water",
      label: "[03214]Culture of crustaceans, bivalves, other molluscs and other aquatic animals in sea water",
    },
    {
      value: "[03215]Aquaculture activities in brackish water",
      label: "[03215]Aquaculture activities in brackish water",
    },
    {
      value: "[03216]Aquaculture activities in salt water filled tanks or reservoirs",
      label: "[03216]Aquaculture activities in salt water filled tanks or reservoirs",
    },
    {
      value: "[03217]Operation of  hatcheries (marine)",
      label: "[03217]Operation of  hatcheries (marine)",
    },
    {
      value: "[03218]Operation of marine worm farms for fish feed",
      label: "[03218]Operation of marine worm farms for fish feed",
    },
    {
      value: "[03219]Marine aquaculture n.e.c.",
      label: "[03219]Marine aquaculture n.e.c.",
    },
    {
      value: "[03221]Fish farming in freshwater",
      label: "[03221]Fish farming in freshwater",
    },
    {
      value: "[03222]Shrimp farming in freshwater",
      label: "[03222]Shrimp farming in freshwater",
    },
    {
      value: "[03223]Culture of freshwater crustaceans, bivalves, other molluscs and other aquatic animals",
      label: "[03223]Culture of freshwater crustaceans, bivalves, other molluscs and other aquatic animals",
    },
    {
      value: "[03224]Operation of hatcheries (freshwater)",
      label: "[03224]Operation of hatcheries (freshwater)",
    },
    {
      value: "[03225]Farming of frogs",
      label: "[03225]Farming of frogs",
    },
    {
      value: "[03229]Freshwater aquaculture n.e.c.",
      label: "[03229]Freshwater aquaculture n.e.c.",
    },
    {
      value: "[05100]Mining of hard coal",
      label: "[05100]Mining of hard coal",
    },
    {
      value: "[05200]Mining of lignite (brown coal)",
      label: "[05200]Mining of lignite (brown coal)",
    },
    {
      value: "[06101]Extraction of crude petroleum oils",
      label: "[06101]Extraction of crude petroleum oils",
    },
    {
      value: "[06102]Extraction of bituminous or oil shale and tar sand",
      label: "[06102]Extraction of bituminous or oil shale and tar sand",
    },
    {
      value: "[06103]Production of crude petroleum from bituminous shale and sand",
      label: "[06103]Production of crude petroleum from bituminous shale and sand",
    },
    {
      value: "[06104]Processes to obtain crude oils",
      label: "[06104]Processes to obtain crude oils",
    },
    {
      value: "[06201]Production of crude gaseous hydrocarbon (natural gas)",
      label: "[06201]Production of crude gaseous hydrocarbon (natural gas)",
    },
    {
      value: "[06202]Extraction of condensates",
      label: "[06202]Extraction of condensates",
    },
    {
      value: "[06203]Draining and separation of liquid hydrocarbon fractions",
      label: "[06203]Draining and separation of liquid hydrocarbon fractions",
    },
    {
      value: "[06204]Gas desulphurization",
      label: "[06204]Gas desulphurization",
    },
    {
      value: "[06205]Mining of hydrocarbon liquids, obtain through liquefaction or pyrolysis",
      label: "[06205]Mining of hydrocarbon liquids, obtain through liquefaction or pyrolysis",
    },
    {
      value: "[07101]Mining of ores valued chiefly for iron content",
      label: "[07101]Mining of ores valued chiefly for iron content",
    },
    {
      value: "[07102]Beneficiation and agglomeration of iron ores",
      label: "[07102]Beneficiation and agglomeration of iron ores",
    },
    {
      value: "[07210]Mining of uranium and thorium ores",
      label: "[07210]Mining of uranium and thorium ores",
    },
    {
      value: "[07291]Mining of tin ores",
      label: "[07291]Mining of tin ores",
    },
    {
      value: "[07292]Mining of copper",
      label: "[07292]Mining of copper",
    },
    {
      value: "[07293]Mining of bauxite (aluminium)",
      label: "[07293]Mining of bauxite (aluminium)",
    },
    {
      value: "[07294]Mining of ilmenite",
      label: "[07294]Mining of ilmenite",
    },
    {
      value: "[07295]Mining of gold",
      label: "[07295]Mining of gold",
    },
    {
      value: "[07296]Mining of silver",
      label: "[07296]Mining of silver",
    },
    {
      value: "[07297]Mining of platinum",
      label: "[07297]Mining of platinum",
    },
    {
      value: "[07298]Amang retreatment",
      label: "[07298]Amang retreatment",
    },
    {
      value: "[07299]Mining of other non-ferrous metal ores n.e.c.",
      label: "[07299]Mining of other non-ferrous metal ores n.e.c.",
    },
    {
      value: "[08101]Quarrying, rough trimming and sawing of monumental and building stone such as marble, granite (dimension stone), sandstone",
      label: "[08101]Quarrying, rough trimming and sawing of monumental and building stone such as marble, granite (dimension stone), sandstone",
    },
    {
      value: "[08102]Quarrying, crushing and breaking of limestone",
      label: "[08102]Quarrying, crushing and breaking of limestone",
    },
    {
      value: "[08103]Mining of gypsum and anhydrite",
      label: "[08103]Mining of gypsum and anhydrite",
    },
    {
      value: "[08104]Mining of chalk and uncalcined dolomite",
      label: "[08104]Mining of chalk and uncalcined dolomite",
    },
    {
      value: "[08105]Extraction and dredging of industrial sand, sand for construction and gravel",
      label: "[08105]Extraction and dredging of industrial sand, sand for construction and gravel",
    },
    {
      value: "[08106]Breaking and crushing of stone and gravel",
      label: "[08106]Breaking and crushing of stone and gravel",
    },
    {
      value: "[08107]Quarrying of sand",
      label: "[08107]Quarrying of sand",
    },
    {
      value: "[08108]Mining of clays, refractory clays and kaolin",
      label: "[08108]Mining of clays, refractory clays and kaolin",
    },
    {
      value: "[08109]Quarrying, crushing and breaking of granite",
      label: "[08109]Quarrying, crushing and breaking of granite",
    },
    {
      value: "[08911]Mining of natural phosphates",
      label: "[08911]Mining of natural phosphates",
    },
    {
      value: "[08912]Mining of natural potassium salts",
      label: "[08912]Mining of natural potassium salts",
    },
    {
      value: "[08913]Mining of native sulphur",
      label: "[08913]Mining of native sulphur",
    },
    {
      value: "[08914]Extraction and preparation of pyrites and pyrrhotite, except roasting",
      label: "[08914]Extraction and preparation of pyrites and pyrrhotite, except roasting",
    },
    {
      value: "[08915]Mining of natural barium sulphate and carbonate (barytes and witherite)",
      label: "[08915]Mining of natural barium sulphate and carbonate (barytes and witherite)",
    },
    {
      value: "[08916]Mining of natural borates, natural magnesium sulphates (kieserite)",
      label: "[08916]Mining of natural borates, natural magnesium sulphates (kieserite)",
    },
    {
      value: "[08917]Mining of earth colours, fluorspar and other minerals valued chiefly as a source of chemicals",
      label: "[08917]Mining of earth colours, fluorspar and other minerals valued chiefly as a source of chemicals",
    },
    {
      value: "[08918]Guano mining",
      label: "[08918]Guano mining",
    },
    {
      value: "[08921]Peat digging",
      label: "[08921]Peat digging",
    },
    {
      value: "[08922]Peat agglomeration",
      label: "[08922]Peat agglomeration",
    },
    {
      value: "[08923]Preparation of peat to improve quality or facilitate transport or storage",
      label: "[08923]Preparation of peat to improve quality or facilitate transport or storage",
    },
    {
      value: "[08931]Extraction of salt from underground",
      label: "[08931]Extraction of salt from underground",
    },
    {
      value: "[08932]Salt production by evaporation of sea water or other saline waters",
      label: "[08932]Salt production by evaporation of sea water or other saline waters",
    },
    {
      value: "[08933]Crushing, purification and refining of salt by the producer",
      label: "[08933]Crushing, purification and refining of salt by the producer",
    },
    {
      value: "[08991]Mining and quarrying of abrasive materials",
      label: "[08991]Mining and quarrying of abrasive materials",
    },
    {
      value: "[08992]Mining and quarrying of asbestos",
      label: "[08992]Mining and quarrying of asbestos",
    },
    {
      value: "[08993]Mining and quarrying of siliceous fossil meals",
      label: "[08993]Mining and quarrying of siliceous fossil meals",
    },
    {
      value: "[08994]Mining and quarrying of natural graphite",
      label: "[08994]Mining and quarrying of natural graphite",
    },
    {
      value: "[08995]Mining and quarrying of steatite (talc)",
      label: "[08995]Mining and quarrying of steatite (talc)",
    },
    {
      value: "[08996]Mining and quarrying of gemstones",
      label: "[08996]Mining and quarrying of gemstones",
    },
    {
      value: "[08999]Other mining and quarrying n.e.c.",
      label: "[08999]Other mining and quarrying n.e.c.",
    },
    {
      value: "[09101]Oil and gas extraction service activities provided on a fee or contract basis",
      label: "[09101]Oil and gas extraction service activities provided on a fee or contract basis",
    },
    {
      value: "[09102]Oil and gas field fire fighting services",
      label: "[09102]Oil and gas field fire fighting services",
    },
    {
      value: "[09900]Support activities for other mining and quarrying",
      label: "[09900]Support activities for other mining and quarrying",
    },
    {
      value: "[10101]Processing and preserving of meat and production of meat products",
      label: "[10101]Processing and preserving of meat and production of meat products",
    },
    {
      value: "[10102]Processing and preserving of poultry and poultry products",
      label: "[10102]Processing and preserving of poultry and poultry products",
    },
    {
      value: "[10103]Production of hides and skins originating from slaughterhouses",
      label: "[10103]Production of hides and skins originating from slaughterhouses",
    },
    {
      value: "[10104]Operation of slaughterhouses engaged in killing, houses dressing or packing meat",
      label: "[10104]Operation of slaughterhouses engaged in killing, houses dressing or packing meat",
    },
    {
      value: "[10109]Processing and preserving of meat n.e.c.",
      label: "[10109]Processing and preserving of meat n.e.c.",
    },
    {
      value: "[10201]Canning of fish, crustaceans and mollusks",
      label: "[10201]Canning of fish, crustaceans and mollusks",
    },
    {
      value: "[10202]Processing, curing and preserving of fish, crustacean and molluscs",
      label: "[10202]Processing, curing and preserving of fish, crustacean and molluscs",
    },
    {
      value: "[10203]Production of fish meals for human consumption or animal feed",
      label: "[10203]Production of fish meals for human consumption or animal feed",
    },
    {
      value: "[10204]Production of keropok including keropok lekor",
      label: "[10204]Production of keropok including keropok lekor",
    },
    {
      value: "[10205]Processing of seaweed",
      label: "[10205]Processing of seaweed",
    },
    {
      value: "[10301]Manufacture of fruits and vegetable food products",
      label: "[10301]Manufacture of fruits and vegetable food products",
    },
    {
      value: "[10302]Manufacture of fruit and vegetable juices",
      label: "[10302]Manufacture of fruit and vegetable juices",
    },
    {
      value: "[10303]Pineapple canning",
      label: "[10303]Pineapple canning",
    },
    {
      value: "[10304]Manufacture of jams, marmalades and table jellies",
      label: "[10304]Manufacture of jams, marmalades and table jellies",
    },
    {
      value: "[10305]Manufacture of nuts and nut products",
      label: "[10305]Manufacture of nuts and nut products",
    },
    {
      value: "[10306]Manufacture of bean curd products",
      label: "[10306]Manufacture of bean curd products",
    },
    {
      value: "[10401]Manufacture of crude palm oil",
      label: "[10401]Manufacture of crude palm oil",
    },
    {
      value: "[10402]Manufacture of refined palm oil",
      label: "[10402]Manufacture of refined palm oil",
    },
    {
      value: "[10403]Manufacture of palm kernel oil",
      label: "[10403]Manufacture of palm kernel oil",
    },
    {
      value: "[10404]Manufacture of crude and refined vegetable oil",
      label: "[10404]Manufacture of crude and refined vegetable oil",
    },
    {
      value: "[10405]Manufacture of coconut oil",
      label: "[10405]Manufacture of coconut oil",
    },
    {
      value: "[10406]Manufacture of compound cooking fats",
      label: "[10406]Manufacture of compound cooking fats",
    },
    {
      value: "[10407]Manufacture of animal oils and fats",
      label: "[10407]Manufacture of animal oils and fats",
    },
    {
      value: "[10501]Manufacture of ice cream and other edible ice such as sorbet",
      label: "[10501]Manufacture of ice cream and other edible ice such as sorbet",
    },
    {
      value: "[10502]Manufacture of condensed, powdered and evaporated milk",
      label: "[10502]Manufacture of condensed, powdered and evaporated milk",
    },
    {
      value: "[10509]Manufacture of other dairy products n.e.c.",
      label: "[10509]Manufacture of other dairy products n.e.c.",
    },
    {
      value: "[10611]Rice milling",
      label: "[10611]Rice milling",
    },
    {
      value: "[10612]Provision of milling services",
      label: "[10612]Provision of milling services",
    },
    {
      value: "[10613]Flour milling",
      label: "[10613]Flour milling",
    },
    {
      value: "[10619]Manufacture of grain mill products n.e.c.",
      label: "[10619]Manufacture of grain mill products n.e.c.",
    },
    {
      value: "[10621]Manufacture of starches and starch products",
      label: "[10621]Manufacture of starches and starch products",
    },
    {
      value: "[10622]Manufacture of glucose, glucose syrup, maltose, inulin",
      label: "[10622]Manufacture of glucose, glucose syrup, maltose, inulin",
    },
    {
      value: "[10623]Manufacture of sago and tapioca flour/products",
      label: "[10623]Manufacture of sago and tapioca flour/products",
    },
    {
      value: "[10711]Manufacture of biscuits and cookies",
      label: "[10711]Manufacture of biscuits and cookies",
    },
    {
      value: "[10712]Manufacture of bread, cakes and other bakery products",
      label: "[10712]Manufacture of bread, cakes and other bakery products",
    },
    {
      value: "[10713]Manufacture of snack products",
      label: "[10713]Manufacture of snack products",
    },
    {
      value: "[10714]Manufacture of frozen bakery products",
      label: "[10714]Manufacture of frozen bakery products",
    },
    {
      value: "[10721]Manufacture of sugar",
      label: "[10721]Manufacture of sugar",
    },
    {
      value: "[10722]Manufacture of sugar products",
      label: "[10722]Manufacture of sugar products",
    },
    {
      value: "[10731]Manufacture of cocoa products",
      label: "[10731]Manufacture of cocoa products",
    },
    {
      value: "[10732]Manufacture of chocolate and chocolate products",
      label: "[10732]Manufacture of chocolate and chocolate products",
    },
    {
      value: "[10733]Manufacture of sugar confectionery",
      label: "[10733]Manufacture of sugar confectionery",
    },
    {
      value: "[10741]Manufacture of meehoon, noodles and other related products",
      label: "[10741]Manufacture of meehoon, noodles and other related products",
    },
    {
      value: "[10742]Manufacture of pastas",
      label: "[10742]Manufacture of pastas",
    },
    {
      value: "[10750]Manufacture of prepared meals and dishes",
      label: "[10750]Manufacture of prepared meals and dishes",
    },
    {
      value: "[10791]Manufacture of coffee",
      label: "[10791]Manufacture of coffee",
    },
    {
      value: "[10792]Manufacture of tea",
      label: "[10792]Manufacture of tea",
    },
    {
      value: "[10793]Manufacture of sauces and condiments",
      label: "[10793]Manufacture of sauces and condiments",
    },
    {
      value: "[10794]Manufacture of spices and curry powder",
      label: "[10794]Manufacture of spices and curry powder",
    },
    {
      value: "[10795]Manufacture of egg products",
      label: "[10795]Manufacture of egg products",
    },
    {
      value: "[10799]Manufacture of other food products n.e.c.",
      label: "[10799]Manufacture of other food products n.e.c.",
    },
    {
      value: "[10800]Manufacture of prepared animal feeds",
      label: "[10800]Manufacture of prepared animal feeds",
    },
    {
      value: "[11010]Distilling, rectifying and blending of spirits",
      label: "[11010]Distilling, rectifying and blending of spirits",
    },
    {
      value: "[11020]Manufacture of wines",
      label: "[11020]Manufacture of wines",
    },
    {
      value: "[11030]Manufacture of malt liquors and malt",
      label: "[11030]Manufacture of malt liquors and malt",
    },
    {
      value: "[11041]Manufacture of soft drinks",
      label: "[11041]Manufacture of soft drinks",
    },
    {
      value: "[11042]Production of natural mineral water and other bottled water",
      label: "[11042]Production of natural mineral water and other bottled water",
    },
    {
      value: "[12000]MANUFACTURE OF TOBACCO PRODUCTS",
      label: "[12000]MANUFACTURE OF TOBACCO PRODUCTS",
    },
    {
      value: "[13110]Preparation and spinning of textile fibres",
      label: "[13110]Preparation and spinning of textile fibres",
    },
    {
      value: "[13120]Weaving of textiles",
      label: "[13120]Weaving of textiles",
    },
    {
      value: "[13131]Batik making",
      label: "[13131]Batik making",
    },
    {
      value: "[13132]Dyeing, bleaching, printing and finishing of yarns and fabrics",
      label: "[13132]Dyeing, bleaching, printing and finishing of yarns and fabrics",
    },
    {
      value: "[13139]Other finishing textiles",
      label: "[13139]Other finishing textiles",
    },
    {
      value: "[13910]Manufacture of knitted and crocheted fabrics",
      label: "[13910]Manufacture of knitted and crocheted fabrics",
    },
    {
      value: "[13921]Manufacture of made-up articles of any textile materials, including of knitted or crocheted fabrics",
      label: "[13921]Manufacture of made-up articles of any textile materials, including of knitted or crocheted fabrics",
    },
    {
      value: "[13922]Manufacture of made-up furnishing articles",
      label: "[13922]Manufacture of made-up furnishing articles",
    },
    {
      value: "[13930]Manufacture of carpets and rugs",
      label: "[13930]Manufacture of carpets and rugs",
    },
    {
      value: "[13940]Manufacture of cordage, rope, twine and netting",
      label: "[13940]Manufacture of cordage, rope, twine and netting",
    },
    {
      value: "[13990]Manufacture of other textiles n.e.c.",
      label: "[13990]Manufacture of other textiles n.e.c.",
    },
    {
      value: "[14101]Manufacture of specific wearing apparel",
      label: "[14101]Manufacture of specific wearing apparel",
    },
    {
      value: "[14102]Manufacture of clothings",
      label: "[14102]Manufacture of clothings",
    },
    {
      value: "[14103]Custom tailoring",
      label: "[14103]Custom tailoring",
    },
    {
      value: "[14109]Manufacture of other clothing accessories",
      label: "[14109]Manufacture of other clothing accessories",
    },
    {
      value: "[14200]Manufacture of articles made of fur skins",
      label: "[14200]Manufacture of articles made of fur skins",
    },
    {
      value: "[14300]Manufacture of knitted and crocheted apparel",
      label: "[14300]Manufacture of knitted and crocheted apparel",
    },
    {
      value: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
      label: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
    },
    {
      value: "[15120]Manufacture of luggage, handbags and the like, saddlery and harness",
      label: "[15120]Manufacture of luggage, handbags and the like, saddlery and harness",
    },
    {
      value: "[15201]Manufacture of leather footwear",
      label: "[15201]Manufacture of leather footwear",
    },
    {
      value: "[15202]Manufacture of plastic footwear",
      label: "[15202]Manufacture of plastic footwear",
    },
    {
      value: "[15203]Manufacture of rubber footwear",
      label: "[15203]Manufacture of rubber footwear",
    },
    {
      value: "[15209]Manufacture of other footwear n.e.c.",
      label: "[15209]Manufacture of other footwear n.e.c.",
    },
    {
      value: "[16100]Sawmilling and planning of wood",
      label: "[16100]Sawmilling and planning of wood",
    },
    {
      value: "[16211]Manufacture of veneer sheets and plywood",
      label: "[16211]Manufacture of veneer sheets and plywood",
    },
    {
      value: "[16212]Manufacture of particle board and fibreboard",
      label: "[16212]Manufacture of particle board and fibreboard",
    },
    {
      value: "[16221]Manufacture of builders’ carpentry",
      label: "[16221]Manufacture of builders’ carpentry",
    },
    {
      value: "[16222]Manufacture of joinery wood products",
      label: "[16222]Manufacture of joinery wood products",
    },
    {
      value: "[16230]Manufacture of wooden containers",
      label: "[16230]Manufacture of wooden containers",
    },
    {
      value: "[16291]Manufacture of wood charcoal",
      label: "[16291]Manufacture of wood charcoal",
    },
    {
      value: "[16292]Manufacture of other products of wood, cane, articles of cork, straw and plaiting materials",
      label: "[16292]Manufacture of other products of wood, cane, articles of cork, straw and plaiting materials",
    },
    {
      value: "[17010]Manufacture of pulp, paper and paperboard",
      label: "[17010]Manufacture of pulp, paper and paperboard",
    },
    {
      value: "[17020]Manufacture of corrugated paper and paperboard and of containers of paper and paperboard",
      label: "[17020]Manufacture of corrugated paper and paperboard and of containers of paper and paperboard",
    },
    {
      value: "[17091]Manufacture of envelopes and letter-card",
      label: "[17091]Manufacture of envelopes and letter-card",
    },
    {
      value: "[17092]Manufacture of household and personal hygiene paper",
      label: "[17092]Manufacture of household and personal hygiene paper",
    },
    {
      value: "[17093]Manufacture of gummed or adhesive paper in strips or rolls and labels and wall paper",
      label: "[17093]Manufacture of gummed or adhesive paper in strips or rolls and labels and wall paper",
    },
    {
      value: "[17094]Manufacture of effigies, funeral paper goods, joss paper",
      label: "[17094]Manufacture of effigies, funeral paper goods, joss paper",
    },
    {
      value: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
      label: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
    },
    {
      value: "[18110]Printing",
      label: "[18110]Printing",
    },
    {
      value: "[18120]Service activities related to printing",
      label: "[18120]Service activities related to printing",
    },
    {
      value: "[18200]Reproduction of recorded media",
      label: "[18200]Reproduction of recorded media",
    },
    {
      value: "[19100]Manufacture of coke oven products",
      label: "[19100]Manufacture of coke oven products",
    },
    {
      value: "[19201]Manufacture of refined petroleum products",
      label: "[19201]Manufacture of refined petroleum products",
    },
    {
      value: "[19202]Manufacture of bio-diesel products",
      label: "[19202]Manufacture of bio-diesel products",
    },
    {
      value: "[20111]Manufacture of liquefied or compressed inorganic industrial or medical gases",
      label: "[20111]Manufacture of liquefied or compressed inorganic industrial or medical gases",
    },
    {
      value: "[20112]Manufacture of basic organic chemicals",
      label: "[20112]Manufacture of basic organic chemicals",
    },
    {
      value: "[20113]Manufacture of inorganic compounds",
      label: "[20113]Manufacture of inorganic compounds",
    },
    {
      value: "[20119]Manufacture of other basic chemicals n.e.c.",
      label: "[20119]Manufacture of other basic chemicals n.e.c.",
    },
    {
      value: "[20121]Manufacture of fertilizers",
      label: "[20121]Manufacture of fertilizers",
    },
    {
      value: "[20129]Manufacture of associated nitrogen products",
      label: "[20129]Manufacture of associated nitrogen products",
    },
    {
      value: "[20131]Manufacture of plastic in primary forms",
      label: "[20131]Manufacture of plastic in primary forms",
    },
    {
      value: "[20132]Manufacture of synthetic rubber in primary forms: synthetic rubber, factice",
      label: "[20132]Manufacture of synthetic rubber in primary forms: synthetic rubber, factice",
    },
    {
      value: "[20133]Manufacture of mixtures of synthetic rubber and natural rubber or rubber - like gums",
      label: "[20133]Manufacture of mixtures of synthetic rubber and natural rubber or rubber - like gums",
    },
    {
      value: "[20210]Manufacture of pesticides and other agrochemical products",
      label: "[20210]Manufacture of pesticides and other agrochemical products",
    },
    {
      value: "[20221]Manufacture of paints, varnishes and similar coatings ink and mastics",
      label: "[20221]Manufacture of paints, varnishes and similar coatings ink and mastics",
    },
    {
      value: "[20222]Manufacture of printing ink",
      label: "[20222]Manufacture of printing ink",
    },
    {
      value: "[20231]Manufacture of soap and detergents, cleaning and polishing preparations",
      label: "[20231]Manufacture of soap and detergents, cleaning and polishing preparations",
    },
    {
      value: "[20232]Manufacture of perfumes and toilet preparations",
      label: "[20232]Manufacture of perfumes and toilet preparations",
    },
    {
      value: "[20291]Manufacture of photographic plates, films, sensitized paper and other sensitized unexposed materials",
      label: "[20291]Manufacture of photographic plates, films, sensitized paper and other sensitized unexposed materials",
    },
    {
      value: "[20292]Manufacture of writing and drawing ink",
      label: "[20292]Manufacture of writing and drawing ink",
    },
    {
      value: "[20299]Manufacture of other chemical products n.e.c.",
      label: "[20299]Manufacture of other chemical products n.e.c.",
    },
    {
      value: "[20300]Manufacture of man-made fibres",
      label: "[20300]Manufacture of man-made fibres",
    },
    {
      value: "[21001]Manufacture of medicinal active substances to be used for their pharmacological properties in the manufacture of medicaments",
      label: "[21001]Manufacture of medicinal active substances to be used for their pharmacological properties in the manufacture of medicaments",
    },
    {
      value: "[21002]Processing of blood",
      label: "[21002]Processing of blood",
    },
    {
      value: "[21003]Manufacture of medicaments",
      label: "[21003]Manufacture of medicaments",
    },
    {
      value: "[21004]Manufacture of chemical contraceptive products",
      label: "[21004]Manufacture of chemical contraceptive products",
    },
    {
      value: "[21005]Manufacture of medical diagnostic preparation",
      label: "[21005]Manufacture of medical diagnostic preparation",
    },
    {
      value: "[21006]Manufacture of radioactive in-vivo diagnostic substances",
      label: "[21006]Manufacture of radioactive in-vivo diagnostic substances",
    },
    {
      value: "[21007]Manufacture of biotech pharmaceuticals",
      label: "[21007]Manufacture of biotech pharmaceuticals",
    },
    {
      value: "[21009]Manufacture of other pharmaceuticals, medicinal chemical and botanical products n.e.c.",
      label: "[21009]Manufacture of other pharmaceuticals, medicinal chemical and botanical products n.e.c.",
    },
    {
      value: "[22111]Manufacture of rubber tyres for vehicles",
      label: "[22111]Manufacture of rubber tyres for vehicles",
    },
    {
      value: "[22112]Manufacture of interchangeable tyre treads and retreading rubber tyres",
      label: "[22112]Manufacture of interchangeable tyre treads and retreading rubber tyres",
    },
    {
      value: "[22191]Manufacture of other products of natural or synthetic rubber, unvulcanized, vulcanized or hardened",
      label: "[22191]Manufacture of other products of natural or synthetic rubber, unvulcanized, vulcanized or hardened",
    },
    {
      value: "[22192]Manufacture of rubber gloves",
      label: "[22192]Manufacture of rubber gloves",
    },
    {
      value: "[22193]Rubber remilling and latex processing",
      label: "[22193]Rubber remilling and latex processing",
    },
    {
      value: "[22199]Manufacture of other rubber products n.e.c",
      label: "[22199]Manufacture of other rubber products n.e.c",
    },
    {
      value: "[22201]Manufacture of semi-manufactures of plastic products",
      label: "[22201]Manufacture of semi-manufactures of plastic products",
    },
    {
      value: "[22202]Manufacture of finished plastic products",
      label: "[22202]Manufacture of finished plastic products",
    },
    {
      value: "[22203]Manufacture of plastic articles for the packing of goods",
      label: "[22203]Manufacture of plastic articles for the packing of goods",
    },
    {
      value: "[22204]Manufacture of builders’ plastics ware",
      label: "[22204]Manufacture of builders’ plastics ware",
    },
    {
      value: "[22205]Manufacture of plastic tableware, kitchenware and toilet articles",
      label: "[22205]Manufacture of plastic tableware, kitchenware and toilet articles",
    },
    {
      value: "[22209]Manufacture of diverse plastic products n.e.c.",
      label: "[22209]Manufacture of diverse plastic products n.e.c.",
    },
    {
      value: "[23101]Manufacture of flat glass, including wired, coloured or tinted flat glass",
      label: "[23101]Manufacture of flat glass, including wired, coloured or tinted flat glass",
    },
    {
      value: "[23102]Manufacture of laboratory, hygienic or pharmaceutical glassware",
      label: "[23102]Manufacture of laboratory, hygienic or pharmaceutical glassware",
    },
    {
      value: "[23109]Manufacture of other glass products n.e.c.",
      label: "[23109]Manufacture of other glass products n.e.c.",
    },
    {
      value: "[23911]Manufacture of refractory mortars and concretes",
      label: "[23911]Manufacture of refractory mortars and concretes",
    },
    {
      value: "[23912]Manufacture of refractory ceramic goods",
      label: "[23912]Manufacture of refractory ceramic goods",
    },
    {
      value: "[23921]Manufacture of non-refractory ceramic",
      label: "[23921]Manufacture of non-refractory ceramic",
    },
    {
      value: "[23929]Manufacture of other clay building materials",
      label: "[23929]Manufacture of other clay building materials",
    },
    {
      value: "[23930]Manufacture of other porcelain and ceramic products",
      label: "[23930]Manufacture of other porcelain and ceramic products",
    },
    {
      value: "[23941]Manufacture of hydraulic cement",
      label: "[23941]Manufacture of hydraulic cement",
    },
    {
      value: "[23942]Manufacture of lime and plaster",
      label: "[23942]Manufacture of lime and plaster",
    },
    {
      value: "[23951]Manufacture of ready-mix and dry-mix concrete and mortars",
      label: "[23951]Manufacture of ready-mix and dry-mix concrete and mortars",
    },
    {
      value: "[23952]Manufacture of precast concrete, cement or artificial stone articles for use in construction",
      label: "[23952]Manufacture of precast concrete, cement or artificial stone articles for use in construction",
    },
    {
      value: "[23953]Manufacture of prefabricated structural components for building or civil engineering of cement, concrete or artificial stone",
      label: "[23953]Manufacture of prefabricated structural components for building or civil engineering of cement, concrete or artificial stone",
    },
    {
      value: "[23959]Manufacture of other articles of concrete, cement and plaster n.e.c.",
      label: "[23959]Manufacture of other articles of concrete, cement and plaster n.e.c.",
    },
    {
      value: "[23960]Cutting, shaping and finishing of stone",
      label: "[23960]Cutting, shaping and finishing of stone",
    },
    {
      value: "[23990]Manufacture of other non-metallic mineral products n.e.c.",
      label: "[23990]Manufacture of other non-metallic mineral products n.e.c.",
    },
    {
      value: "[24101]Production of pig iron and spiegeleisen in pigs, blocks or other primary forms",
      label: "[24101]Production of pig iron and spiegeleisen in pigs, blocks or other primary forms",
    },
    {
      value: "[24102]Production of bars and rods of stainless steel or other alloy steel",
      label: "[24102]Production of bars and rods of stainless steel or other alloy steel",
    },
    {
      value: "[24103]Manufacture of seamless tubes, by hot rolling, hot extrusion or hot drawing, or by cold drawing or cold rolling",
      label: "[24103]Manufacture of seamless tubes, by hot rolling, hot extrusion or hot drawing, or by cold drawing or cold rolling",
    },
    {
      value: "[24104]Manufacture of steel tube fittings",
      label: "[24104]Manufacture of steel tube fittings",
    },
    {
      value: "[24109]Manufacture of other basic iron and steel products n.e.c.",
      label: "[24109]Manufacture of other basic iron and steel products n.e.c.",
    },
    {
      value: "[24201]Tin smelting",
      label: "[24201]Tin smelting",
    },
    {
      value: "[24202]Production of aluminium from alumina",
      label: "[24202]Production of aluminium from alumina",
    },
    {
      value: "[24209]Manufacture of other basic precious and other non-ferrous metals n.e.c.",
      label: "[24209]Manufacture of other basic precious and other non-ferrous metals n.e.c.",
    },
    {
      value: "[24311]Casting of iron",
      label: "[24311]Casting of iron",
    },
    {
      value: "[24312]Casting of steel",
      label: "[24312]Casting of steel",
    },
    {
      value: "[24320]Casting of non-ferrous metals",
      label: "[24320]Casting of non-ferrous metals",
    },
    {
      value: "[25111]Manufacture of industrial frameworks in metal",
      label: "[25111]Manufacture of industrial frameworks in metal",
    },
    {
      value: "[25112]Manufacture of prefabricated buildings mainly of metal",
      label: "[25112]Manufacture of prefabricated buildings mainly of metal",
    },
    {
      value: "[25113]Manufacture of metal doors, windows and their frames, shutters and gates",
      label: "[25113]Manufacture of metal doors, windows and their frames, shutters and gates",
    },
    {
      value: "[25119]Manufacture of other structural metal products",
      label: "[25119]Manufacture of other structural metal products",
    },
    {
      value: "[25120]Manufacture of tanks, reservoirs and containers of metal",
      label: "[25120]Manufacture of tanks, reservoirs and containers of metal",
    },
    {
      value: "[25130]Manufacture of steam generators, except central heating hot water boilers",
      label: "[25130]Manufacture of steam generators, except central heating hot water boilers",
    },
    {
      value: "[25200]Manufacture of weapons and ammunition",
      label: "[25200]Manufacture of weapons and ammunition",
    },
    {
      value: "[25910]Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
      label: "[25910]Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
    },
    {
      value: "[25920]Treatment and coating of metals; machining",
      label: "[25920]Treatment and coating of metals; machining",
    },
    {
      value: "[25930]Manufacture of cutlery, hand tools and general hardware",
      label: "[25930]Manufacture of cutlery, hand tools and general hardware",
    },
    {
      value: "[25991]Manufacture of tins and cans for food products, collapsible tubes and boxes",
      label: "[25991]Manufacture of tins and cans for food products, collapsible tubes and boxes",
    },
    {
      value: "[25992]Manufacture of metal cable, plaited bands and similar articles",
      label: "[25992]Manufacture of metal cable, plaited bands and similar articles",
    },
    {
      value: "[25993]Manufacture of bolts, screws, nuts and similar threaded products",
      label: "[25993]Manufacture of bolts, screws, nuts and similar threaded products",
    },
    {
      value: "[25994]Manufacture of metal household articles",
      label: "[25994]Manufacture of metal household articles",
    },
    {
      value: "[25999]Manufacture of any other fabricated metal products n.e.c.",
      label: "[25999]Manufacture of any other fabricated metal products n.e.c.",
    },
    {
      value: "[26101]Manufacture of diodes, transistors and similar semiconductor devices",
      label: "[26101]Manufacture of diodes, transistors and similar semiconductor devices",
    },
    {
      value: "[26102]Manufacture electronic integrated circuits micro assemblies",
      label: "[26102]Manufacture electronic integrated circuits micro assemblies",
    },
    {
      value: "[26103]Manufacture of electrical capacitors and resistors",
      label: "[26103]Manufacture of electrical capacitors and resistors",
    },
    {
      value: "[26104]Manufacture of printed circuit boards",
      label: "[26104]Manufacture of printed circuit boards",
    },
    {
      value: "[26105]Manufacture of display components",
      label: "[26105]Manufacture of display components",
    },
    {
      value: "[26109]Manufacture of other components for electronic applications",
      label: "[26109]Manufacture of other components for electronic applications",
    },
    {
      value: "[26201]Manufacture of computers",
      label: "[26201]Manufacture of computers",
    },
    {
      value: "[26202]Manufacture of peripheral equipment",
      label: "[26202]Manufacture of peripheral equipment",
    },
    {
      value: "[26300]Manufacture of communication equipment",
      label: "[26300]Manufacture of communication equipment",
    },
    {
      value: "[26400]Manufacture of consumer electronics",
      label: "[26400]Manufacture of consumer electronics",
    },
    {
      value: "[26511]Manufacture of measuring, testing, navigating and control equipment",
      label: "[26511]Manufacture of measuring, testing, navigating and control equipment",
    },
    {
      value: "[26512]Manufacture of industrial process control equipment",
      label: "[26512]Manufacture of industrial process control equipment",
    },
    {
      value: "[26520]Manufacture of watches and clocks and parts",
      label: "[26520]Manufacture of watches and clocks and parts",
    },
    {
      value: "[26600]Manufacture of irradiation, electro medical and electrotherapeutic equipment",
      label: "[26600]Manufacture of irradiation, electro medical and electrotherapeutic equipment",
    },
    {
      value: "[26701]Manufacture of optical instruments and equipment",
      label: "[26701]Manufacture of optical instruments and equipment",
    },
    {
      value: "[26702]Manufacture of photographic equipment",
      label: "[26702]Manufacture of photographic equipment",
    },
    {
      value: "[26800]Manufacture of magnetic and optical recording media",
      label: "[26800]Manufacture of magnetic and optical recording media",
    },
    {
      value: "[27101]Manufacture of electric motors, generators and transformers",
      label: "[27101]Manufacture of electric motors, generators and transformers",
    },
    {
      value: "[27102]Manufacture of electricity distribution and control apparatus",
      label: "[27102]Manufacture of electricity distribution and control apparatus",
    },
    {
      value: "[27200]Manufacture of batteries and accumulators",
      label: "[27200]Manufacture of batteries and accumulators",
    },
    {
      value: "[27310]Manufacture of fibre optic cables",
      label: "[27310]Manufacture of fibre optic cables",
    },
    {
      value: "[27320]Manufacture of other electronic and electric wires and cables",
      label: "[27320]Manufacture of other electronic and electric wires and cables",
    },
    {
      value: "[27330]Manufacture of current-carrying and non current-carrying wiring devices for electrical circuits regardless of material",
      label: "[27330]Manufacture of current-carrying and non current-carrying wiring devices for electrical circuits regardless of material",
    },
    {
      value: "[27400]Manufacture of electric lighting equipment",
      label: "[27400]Manufacture of electric lighting equipment",
    },
    {
      value: "[27500]Manufacture of domestic appliances",
      label: "[27500]Manufacture of domestic appliances",
    },
    {
      value:
        "[27900]Manufacture of miscellaneous electrical equipment other than motors, generators and transformers, batteries and accumulators, wires and wiring devices, lighting equipment or domestic appliances",
      label:
        "[27900]Manufacture of miscellaneous electrical equipment other than motors, generators and transformers, batteries and accumulators, wires and wiring devices, lighting equipment or domestic appliances",
    },
    {
      value: "[28110]Manufacture of engines and turbines, except aircraft, vehicle and cycle engines",
      label: "[28110]Manufacture of engines and turbines, except aircraft, vehicle and cycle engines",
    },
    {
      value: "[28120]Manufacture of fluid power equipment",
      label: "[28120]Manufacture of fluid power equipment",
    },
    {
      value: "[28130]Manufacture of other pumps, compressors, taps and valves",
      label: "[28130]Manufacture of other pumps, compressors, taps and valves",
    },
    {
      value: "[28140]Manufacture of bearings, gears, gearing and driving elements",
      label: "[28140]Manufacture of bearings, gears, gearing and driving elements",
    },
    {
      value: "[28150]Manufacture of ovens, furnaces and furnace burners",
      label: "[28150]Manufacture of ovens, furnaces and furnace burners",
    },
    {
      value: "[28160]Manufacture of lifting and handling equipment",
      label: "[28160]Manufacture of lifting and handling equipment",
    },
    {
      value: "[28170]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
      label: "[28170]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
    },
    {
      value: "[28180]Manufacture of power-driven hand tools with self-contained electric or non-electric motor or pneumatic drives",
      label: "[28180]Manufacture of power-driven hand tools with self-contained electric or non-electric motor or pneumatic drives",
    },
    {
      value: "[28191]Manufacture of refrigerating or freezing industrial equipment",
      label: "[28191]Manufacture of refrigerating or freezing industrial equipment",
    },
    {
      value: "[28192]Manufacture of air-conditioning machines, including for motor vehicles",
      label: "[28192]Manufacture of air-conditioning machines, including for motor vehicles",
    },
    {
      value: "[28199]Manufacture of other general-purpose machinery n.e.c.",
      label: "[28199]Manufacture of other general-purpose machinery n.e.c.",
    },
    {
      value: "[28210]Manufacture of agricultural and forestry machinery",
      label: "[28210]Manufacture of agricultural and forestry machinery",
    },
    {
      value: "[28220]Manufacture of metal-forming machinery and machine tools",
      label: "[28220]Manufacture of metal-forming machinery and machine tools",
    },
    {
      value: "[28230]Manufacture of machinery for metallurgy",
      label: "[28230]Manufacture of machinery for metallurgy",
    },
    {
      value: "[28240]Manufacture of machinery for mining, quarrying and construction",
      label: "[28240]Manufacture of machinery for mining, quarrying and construction",
    },
    {
      value: "[28250]Manufacture of machinery for food, beverage and tobacco processing",
      label: "[28250]Manufacture of machinery for food, beverage and tobacco processing",
    },
    {
      value: "[28260]Manufacture of machinery for textile, apparel and leather production",
      label: "[28260]Manufacture of machinery for textile, apparel and leather production",
    },
    {
      value: "[28290]Manufacture of other special-purpose machinery n.e.c.",
      label: "[28290]Manufacture of other special-purpose machinery n.e.c.",
    },
    {
      value: "[29101]Manufacture of passenger cars",
      label: "[29101]Manufacture of passenger cars",
    },
    {
      value: "[29102]Manufacture of commercial vehicles",
      label: "[29102]Manufacture of commercial vehicles",
    },
    {
      value: "[29200]Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi- trailers",
      label: "[29200]Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi- trailers",
    },
    {
      value: "[29300]Manufacture of parts and accessories for motor vehicles",
      label: "[29300]Manufacture of parts and accessories for motor vehicles",
    },
    {
      value: "[30110]Building of ships and floating structures",
      label: "[30110]Building of ships and floating structures",
    },
    {
      value: "[30120]Building of pleasure and sporting boats",
      label: "[30120]Building of pleasure and sporting boats",
    },
    {
      value: "[30200]Manufacture of railway locomotives and rolling stock",
      label: "[30200]Manufacture of railway locomotives and rolling stock",
    },
    {
      value: "[30300]Manufacture of air and spacecraft and related machinery",
      label: "[30300]Manufacture of air and spacecraft and related machinery",
    },
    {
      value: "[30400]Manufacture of military fighting vehicles",
      label: "[30400]Manufacture of military fighting vehicles",
    },
    {
      value: "[30910]Manufacture of motorcycles",
      label: "[30910]Manufacture of motorcycles",
    },
    {
      value: "[30920]Manufacture of bicycles and invalid carriages",
      label: "[30920]Manufacture of bicycles and invalid carriages",
    },
    {
      value: "[30990]Manufacture of other transport equipments n.e.c.",
      label: "[30990]Manufacture of other transport equipments n.e.c.",
    },
    {
      value: "[31001]Manufacture of wooden and cane furniture",
      label: "[31001]Manufacture of wooden and cane furniture",
    },
    {
      value: "[31002]Manufacture of metal furniture",
      label: "[31002]Manufacture of metal furniture",
    },
    {
      value: "[31003]Manufacture of mattress",
      label: "[31003]Manufacture of mattress",
    },
    {
      value: "[31009]Manufacture of other furniture, except of stone, concrete or ceramic",
      label: "[31009]Manufacture of other furniture, except of stone, concrete or ceramic",
    },
    {
      value: "[32110]Manufacture of jewellery and related articles",
      label: "[32110]Manufacture of jewellery and related articles",
    },
    {
      value: "[32120]Manufacture of imitation jewellery and related articles",
      label: "[32120]Manufacture of imitation jewellery and related articles",
    },
    {
      value: "[32200]Manufacture of musical instruments",
      label: "[32200]Manufacture of musical instruments",
    },
    {
      value: "[32300]Manufacture of sports goods",
      label: "[32300]Manufacture of sports goods",
    },
    {
      value: "[32400]Manufacture of games and toys",
      label: "[32400]Manufacture of games and toys",
    },
    {
      value: "[32500]Manufacture of medical and dental instrument and supplies",
      label: "[32500]Manufacture of medical and dental instrument and supplies",
    },
    {
      value: "[32901]Manufacture of stationery",
      label: "[32901]Manufacture of stationery",
    },
    {
      value: "[32909]Other manufacturing n.e.c.",
      label: "[32909]Other manufacturing n.e.c.",
    },
    {
      value: "[33110]Repair of fabricated metal products",
      label: "[33110]Repair of fabricated metal products",
    },
    {
      value: "[33120]Repair and maintenance of industrial machinery and equipment",
      label: "[33120]Repair and maintenance of industrial machinery and equipment",
    },
    {
      value: "[33131]Repair and maintenance of the measuring, testing, navigating and control equipment",
      label: "[33131]Repair and maintenance of the measuring, testing, navigating and control equipment",
    },
    {
      value: "[33132]Repair and maintenance of irradiation, electro medical and electrotherapeutic equipment",
      label: "[33132]Repair and maintenance of irradiation, electro medical and electrotherapeutic equipment",
    },
    {
      value: "[33133]Repair of optical instruments and photographic equipment",
      label: "[33133]Repair of optical instruments and photographic equipment",
    },
    {
      value: "[33140]Repair and maintenance of electrical equipment except domestic appliances",
      label: "[33140]Repair and maintenance of electrical equipment except domestic appliances",
    },
    {
      value: "[33150]Repair and maintenance of transport equipment except motorcycles and bicycles",
      label: "[33150]Repair and maintenance of transport equipment except motorcycles and bicycles",
    },
    {
      value: "[33190]Repair and maintenance of other equipment n.e.c.",
      label: "[33190]Repair and maintenance of other equipment n.e.c.",
    },
    {
      value: "[33200]Installation of industrial machinery and equipment",
      label: "[33200]Installation of industrial machinery and equipment",
    },
    {
      value: "[35101]Operation of generation facilities that produce electric energy",
      label: "[35101]Operation of generation facilities that produce electric energy",
    },
    {
      value: "[35102]Operation of transmission, distribution and sales of electricity",
      label: "[35102]Operation of transmission, distribution and sales of electricity",
    },
    {
      value:
        "[35201]Manufacture of gaseous fuels with a specified calorific value, by purification, blending and other processes from gases of various types including natural gas",
      label:
        "[35201]Manufacture of gaseous fuels with a specified calorific value, by purification, blending and other processes from gases of various types including natural gas",
    },
    {
      value: "[35202]Transportation, distribution and supply of gaseous fuels of all kinds through a system of mains",
      label: "[35202]Transportation, distribution and supply of gaseous fuels of all kinds through a system of mains",
    },
    {
      value: "[35203]Sale of gas to the user through mains",
      label: "[35203]Sale of gas to the user through mains",
    },
    {
      value: "[35301]Production, collection and distribution of steam and hot water for heating, power and other purposes",
      label: "[35301]Production, collection and distribution of steam and hot water for heating, power and other purposes",
    },
    {
      value: "[35302]Production and distribution of cooled air, chilled water for cooling purposes",
      label: "[35302]Production and distribution of cooled air, chilled water for cooling purposes",
    },
    {
      value: "[35303]Production of ice, including ice for food and non-food (e.g. cooling) purposes",
      label: "[35303]Production of ice, including ice for food and non-food (e.g. cooling) purposes",
    },
    {
      value: "[36001]Purification and distribution of water for water supply purposes",
      label: "[36001]Purification and distribution of water for water supply purposes",
    },
    {
      value: "[36002]Desalting of sea or ground water to produce water as the principal product of interest",
      label: "[36002]Desalting of sea or ground water to produce water as the principal product of interest",
    },
    {
      value: "[37000]Sewerage and similar activities",
      label: "[37000]Sewerage and similar activities",
    },
    {
      value: "[38111]Collection of non-hazardous solid waste (i.e. garbage) within a local area",
      label: "[38111]Collection of non-hazardous solid waste (i.e. garbage) within a local area",
    },
    {
      value: "[38112]Collection of recyclable materials",
      label: "[38112]Collection of recyclable materials",
    },
    {
      value: "[38113]Collection of refuse in litter-bins in public places",
      label: "[38113]Collection of refuse in litter-bins in public places",
    },
    {
      value: "[38114]Collection of construction and demolition waste",
      label: "[38114]Collection of construction and demolition waste",
    },
    {
      value: "[38115]Operation of waste transfer stations for non-hazardous waste",
      label: "[38115]Operation of waste transfer stations for non-hazardous waste",
    },
    {
      value: "[38121]Collection of hazardous waste",
      label: "[38121]Collection of hazardous waste",
    },
    {
      value: "[38122]Operation of waste transfer stations for hazardous waste",
      label: "[38122]Operation of waste transfer stations for hazardous waste",
    },
    {
      value: "[38210]Treatment and disposal of non-hazardous waste",
      label: "[38210]Treatment and disposal of non-hazardous waste",
    },
    {
      value: "[38220]Treatment and disposal of hazardous waste",
      label: "[38220]Treatment and disposal of hazardous waste",
    },
    {
      value: "[38301]Mechanical crushing of metal waste",
      label: "[38301]Mechanical crushing of metal waste",
    },
    {
      value: "[38302]Dismantling of automobiles, computers, televisions and other equipment for material recover",
      label: "[38302]Dismantling of automobiles, computers, televisions and other equipment for material recover",
    },
    {
      value: "[38303]Reclaiming of rubber such as used tires to produce secondary raw material",
      label: "[38303]Reclaiming of rubber such as used tires to produce secondary raw material",
    },
    {
      value: "[38304]Reuse of rubber products",
      label: "[38304]Reuse of rubber products",
    },
    {
      value: "[38309]Materials recovery n.e.c.",
      label: "[38309]Materials recovery n.e.c.",
    },
    {
      value: "[39000]Remediation activities and other waste management services",
      label: "[39000]Remediation activities and other waste management services",
    },
    {
      value: "[41001]Residential buildings",
      label: "[41001]Residential buildings",
    },
    {
      value: "[41002]Non-residential buildings",
      label: "[41002]Non-residential buildings",
    },
    {
      value: "[41003]Assembly and erection of prefabricated constructions on the site",
      label: "[41003]Assembly and erection of prefabricated constructions on the site",
    },
    {
      value: "[41009]Construction of buildings n.e.c.",
      label: "[41009]Construction of buildings n.e.c.",
    },
    {
      value: "[42101]Construction of motorways, streets, roads, other vehicular and pedestrian ways",
      label: "[42101]Construction of motorways, streets, roads, other vehicular and pedestrian ways",
    },
    {
      value: "[42102]Surface work on streets, roads, highways, bridges or tunnels",
      label: "[42102]Surface work on streets, roads, highways, bridges or tunnels",
    },
    {
      value: "[42103]Construction of bridges, including those for elevated highways",
      label: "[42103]Construction of bridges, including those for elevated highways",
    },
    {
      value: "[42104]Construction of tunnels",
      label: "[42104]Construction of tunnels",
    },
    {
      value: "[42105]Construction of railways and subways",
      label: "[42105]Construction of railways and subways",
    },
    {
      value: "[42106]Construction of airfield/airports runways",
      label: "[42106]Construction of airfield/airports runways",
    },
    {
      value: "[42109]Construction of roads and railways n.e.c.",
      label: "[42109]Construction of roads and railways n.e.c.",
    },
    {
      value: "[42201]Long-distance pipelines, communication and power lines",
      label: "[42201]Long-distance pipelines, communication and power lines",
    },
    {
      value: "[42202]Urban pipelines, urban communication and power lines; ancillary urban works",
      label: "[42202]Urban pipelines, urban communication and power lines; ancillary urban works",
    },
    {
      value: "[42203]Water main and line construction",
      label: "[42203]Water main and line construction",
    },
    {
      value: "[42204]Reservoirs",
      label: "[42204]Reservoirs",
    },
    {
      value: "[42205]Construction of irrigation systems (canals)",
      label: "[42205]Construction of irrigation systems (canals)",
    },
    {
      value: "[42206]Construction of sewer systems (including repair) and sewage disposal plants",
      label: "[42206]Construction of sewer systems (including repair) and sewage disposal plants",
    },
    {
      value: "[42207]Construction of power plants",
      label: "[42207]Construction of power plants",
    },
    {
      value: "[42209]Construction of utility projects n.e.c.",
      label: "[42209]Construction of utility projects n.e.c.",
    },
    {
      value: "[42901]Construction of refineries",
      label: "[42901]Construction of refineries",
    },
    {
      value: "[42902]Construction of waterways, harbour and river works, pleasure ports (marinas), locks",
      label: "[42902]Construction of waterways, harbour and river works, pleasure ports (marinas), locks",
    },
    {
      value: "[42903]Construction of dams and dykes",
      label: "[42903]Construction of dams and dykes",
    },
    {
      value: "[42904]Dredging of waterways",
      label: "[42904]Dredging of waterways",
    },
    {
      value: "[42905]Outdoor sports facilities",
      label: "[42905]Outdoor sports facilities",
    },
    {
      value: "[42906]Land subdivision with land improvement",
      label: "[42906]Land subdivision with land improvement",
    },
    {
      value: "[42909]Construction of other engineering projects n.e.c.",
      label: "[42909]Construction of other engineering projects n.e.c.",
    },
    {
      value: "[43110]Demolition or wrecking of buildings and other structures",
      label: "[43110]Demolition or wrecking of buildings and other structures",
    },
    {
      value: "[43121]Clearing of building sites",
      label: "[43121]Clearing of building sites",
    },
    {
      value: "[43122]Earth moving",
      label: "[43122]Earth moving",
    },
    {
      value: "[43123]Drilling, boring and core sampling for construction, geophysical, geological or similar purposes",
      label: "[43123]Drilling, boring and core sampling for construction, geophysical, geological or similar purposes",
    },
    {
      value: "[43124]Site preparation for mining",
      label: "[43124]Site preparation for mining",
    },
    {
      value: "[43125]Drainage of agricultural or forestry land",
      label: "[43125]Drainage of agricultural or forestry land",
    },
    {
      value: "[43126]Land reclamation work",
      label: "[43126]Land reclamation work",
    },
    {
      value: "[43129]Other site preparation activities n.e.c.",
      label: "[43129]Other site preparation activities n.e.c.",
    },
    {
      value: "[43211]Electrical wiring and fittings",
      label: "[43211]Electrical wiring and fittings",
    },
    {
      value: "[43212]Telecommunications wiring",
      label: "[43212]Telecommunications wiring",
    },
    {
      value: "[43213]Computer network and cable television wiring",
      label: "[43213]Computer network and cable television wiring",
    },
    {
      value: "[43214]Satellite dishes",
      label: "[43214]Satellite dishes",
    },
    {
      value: "[43215]Lighting systems",
      label: "[43215]Lighting systems",
    },
    {
      value: "[43216]Security systems",
      label: "[43216]Security systems",
    },
    {
      value: "[43219]Electrical installation n.e.c.",
      label: "[43219]Electrical installation n.e.c.",
    },
    {
      value: "[43221]Installation of heating systems (electric, gas and oil)",
      label: "[43221]Installation of heating systems (electric, gas and oil)",
    },
    {
      value: "[43222]Installation of furnaces, cooling towers",
      label: "[43222]Installation of furnaces, cooling towers",
    },
    {
      value: "[43223]Installation of non-electric solar energy collectors",
      label: "[43223]Installation of non-electric solar energy collectors",
    },
    {
      value: "[43224]Installation of plumbing and sanitary equipment",
      label: "[43224]Installation of plumbing and sanitary equipment",
    },
    {
      value: "[43225]Installation of ventilation, refrigeration or air-conditioning equipment and ducts",
      label: "[43225]Installation of ventilation, refrigeration or air-conditioning equipment and ducts",
    },
    {
      value: "[43226]Installation of gas fittings",
      label: "[43226]Installation of gas fittings",
    },
    {
      value: "[43227]Installation of fire and lawn sprinkler systems",
      label: "[43227]Installation of fire and lawn sprinkler systems",
    },
    {
      value: "[43228]Steam piping",
      label: "[43228]Steam piping",
    },
    {
      value: "[43229]Plumbing, heat and air-conditioning installation n.e.c.",
      label: "[43229]Plumbing, heat and air-conditioning installation n.e.c.",
    },
    {
      value: "[43291]Installation of elevators, escalators in buildings or other construction projects",
      label: "[43291]Installation of elevators, escalators in buildings or other construction projects",
    },
    {
      value: "[43292]Installation of automated and revolving doors in buildings or other construction projects",
      label: "[43292]Installation of automated and revolving doors in buildings or other construction projects",
    },
    {
      value: "[43293]Installation of lighting conductors in buildings or other construction projects",
      label: "[43293]Installation of lighting conductors in buildings or other construction projects",
    },
    {
      value: "[43294]Installation vacuum cleaning systems in buildings or other construction projects",
      label: "[43294]Installation vacuum cleaning systems in buildings or other construction projects",
    },
    {
      value: "[43295]Installation thermal, sound or vibration insulation in buildings or other construction projects",
      label: "[43295]Installation thermal, sound or vibration insulation in buildings or other construction projects",
    },
    {
      value: "[43299]Other construction installation n.e.c.",
      label: "[43299]Other construction installation n.e.c.",
    },
    {
      value:
        "[43301]Installation of doors, windows, door and window frames of wood or other materials, fitted kitchens, staircases, shop fittings and furniture",
      label:
        "[43301]Installation of doors, windows, door and window frames of wood or other materials, fitted kitchens, staircases, shop fittings and furniture",
    },
    {
      value: "[43302]Laying, tiling, hanging or fitting in buildings or other construction projects of various types of materials",
      label: "[43302]Laying, tiling, hanging or fitting in buildings or other construction projects of various types of materials",
    },
    {
      value: "[43303]Interior and exterior painting of buildings",
      label: "[43303]Interior and exterior painting of buildings",
    },
    {
      value: "[43304]Painting of civil engineering structures",
      label: "[43304]Painting of civil engineering structures",
    },
    {
      value: "[43305]Installation of glass, mirrors",
      label: "[43305]Installation of glass, mirrors",
    },
    {
      value: "[43306]Interior completion",
      label: "[43306]Interior completion",
    },
    {
      value: "[43307]Cleaning of new buildings after construction",
      label: "[43307]Cleaning of new buildings after construction",
    },
    {
      value: "[43309]Other building completion and finishing work n.e.c.",
      label: "[43309]Other building completion and finishing work n.e.c.",
    },
    {
      value: "[43901]Construction of foundations, including pile driving",
      label: "[43901]Construction of foundations, including pile driving",
    },
    {
      value: "[43902]Erection of non-self-manufactured steel elements",
      label: "[43902]Erection of non-self-manufactured steel elements",
    },
    {
      value: "[43903]Scaffolds and work platform erecting and dismantling",
      label: "[43903]Scaffolds and work platform erecting and dismantling",
    },
    {
      value: "[43904]Bricklaying and stone setting",
      label: "[43904]Bricklaying and stone setting",
    },
    {
      value: "[43905]Construction of outdoor swimming pools",
      label: "[43905]Construction of outdoor swimming pools",
    },
    {
      value: "[43906]Steam cleaning, sand blasting and similar activities for building exteriors",
      label: "[43906]Steam cleaning, sand blasting and similar activities for building exteriors",
    },
    {
      value: "[43907]Renting of construction machinery and equipment with operator (e.g. cranes)",
      label: "[43907]Renting of construction machinery and equipment with operator (e.g. cranes)",
    },
    {
      value: "[43909]Other specialized construction activities, n.e.c.",
      label: "[43909]Other specialized construction activities, n.e.c.",
    },
    {
      value: "[45101]Wholesale and retail of new motor vehicles",
      label: "[45101]Wholesale and retail of new motor vehicles",
    },
    {
      value: "[45102]Wholesale and retail of used motor vehicles",
      label: "[45102]Wholesale and retail of used motor vehicles",
    },
    {
      value: "[45103]Sale of industrial, commercial and agriculture vehicles – new",
      label: "[45103]Sale of industrial, commercial and agriculture vehicles – new",
    },
    {
      value: "[45104]Sale of industrial, commercial and agriculture vehicles – used",
      label: "[45104]Sale of industrial, commercial and agriculture vehicles – used",
    },
    {
      value: "[45105]Sale by commission agents",
      label: "[45105]Sale by commission agents",
    },
    {
      value: "[45106]Car auctions",
      label: "[45106]Car auctions",
    },
    {
      value: "[45109]Sale of other motor vehicles n.e.c.",
      label: "[45109]Sale of other motor vehicles n.e.c.",
    },
    {
      value: "[45201]Maintenance and repair of motor vehicles",
      label: "[45201]Maintenance and repair of motor vehicles",
    },
    {
      value: "[45202]Spraying and painting",
      label: "[45202]Spraying and painting",
    },
    {
      value: "[45203]Washing and polishing (car wash)",
      label: "[45203]Washing and polishing (car wash)",
    },
    {
      value: "[45204]Repair of motor vehicle seats",
      label: "[45204]Repair of motor vehicle seats",
    },
    {
      value: "[45205]Installation of parts and accessories not as part of the manufacturing process",
      label: "[45205]Installation of parts and accessories not as part of the manufacturing process",
    },
    {
      value: "[45300]Wholesale and retail sale of all kinds of parts, components, supplies, tools and accessories for motor vehicles",
      label: "[45300]Wholesale and retail sale of all kinds of parts, components, supplies, tools and accessories for motor vehicles",
    },
    {
      value: "[45401]Wholesale and retail sale of motorcycles",
      label: "[45401]Wholesale and retail sale of motorcycles",
    },
    {
      value: "[45402]Wholesale and retail sale of parts and accessories for motorcycles",
      label: "[45402]Wholesale and retail sale of parts and accessories for motorcycles",
    },
    {
      value: "[45403]Repair and maintenance of motorcycles",
      label: "[45403]Repair and maintenance of motorcycles",
    },
    {
      value: "[46100]Wholesale on a fee or contract basis",
      label: "[46100]Wholesale on a fee or contract basis",
    },
    {
      value: "[46201]Wholesale of rubber",
      label: "[46201]Wholesale of rubber",
    },
    {
      value: "[46202]Wholesale of palm oil",
      label: "[46202]Wholesale of palm oil",
    },
    {
      value: "[46203]Wholesale of lumber and timber",
      label: "[46203]Wholesale of lumber and timber",
    },
    {
      value: "[46204]Wholesale of flowers and plants",
      label: "[46204]Wholesale of flowers and plants",
    },
    {
      value: "[46205]Wholesale of livestock",
      label: "[46205]Wholesale of livestock",
    },
    {
      value: "[46209]Wholesale of agricultural raw material and live animal n.e.c.",
      label: "[46209]Wholesale of agricultural raw material and live animal n.e.c.",
    },
    {
      value: "[46311]Wholesale of meat, poultry and eggs",
      label: "[46311]Wholesale of meat, poultry and eggs",
    },
    {
      value: "[46312]Wholesale of fish and other seafood",
      label: "[46312]Wholesale of fish and other seafood",
    },
    {
      value: "[46313]Wholesale of fruits",
      label: "[46313]Wholesale of fruits",
    },
    {
      value: "[46314]Wholesale of vegetables",
      label: "[46314]Wholesale of vegetables",
    },
    {
      value: "[46319]Wholesale of meat, fish, fruits and vegetables n.e.c.",
      label: "[46319]Wholesale of meat, fish, fruits and vegetables n.e.c.",
    },
    {
      value: "[46321]Wholesale of rice, other grains, flour and sugars",
      label: "[46321]Wholesale of rice, other grains, flour and sugars",
    },
    {
      value: "[46322]Wholesale of dairy products",
      label: "[46322]Wholesale of dairy products",
    },
    {
      value: "[46323]Wholesale of confectionary",
      label: "[46323]Wholesale of confectionary",
    },
    {
      value: "[46324]Wholesale of  biscuits, cakes, breads and other bakery products",
      label: "[46324]Wholesale of  biscuits, cakes, breads and other bakery products",
    },
    {
      value: "[46325]Wholesale of coffee, tea, cocoa and other beverages",
      label: "[46325]Wholesale of coffee, tea, cocoa and other beverages",
    },
    {
      value: "[46326]Wholesale of beer, wine and spirits",
      label: "[46326]Wholesale of beer, wine and spirits",
    },
    {
      value: "[46327]Wholesale of tobacco, cigar, cigarettes",
      label: "[46327]Wholesale of tobacco, cigar, cigarettes",
    },
    {
      value: "[46329]Wholesale of other foodstuffs",
      label: "[46329]Wholesale of other foodstuffs",
    },
    {
      value: "[46411]Wholesale of yarn and fabrics",
      label: "[46411]Wholesale of yarn and fabrics",
    },
    {
      value: "[46412]Wholesale of household linen, towels, blankets",
      label: "[46412]Wholesale of household linen, towels, blankets",
    },
    {
      value: "[46413]Wholesale of clothing",
      label: "[46413]Wholesale of clothing",
    },
    {
      value: "[46414]Wholesale of clothing accessories",
      label: "[46414]Wholesale of clothing accessories",
    },
    {
      value: "[46415]Wholesale of fur articles",
      label: "[46415]Wholesale of fur articles",
    },
    {
      value: "[46416]Wholesale of footwear",
      label: "[46416]Wholesale of footwear",
    },
    {
      value: "[46417]Wholesale of haberdashery",
      label: "[46417]Wholesale of haberdashery",
    },
    {
      value: "[46419]Wholesale of textiles, clothing n.e.c.",
      label: "[46419]Wholesale of textiles, clothing n.e.c.",
    },
    {
      value: "[46421]Wholesale of pharmaceutical and medical goods",
      label: "[46421]Wholesale of pharmaceutical and medical goods",
    },
    {
      value: "[46422]Wholesale of perfumeries, cosmetics, soap and toiletries",
      label: "[46422]Wholesale of perfumeries, cosmetics, soap and toiletries",
    },
    {
      value: "[46431]Wholesale of bicycles and their parts and accessories",
      label: "[46431]Wholesale of bicycles and their parts and accessories",
    },
    {
      value: "[46432]Wholesale of photographic and optical goods",
      label: "[46432]Wholesale of photographic and optical goods",
    },
    {
      value: "[46433]Wholesale of leather goods and travel accessories",
      label: "[46433]Wholesale of leather goods and travel accessories",
    },
    {
      value: "[46434]Wholesale of musical instruments, games and toys, sports goods",
      label: "[46434]Wholesale of musical instruments, games and toys, sports goods",
    },
    {
      value: "[46441]Wholesale of handicrafts and artificial flowers",
      label: "[46441]Wholesale of handicrafts and artificial flowers",
    },
    {
      value: "[46442]Wholesale of cut flowers and plants",
      label: "[46442]Wholesale of cut flowers and plants",
    },
    {
      value: "[46443]Wholesale of watches and clocks",
      label: "[46443]Wholesale of watches and clocks",
    },
    {
      value: "[46444]Wholesale of jewellery",
      label: "[46444]Wholesale of jewellery",
    },
    {
      value: "[46491]Wholesale of household furniture",
      label: "[46491]Wholesale of household furniture",
    },
    {
      value: "[46492]Wholesale of household appliances",
      label: "[46492]Wholesale of household appliances",
    },
    {
      value: "[46493]Wholesale of lighting equipment",
      label: "[46493]Wholesale of lighting equipment",
    },
    {
      value: "[46494]Wholesale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
      label: "[46494]Wholesale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
    },
    {
      value: "[46495]Wholesale of woodenware, wickerwork and corkware",
      label: "[46495]Wholesale of woodenware, wickerwork and corkware",
    },
    {
      value: "[46496]Wholesale of electrical and electronic goods",
      label: "[46496]Wholesale of electrical and electronic goods",
    },
    {
      value: "[46497]Wholesale of stationery, books, magazines and newspapers",
      label: "[46497]Wholesale of stationery, books, magazines and newspapers",
    },
    {
      value: "[46499]Wholesale of other household goods n.e.c.",
      label: "[46499]Wholesale of other household goods n.e.c.",
    },
    {
      value: "[46510]Wholesale of computer hardware, software and peripherals",
      label: "[46510]Wholesale of computer hardware, software and peripherals",
    },
    {
      value: "[46521]Wholesale of telephone and telecommunications equipment, cell phones, pagers",
      label: "[46521]Wholesale of telephone and telecommunications equipment, cell phones, pagers",
    },
    {
      value: "[46522]Wholesale of electronic components and wiring accessories",
      label: "[46522]Wholesale of electronic components and wiring accessories",
    },
    {
      value: "[46531]Wholesale of agricultural machinery, equipment and supplies",
      label: "[46531]Wholesale of agricultural machinery, equipment and supplies",
    },
    {
      value: "[46532]Wholesale of lawn mowers however operated",
      label: "[46532]Wholesale of lawn mowers however operated",
    },
    {
      value: "[46591]Wholesale of office machinery and business equipment, except computers and computer peripheral equipment",
      label: "[46591]Wholesale of office machinery and business equipment, except computers and computer peripheral equipment",
    },
    {
      value: "[46592]Wholesale of office furniture",
      label: "[46592]Wholesale of office furniture",
    },
    {
      value: "[46593]Wholesale of computer-controlled machines tools",
      label: "[46593]Wholesale of computer-controlled machines tools",
    },
    {
      value: "[46594]Wholesale of industrial machinery, equipment and supplies",
      label: "[46594]Wholesale of industrial machinery, equipment and supplies",
    },
    {
      value: "[46595]Wholesale of construction and civil engineering machinery and equipment",
      label: "[46595]Wholesale of construction and civil engineering machinery and equipment",
    },
    {
      value: "[46596]Wholesale of lift escalators, air-conditioning, security and fire fighting equipment",
      label: "[46596]Wholesale of lift escalators, air-conditioning, security and fire fighting equipment",
    },
    {
      value: "[46599]Wholesale of other machinery for use in industry, trade and navigation and other services n.e.c.",
      label: "[46599]Wholesale of other machinery for use in industry, trade and navigation and other services n.e.c.",
    },
    {
      value: "[46611]Wholesale of petrol, diesel, lubricants",
      label: "[46611]Wholesale of petrol, diesel, lubricants",
    },
    {
      value: "[46612]Wholesale of liquefied petroleum gas",
      label: "[46612]Wholesale of liquefied petroleum gas",
    },
    {
      value: "[46619]Wholesale of other solid, liquid and gaseous fuels and related products n.e.c.",
      label: "[46619]Wholesale of other solid, liquid and gaseous fuels and related products n.e.c.",
    },
    {
      value: "[46621]Wholesale of ferrous and non-ferrous metal ores and metals",
      label: "[46621]Wholesale of ferrous and non-ferrous metal ores and metals",
    },
    {
      value: "[46622]Wholesale of ferrous and non-ferrous semi-finished metal ores and products n.e.c.",
      label: "[46622]Wholesale of ferrous and non-ferrous semi-finished metal ores and products n.e.c.",
    },
    {
      value: "[46631]Wholesale of logs, sawn timber, plywood, veneer and related products",
      label: "[46631]Wholesale of logs, sawn timber, plywood, veneer and related products",
    },
    {
      value: "[46632]Wholesale of paints and varnish",
      label: "[46632]Wholesale of paints and varnish",
    },
    {
      value: "[46633]Wholesale of construction materials",
      label: "[46633]Wholesale of construction materials",
    },
    {
      value: "[46634]Wholesale of fittings and fixtures",
      label: "[46634]Wholesale of fittings and fixtures",
    },
    {
      value: "[46635]Wholesale of hot water heaters",
      label: "[46635]Wholesale of hot water heaters",
    },
    {
      value: "[46636]Wholesale of sanitary installation and equipment",
      label: "[46636]Wholesale of sanitary installation and equipment",
    },
    {
      value: "[46637]Wholesale of tools",
      label: "[46637]Wholesale of tools",
    },
    {
      value: "[46639]Wholesale of other construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
      label: "[46639]Wholesale of other construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
    },
    {
      value: "[46691]Wholesale of industrial chemicals",
      label: "[46691]Wholesale of industrial chemicals",
    },
    {
      value: "[46692]Wholesale of fertilizers and agrochemical products",
      label: "[46692]Wholesale of fertilizers and agrochemical products",
    },
    {
      value: "[46693]Wholesale of plastic materials in primary forms",
      label: "[46693]Wholesale of plastic materials in primary forms",
    },
    {
      value: "[46694]Wholesale of rubber scrap",
      label: "[46694]Wholesale of rubber scrap",
    },
    {
      value: "[46695]Wholesale of textile fibres",
      label: "[46695]Wholesale of textile fibres",
    },
    {
      value: "[46696]Wholesale of paper in bulk, packaging materials",
      label: "[46696]Wholesale of paper in bulk, packaging materials",
    },
    {
      value: "[46697]Wholesale of precious stones",
      label: "[46697]Wholesale of precious stones",
    },
    {
      value: "[46698]Wholesale of metal and non-metal waste and scrap and materials for recycling",
      label: "[46698]Wholesale of metal and non-metal waste and scrap and materials for recycling",
    },
    {
      value: "[46699]Dismantling of automobiles, computer, televisions and other equipment to obtain and re-sell usable parts",
      label: "[46699]Dismantling of automobiles, computer, televisions and other equipment to obtain and re-sell usable parts",
    },
    {
      value: "[46901]Wholesale of aquarium fishes, pet birds and animals",
      label: "[46901]Wholesale of aquarium fishes, pet birds and animals",
    },
    {
      value: "[46902]Wholesale of animal/pet food",
      label: "[46902]Wholesale of animal/pet food",
    },
    {
      value: "[46909]Wholesale of a variety of goods without any particular specialization n.e.c.",
      label: "[46909]Wholesale of a variety of goods without any particular specialization n.e.c.",
    },
    {
      value: "[47111]Provision stores",
      label: "[47111]Provision stores",
    },
    {
      value: "[47112]Supermarket",
      label: "[47112]Supermarket",
    },
    {
      value: "[47113]Mini market",
      label: "[47113]Mini market",
    },
    {
      value: "[47114]Convenience stores",
      label: "[47114]Convenience stores",
    },
    {
      value: "[47191]Department stores",
      label: "[47191]Department stores",
    },
    {
      value: "[47192]Department stores and supermarket",
      label: "[47192]Department stores and supermarket",
    },
    {
      value: "[47193]Hypermarket",
      label: "[47193]Hypermarket",
    },
    {
      value: "[47194]News agent and miscellaneous goods store",
      label: "[47194]News agent and miscellaneous goods store",
    },
    {
      value: "[47199]Other retail sale in non-specialized stores n.e.c.",
      label: "[47199]Other retail sale in non-specialized stores n.e.c.",
    },
    {
      value: "[47211]Retail sale of rice, flour, other grains and sugars",
      label: "[47211]Retail sale of rice, flour, other grains and sugars",
    },
    {
      value: "[47212]Retail sale of fresh or preserved vegetables and fruits",
      label: "[47212]Retail sale of fresh or preserved vegetables and fruits",
    },
    {
      value: "[47213]Retail sale of dairy products and eggs",
      label: "[47213]Retail sale of dairy products and eggs",
    },
    {
      value: "[47214]Retail sale of meat and meat products (including poultry)",
      label: "[47214]Retail sale of meat and meat products (including poultry)",
    },
    {
      value: "[47215]Retail sale of fish, other seafood and products thereof",
      label: "[47215]Retail sale of fish, other seafood and products thereof",
    },
    {
      value: "[47216]Retail sale of bakery products and sugar confectionery",
      label: "[47216]Retail sale of bakery products and sugar confectionery",
    },
    {
      value: "[47217]Retail sale of mee, kuey teow, mee hoon, wantan skins and other food products made from flour or soya",
      label: "[47217]Retail sale of mee, kuey teow, mee hoon, wantan skins and other food products made from flour or soya",
    },
    {
      value: "[47219]Retail sale of other food products n.e.c.",
      label: "[47219]Retail sale of other food products n.e.c.",
    },
    {
      value: "[47221]Retail sale of beer, wine and spirits",
      label: "[47221]Retail sale of beer, wine and spirits",
    },
    {
      value: "[47222]Retail sale of tea, coffee, soft drinks, mineral water and other beverages",
      label: "[47222]Retail sale of tea, coffee, soft drinks, mineral water and other beverages",
    },
    {
      value: "[47230]Retail sale of tobacco products in specialized store",
      label: "[47230]Retail sale of tobacco products in specialized store",
    },
    {
      value: "[47300]Retail sale of automotive fuel in specialized stores",
      label: "[47300]Retail sale of automotive fuel in specialized stores",
    },
    {
      value: "[47411]Retail sale of computers, computer equipment and supplies",
      label: "[47411]Retail sale of computers, computer equipment and supplies",
    },
    {
      value: "[47412]Retail sale of video game consoles and non-customized software",
      label: "[47412]Retail sale of video game consoles and non-customized software",
    },
    {
      value: "[47413]Retail sale of telecommunication equipment",
      label: "[47413]Retail sale of telecommunication equipment",
    },
    {
      value: "[47420]Retail sale of audio and video equipment in specialized store",
      label: "[47420]Retail sale of audio and video equipment in specialized store",
    },
    {
      value: "[47510]Retail sale of textiles in specialized stores",
      label: "[47510]Retail sale of textiles in specialized stores",
    },
    {
      value: "[47520]Retail sale of construction materials, hardware, paints and glass",
      label: "[47520]Retail sale of construction materials, hardware, paints and glass",
    },
    {
      value: "[47531]Retail sale of carpets and rugs",
      label: "[47531]Retail sale of carpets and rugs",
    },
    {
      value: "[47532]Retail sale of curtains and net curtains",
      label: "[47532]Retail sale of curtains and net curtains",
    },
    {
      value: "[47533]Retail sale of wallpaper and floor coverings",
      label: "[47533]Retail sale of wallpaper and floor coverings",
    },
    {
      value: "[47591]Retail sale of household furniture",
      label: "[47591]Retail sale of household furniture",
    },
    {
      value: "[47592]Retail sale of articles for lighting",
      label: "[47592]Retail sale of articles for lighting",
    },
    {
      value: "[47593]Retail sale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
      label: "[47593]Retail sale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
    },
    {
      value: "[47594]Retail sale of wood, cork goods and wickerwork goods",
      label: "[47594]Retail sale of wood, cork goods and wickerwork goods",
    },
    {
      value: "[47595]Retail sale of household appliances",
      label: "[47595]Retail sale of household appliances",
    },
    {
      value: "[47596]Retail sale of musical instruments and scores",
      label: "[47596]Retail sale of musical instruments and scores",
    },
    {
      value: "[47597]Retail sale of security systems",
      label: "[47597]Retail sale of security systems",
    },
    {
      value: "[47598]Retail sale of household articles and equipment n.e.c.",
      label: "[47598]Retail sale of household articles and equipment n.e.c.",
    },
    {
      value: "[47611]Retail sale of office supplies and equipment",
      label: "[47611]Retail sale of office supplies and equipment",
    },
    {
      value: "[47612]Retail sale of books, newspapers and stationary",
      label: "[47612]Retail sale of books, newspapers and stationary",
    },
    {
      value: "[47620]Retail sale of musical records, audio tapes, compact discs , cassettes, video tapes, VCDs and DVDs, blank tapes and discs",
      label: "[47620]Retail sale of musical records, audio tapes, compact discs , cassettes, video tapes, VCDs and DVDs, blank tapes and discs",
    },
    {
      value: "[47631]Retail sale of sports goods and equipments",
      label: "[47631]Retail sale of sports goods and equipments",
    },
    {
      value: "[47632]Retail sale of fishing equipment",
      label: "[47632]Retail sale of fishing equipment",
    },
    {
      value: "[47633]Retail sale of camping goods",
      label: "[47633]Retail sale of camping goods",
    },
    {
      value: "[47634]Retail sale of boats and equipments",
      label: "[47634]Retail sale of boats and equipments",
    },
    {
      value: "[47635]Retail sale of bicycles and related parts and accessories",
      label: "[47635]Retail sale of bicycles and related parts and accessories",
    },
    {
      value: "[47640]Retail sale of games and toys, made of all materials",
      label: "[47640]Retail sale of games and toys, made of all materials",
    },
    {
      value: "[47711]Retail sale of articles of clothing, articles of fur and clothing accessories",
      label: "[47711]Retail sale of articles of clothing, articles of fur and clothing accessories",
    },
    {
      value: "[47712]Retail sale of footwear",
      label: "[47712]Retail sale of footwear",
    },
    {
      value: "[47713]Retail sale of leather goods, accessories of leather and leather substitutes",
      label: "[47713]Retail sale of leather goods, accessories of leather and leather substitutes",
    },
    {
      value: "[47721]Stores specialized in retail sale of pharmaceuticals, medical and orthopaedic goods",
      label: "[47721]Stores specialized in retail sale of pharmaceuticals, medical and orthopaedic goods",
    },
    {
      value: "[47722]Stores specialized in retail sale of perfumery, cosmetic and toilet articles",
      label: "[47722]Stores specialized in retail sale of perfumery, cosmetic and toilet articles",
    },
    {
      value: "[47731]Retail sale of photographic and precision equipment",
      label: "[47731]Retail sale of photographic and precision equipment",
    },
    {
      value: "[47732]Retail sale of watches and clocks",
      label: "[47732]Retail sale of watches and clocks",
    },
    {
      value: "[47733]Retail sale of jewellery",
      label: "[47733]Retail sale of jewellery",
    },
    {
      value: "[47734]Retail sale of flowers, plants, seeds, fertilizers",
      label: "[47734]Retail sale of flowers, plants, seeds, fertilizers",
    },
    {
      value: "[47735]Retail sale of souvenirs, craftwork and religious articles",
      label: "[47735]Retail sale of souvenirs, craftwork and religious articles",
    },
    {
      value: "[47736]Retail sale of household fuel oil, cooking gas, coal and fuel wood",
      label: "[47736]Retail sale of household fuel oil, cooking gas, coal and fuel wood",
    },
    {
      value: "[47737]Retail sale of spectacles and other optical goods",
      label: "[47737]Retail sale of spectacles and other optical goods",
    },
    {
      value: "[47738]Retail sale of aquarium fishes, pet animals and pet food",
      label: "[47738]Retail sale of aquarium fishes, pet animals and pet food",
    },
    {
      value: "[47739]Other retail sale of new goods in specialized stores n.e.c.",
      label: "[47739]Other retail sale of new goods in specialized stores n.e.c.",
    },
    {
      value: "[47741]Retail sale of second-hand books",
      label: "[47741]Retail sale of second-hand books",
    },
    {
      value: "[47742]Retail sale of second-hand electrical and electronic goods",
      label: "[47742]Retail sale of second-hand electrical and electronic goods",
    },
    {
      value: "[47743]Retail sale of antiques",
      label: "[47743]Retail sale of antiques",
    },
    {
      value: "[47744]Activities of auctioning houses (retail)",
      label: "[47744]Activities of auctioning houses (retail)",
    },
    {
      value: "[47749]Retail sale of second-hand goods n.e.c.",
      label: "[47749]Retail sale of second-hand goods n.e.c.",
    },
    {
      value: "[47810]Retail sale of food, beverages and tobacco products via stalls or markets",
      label: "[47810]Retail sale of food, beverages and tobacco products via stalls or markets",
    },
    {
      value: "[47820]Retail sale of textiles, clothing and footwear via stalls or markets",
      label: "[47820]Retail sale of textiles, clothing and footwear via stalls or markets",
    },
    {
      value: "[47891]Retail sale of carpets and rugs via stalls or markets",
      label: "[47891]Retail sale of carpets and rugs via stalls or markets",
    },
    {
      value: "[47892]Retail sale of books via stalls or markets",
      label: "[47892]Retail sale of books via stalls or markets",
    },
    {
      value: "[47893]Retail sale of games and toys via stalls or markets",
      label: "[47893]Retail sale of games and toys via stalls or markets",
    },
    {
      value: "[47894]Retail sale of household appliances and consumer electronics via stall or markets",
      label: "[47894]Retail sale of household appliances and consumer electronics via stall or markets",
    },
    {
      value: "[47895]Retail sale of music and video recordings via stall or markets",
      label: "[47895]Retail sale of music and video recordings via stall or markets",
    },
    {
      value: "[47911]Retail sale of any kind of product by mail order",
      label: "[47911]Retail sale of any kind of product by mail order",
    },
    {
      value: "[47912]Retail sale of any kind of product over the Internet",
      label: "[47912]Retail sale of any kind of product over the Internet",
    },
    {
      value: "[47913]Direct sale via television, radio and telephone",
      label: "[47913]Direct sale via television, radio and telephone",
    },
    {
      value: "[47914]Internet retail auctions",
      label: "[47914]Internet retail auctions",
    },
    {
      value: "[47991]Retail sale of any kind of product by direct sales or door-to-door sales persons",
      label: "[47991]Retail sale of any kind of product by direct sales or door-to-door sales persons",
    },
    {
      value: "[47992]Retail sale of any kind of product through vending machines",
      label: "[47992]Retail sale of any kind of product through vending machines",
    },
    {
      value: "[47999]Other retail sale not in stores, stalls or markets n.e.c.",
      label: "[47999]Other retail sale not in stores, stalls or markets n.e.c.",
    },
    {
      value: "[49110]Passenger transport by inter-urban railways",
      label: "[49110]Passenger transport by inter-urban railways",
    },
    {
      value: "[49120]Freight transport by inter-urban, suburban and urban railways",
      label: "[49120]Freight transport by inter-urban, suburban and urban railways",
    },
    {
      value: "[49211]City bus services",
      label: "[49211]City bus services",
    },
    {
      value: "[49212]Urban and suburban railway passenger transport service",
      label: "[49212]Urban and suburban railway passenger transport service",
    },
    {
      value: "[49221]Express bus services",
      label: "[49221]Express bus services",
    },
    {
      value: "[49222]Employees bus services",
      label: "[49222]Employees bus services",
    },
    {
      value: "[49223]School bus services",
      label: "[49223]School bus services",
    },
    {
      value: "[49224]Taxi operation and limousine services",
      label: "[49224]Taxi operation and limousine services",
    },
    {
      value: "[49225]Rental of cars with driver",
      label: "[49225]Rental of cars with driver",
    },
    {
      value: "[49229]Other passenger land transport n.e.c.",
      label: "[49229]Other passenger land transport n.e.c.",
    },
    {
      value: "[49230]Freight transport by road",
      label: "[49230]Freight transport by road",
    },
    {
      value: "[49300]Transport via pipeline",
      label: "[49300]Transport via pipeline",
    },
    {
      value: "[50111]Operation of excursion, cruise or sightseeing boats",
      label: "[50111]Operation of excursion, cruise or sightseeing boats",
    },
    {
      value: "[50112]Operation of ferries, water taxis",
      label: "[50112]Operation of ferries, water taxis",
    },
    {
      value: "[50113]Rental of pleasure boats with crew for sea and coastal water transport",
      label: "[50113]Rental of pleasure boats with crew for sea and coastal water transport",
    },
    {
      value: "[50121]Transport of freight overseas and coastal waters, whether scheduled or not",
      label: "[50121]Transport of freight overseas and coastal waters, whether scheduled or not",
    },
    {
      value: "[50122]Transport by towing or pushing of barges, oil rigs",
      label: "[50122]Transport by towing or pushing of barges, oil rigs",
    },
    {
      value: "[50211]Transport of passenger via rivers, canals, lakes and other inland waterways",
      label: "[50211]Transport of passenger via rivers, canals, lakes and other inland waterways",
    },
    {
      value: "[50212]Rental of pleasure boats with crew for inland water transport",
      label: "[50212]Rental of pleasure boats with crew for inland water transport",
    },
    {
      value: "[50220]Transport of freight via rivers, canals, lakes and other inland waterways",
      label: "[50220]Transport of freight via rivers, canals, lakes and other inland waterways",
    },
    {
      value: "[51101]Transport of passengers by air over regular routes and on regular schedules",
      label: "[51101]Transport of passengers by air over regular routes and on regular schedules",
    },
    {
      value: "[51102]Non-scheduled transport of passenger by air",
      label: "[51102]Non-scheduled transport of passenger by air",
    },
    {
      value: "[51103]Renting of air-transport equipment with operator for the purpose of passenger transportation",
      label: "[51103]Renting of air-transport equipment with operator for the purpose of passenger transportation",
    },
    {
      value: "[51201]Transport freight by air over regular routes and on regular schedules",
      label: "[51201]Transport freight by air over regular routes and on regular schedules",
    },
    {
      value: "[51202]Non-scheduled transport of freight by air",
      label: "[51202]Non-scheduled transport of freight by air",
    },
    {
      value: "[51203]Renting of air-transport equipment with operator for the purpose of freight transportation",
      label: "[51203]Renting of air-transport equipment with operator for the purpose of freight transportation",
    },
    {
      value: "[52100]Warehousing and storage services",
      label: "[52100]Warehousing and storage services",
    },
    {
      value: "[52211]Operation of terminal facilities",
      label: "[52211]Operation of terminal facilities",
    },
    {
      value: "[52212]Towing and road side assistance",
      label: "[52212]Towing and road side assistance",
    },
    {
      value: "[52213]Operation of parking facilities for motor vehicles (parking lots)",
      label: "[52213]Operation of parking facilities for motor vehicles (parking lots)",
    },
    {
      value: "[52214]Highway, bridge and tunnel operation services",
      label: "[52214]Highway, bridge and tunnel operation services",
    },
    {
      value: "[52219]Other service activities incidental to land transportation n.e.c.",
      label: "[52219]Other service activities incidental to land transportation n.e.c.",
    },
    {
      value: "[52221]Port, harbours and piers operation services",
      label: "[52221]Port, harbours and piers operation services",
    },
    {
      value: "[52222]Vessel salvage and refloating services",
      label: "[52222]Vessel salvage and refloating services",
    },
    {
      value: "[52229]Other service activities incidental to water transportation n.e.c.",
      label: "[52229]Other service activities incidental to water transportation n.e.c.",
    },
    {
      value: "[52231]Operation of terminal facilities",
      label: "[52231]Operation of terminal facilities",
    },
    {
      value: "[52232]Airport and air-traffic-control activities",
      label: "[52232]Airport and air-traffic-control activities",
    },
    {
      value: "[52233]Ground service activities on airfields",
      label: "[52233]Ground service activities on airfields",
    },
    {
      value: "[52234]Fire fighting and fire-prevention services at airports",
      label: "[52234]Fire fighting and fire-prevention services at airports",
    },
    {
      value: "[52239]Other service activities incidental to air transportation n.e.c.",
      label: "[52239]Other service activities incidental to air transportation n.e.c.",
    },
    {
      value: "[52241]Stevedoring services",
      label: "[52241]Stevedoring services",
    },
    {
      value: "[52249]Other cargo handling activities n.e.c.",
      label: "[52249]Other cargo handling activities n.e.c.",
    },
    {
      value: "[52291]Forwarding of freight",
      label: "[52291]Forwarding of freight",
    },
    {
      value: "[52292]Brokerage for ship and aircraft space",
      label: "[52292]Brokerage for ship and aircraft space",
    },
    {
      value: "[52299]Other transportation support activities n.e.c.",
      label: "[52299]Other transportation support activities n.e.c.",
    },
    {
      value: "[53100]National postal services",
      label: "[53100]National postal services",
    },
    {
      value: "[53200]Courier activities other than national post activities",
      label: "[53200]Courier activities other than national post activities",
    },
    {
      value: "[55101]Hotels and resort hotels",
      label: "[55101]Hotels and resort hotels",
    },
    {
      value: "[55102]Motels",
      label: "[55102]Motels",
    },
    {
      value: "[55103]Apartment hotels",
      label: "[55103]Apartment hotels",
    },
    {
      value: "[55104]Chalets",
      label: "[55104]Chalets",
    },
    {
      value: "[55105]Rest house/guest house",
      label: "[55105]Rest house/guest house",
    },
    {
      value: "[55106]Bed and breakfast units",
      label: "[55106]Bed and breakfast units",
    },
    {
      value: "[55107]Hostels",
      label: "[55107]Hostels",
    },
    {
      value: "[55108]Home stay",
      label: "[55108]Home stay",
    },
    {
      value: "[55109]Other short term accommodation activities n.e.c.",
      label: "[55109]Other short term accommodation activities n.e.c.",
    },
    {
      value: "[55200]Camping grounds, recreational vehicle parks and trailer parks",
      label: "[55200]Camping grounds, recreational vehicle parks and trailer parks",
    },
    {
      value: "[55900]Other accommodation",
      label: "[55900]Other accommodation",
    },
    {
      value: "[56101]Restaurants and restaurant cum night clubs",
      label: "[56101]Restaurants and restaurant cum night clubs",
    },
    {
      value: "[56102]Cafeterias/canteens",
      label: "[56102]Cafeterias/canteens",
    },
    {
      value: "[56103]Fast-food restaurants",
      label: "[56103]Fast-food restaurants",
    },
    {
      value: "[56104]Ice cream truck vendors and parlours",
      label: "[56104]Ice cream truck vendors and parlours",
    },
    {
      value: "[56105]Mobile food carts",
      label: "[56105]Mobile food carts",
    },
    {
      value: "[56106]Food stalls/hawkers",
      label: "[56106]Food stalls/hawkers",
    },
    {
      value: "[56107]Food or beverage, food and beverage preparation in market stalls/hawkers",
      label: "[56107]Food or beverage, food and beverage preparation in market stalls/hawkers",
    },
    {
      value: "[56210]Event/food caterers",
      label: "[56210]Event/food caterers",
    },
    {
      value: "[56290]Other food service activities",
      label: "[56290]Other food service activities",
    },
    {
      value: "[56301]Pubs, bars, discotheques, coffee houses, cocktail lounges and karaoke",
      label: "[56301]Pubs, bars, discotheques, coffee houses, cocktail lounges and karaoke",
    },
    {
      value: "[56302]Coffee shops",
      label: "[56302]Coffee shops",
    },
    {
      value: "[56303]Drink stalls/hawkers",
      label: "[56303]Drink stalls/hawkers",
    },
    {
      value: "[56304]Mobile beverage",
      label: "[56304]Mobile beverage",
    },
    {
      value: "[56309]Others drinking places n.e.c.",
      label: "[56309]Others drinking places n.e.c.",
    },
    {
      value: "[58110]Publishing of books, brochures and other publications",
      label: "[58110]Publishing of books, brochures and other publications",
    },
    {
      value: "[58120]Publishing of mailing lists, telephone book, other directories",
      label: "[58120]Publishing of mailing lists, telephone book, other directories",
    },
    {
      value: "[58130]Publishing of newspapers, journals, magazines and periodicals in print or electronic form",
      label: "[58130]Publishing of newspapers, journals, magazines and periodicals in print or electronic form",
    },
    {
      value:
        "[58190]Publishing of catalogues, photos, engraving and postcards, greeting cards, forms, posters, reproduction of works of art, advertising material and other printed matter n.e.c.",
      label:
        "[58190]Publishing of catalogues, photos, engraving and postcards, greeting cards, forms, posters, reproduction of works of art, advertising material and other printed matter n.e.c.",
    },
    {
      value: "[58201]Business and other applications",
      label: "[58201]Business and other applications",
    },
    {
      value: "[58202]Computer games for all platforms",
      label: "[58202]Computer games for all platforms",
    },
    {
      value: "[58203]Operating systems",
      label: "[58203]Operating systems",
    },
    {
      value: "[59110]Motion picture, video and television programme production activities",
      label: "[59110]Motion picture, video and television programme production activities",
    },
    {
      value: "[59120]Motion picture, video and television programme post-production activities",
      label: "[59120]Motion picture, video and television programme post-production activities",
    },
    {
      value: "[59130]Motion picture, video and television programme distribution activities",
      label: "[59130]Motion picture, video and television programme distribution activities",
    },
    {
      value: "[59140]Motion picture projection activities",
      label: "[59140]Motion picture projection activities",
    },
    {
      value: "[59200]Sound recording and music publishing activities",
      label: "[59200]Sound recording and music publishing activities",
    },
    {
      value: "[60100]Radio broadcasting",
      label: "[60100]Radio broadcasting",
    },
    {
      value: "[60200]Television programming and broadcasting activities",
      label: "[60200]Television programming and broadcasting activities",
    },
    {
      value: "[61101]Wired telecommunications services",
      label: "[61101]Wired telecommunications services",
    },
    {
      value: "[61102]Internet access providers by the operator of the wired infrastructure",
      label: "[61102]Internet access providers by the operator of the wired infrastructure",
    },
    {
      value: "[61201]Wireless telecommunications services",
      label: "[61201]Wireless telecommunications services",
    },
    {
      value: "[61202]Internet access providers by the operator of the wireless infrastructure",
      label: "[61202]Internet access providers by the operator of the wireless infrastructure",
    },
    {
      value: "[61300]Satellite telecommunications services",
      label: "[61300]Satellite telecommunications services",
    },
    {
      value: "[61901]Provision of Internet access over networks between the client and the ISP not owned or controlled by the ISP",
      label: "[61901]Provision of Internet access over networks between the client and the ISP not owned or controlled by the ISP",
    },
    {
      value: "[61902]Provision of telecommunications services over existing telecom connection",
      label: "[61902]Provision of telecommunications services over existing telecom connection",
    },
    {
      value: "[61903]Telecommunications resellers",
      label: "[61903]Telecommunications resellers",
    },
    {
      value: "[61904]Provision of telecommunications services over existing telecom connections VOIP (Voice Over Internet Protocol) provision",
      label: "[61904]Provision of telecommunications services over existing telecom connections VOIP (Voice Over Internet Protocol) provision",
    },
    {
      value: "[61905]Provision of specialized telecommunications applications",
      label: "[61905]Provision of specialized telecommunications applications",
    },
    {
      value: "[61909]Other telecommunications activities n.e.c.",
      label: "[61909]Other telecommunications activities n.e.c.",
    },
    {
      value: "[62010]Computer programming activities",
      label: "[62010]Computer programming activities",
    },
    {
      value: "[62021]Computer consultancy",
      label: "[62021]Computer consultancy",
    },
    {
      value: "[62022]Computer facilities management activities",
      label: "[62022]Computer facilities management activities",
    },
    {
      value: "[62091]Information Communication Technology (ICT) system security",
      label: "[62091]Information Communication Technology (ICT) system security",
    },
    {
      value: "[62099]Other information technology service activities n.e.c.",
      label: "[62099]Other information technology service activities n.e.c.",
    },
    {
      value: "[63111]Activities of providing infrastructure for hosting, data processing services and related activities",
      label: "[63111]Activities of providing infrastructure for hosting, data processing services and related activities",
    },
    {
      value: "[63112]Data processing activities",
      label: "[63112]Data processing activities",
    },
    {
      value: "[63120]Web portals",
      label: "[63120]Web portals",
    },
    {
      value: "[63910]News syndicate and news agency activities",
      label: "[63910]News syndicate and news agency activities",
    },
    {
      value: "[63990]Other information service activities n.e.c.",
      label: "[63990]Other information service activities n.e.c.",
    },
    {
      value: "[64110]Central banking",
      label: "[64110]Central banking",
    },
    {
      value: "[64191]Commercial Banks",
      label: "[64191]Commercial Banks",
    },
    {
      value: "[64192]Islamic Banks",
      label: "[64192]Islamic Banks",
    },
    {
      value: "[64193]Offshore Banks",
      label: "[64193]Offshore Banks",
    },
    {
      value: "[64194]Investment Banks",
      label: "[64194]Investment Banks",
    },
    {
      value: "[64195]Development financial institutions (with deposit taking functions)",
      label: "[64195]Development financial institutions (with deposit taking functions)",
    },
    {
      value: "[64199]Other monetary intermediation (with deposit taking functions) n.e.c.",
      label: "[64199]Other monetary intermediation (with deposit taking functions) n.e.c.",
    },
    {
      value: "[64200]Activities of holding companies",
      label: "[64200]Activities of holding companies",
    },
    {
      value: "[64301]Venture capital companies",
      label: "[64301]Venture capital companies",
    },
    {
      value: "[64302]Unit trust fund excludes REITs",
      label: "[64302]Unit trust fund excludes REITs",
    },
    {
      value: "[64303]Property unit trust (REITs)",
      label: "[64303]Property unit trust (REITs)",
    },
    {
      value: "[64304]Other administration of trusts accounts",
      label: "[64304]Other administration of trusts accounts",
    },
    {
      value: "[64309]Trusts, funds and similar financial entities n.e.c.",
      label: "[64309]Trusts, funds and similar financial entities n.e.c.",
    },
    {
      value: "[64910]Financial leasing activities",
      label: "[64910]Financial leasing activities",
    },
    {
      value: "[64921]Development financial institutions (without deposit taking functions)",
      label: "[64921]Development financial institutions (without deposit taking functions)",
    },
    {
      value: "[64922]Credit card services",
      label: "[64922]Credit card services",
    },
    {
      value: "[64923]Licensed money lending activities",
      label: "[64923]Licensed money lending activities",
    },
    {
      value: "[64924]Pawnshops and pawnbrokers includes Ar-Rahnu",
      label: "[64924]Pawnshops and pawnbrokers includes Ar-Rahnu",
    },
    {
      value: "[64925]Co-operative with credits functions",
      label: "[64925]Co-operative with credits functions",
    },
    {
      value: "[64929]Other credit granting n.e.c.",
      label: "[64929]Other credit granting n.e.c.",
    },
    {
      value: "[64991]Factoring companies",
      label: "[64991]Factoring companies",
    },
    {
      value: "[64992]Representative office of foreign banks",
      label: "[64992]Representative office of foreign banks",
    },
    {
      value: "[64993]Nominee companies",
      label: "[64993]Nominee companies",
    },
    {
      value: "[64999]Other financial service activities, except insurance/takaful and pension funding n.e.c.",
      label: "[64999]Other financial service activities, except insurance/takaful and pension funding n.e.c.",
    },
    {
      value: "[65111]Life insurance",
      label: "[65111]Life insurance",
    },
    {
      value: "[65112]Family takaful",
      label: "[65112]Family takaful",
    },
    {
      value: "[65121]General insurance",
      label: "[65121]General insurance",
    },
    {
      value: "[65122]General takaful",
      label: "[65122]General takaful",
    },
    {
      value: "[65123]Composite insurance",
      label: "[65123]Composite insurance",
    },
    {
      value: "[65124]Offshore insurance",
      label: "[65124]Offshore insurance",
    },
    {
      value: "[65125]Offshore takaful",
      label: "[65125]Offshore takaful",
    },
    {
      value: "[65201]Life reinsurance",
      label: "[65201]Life reinsurance",
    },
    {
      value: "[65202]Family retakaful",
      label: "[65202]Family retakaful",
    },
    {
      value: "[65203]General reinsurance",
      label: "[65203]General reinsurance",
    },
    {
      value: "[65204]General retakaful",
      label: "[65204]General retakaful",
    },
    {
      value: "[65205]Composite retakaful",
      label: "[65205]Composite retakaful",
    },
    {
      value: "[65206]Offshore reinsurance",
      label: "[65206]Offshore reinsurance",
    },
    {
      value: "[65207]Offshore retakaful",
      label: "[65207]Offshore retakaful",
    },
    {
      value: "[65301]Pension funding",
      label: "[65301]Pension funding",
    },
    {
      value: "[65302]Provident funding",
      label: "[65302]Provident funding",
    },
    {
      value: "[66111]Stock exchanges",
      label: "[66111]Stock exchanges",
    },
    {
      value: "[66112]Exchanges for commodity contracts",
      label: "[66112]Exchanges for commodity contracts",
    },
    {
      value: "[66113]Securities exchange",
      label: "[66113]Securities exchange",
    },
    {
      value: "[66114]Exchanges for commodity futures contracts",
      label: "[66114]Exchanges for commodity futures contracts",
    },
    {
      value: "[66119]Administration of financial markets n.e.c.",
      label: "[66119]Administration of financial markets n.e.c.",
    },
    {
      value: "[66121]Stock, share and bond brokers",
      label: "[66121]Stock, share and bond brokers",
    },
    {
      value: "[66122]Commodity brokers and dealers",
      label: "[66122]Commodity brokers and dealers",
    },
    {
      value: "[66123]Gold bullion dealers",
      label: "[66123]Gold bullion dealers",
    },
    {
      value: "[66124]Foreign exchange broker and dealers (Bureaux de change)",
      label: "[66124]Foreign exchange broker and dealers (Bureaux de change)",
    },
    {
      value: "[66125]Money-changing services",
      label: "[66125]Money-changing services",
    },
    {
      value: "[66129]Other financial and commodity futures brokers and dealers",
      label: "[66129]Other financial and commodity futures brokers and dealers",
    },
    {
      value: "[66191]Investment advisory services",
      label: "[66191]Investment advisory services",
    },
    {
      value: "[66192]Financial consultancy services",
      label: "[66192]Financial consultancy services",
    },
    {
      value: "[66199]Activities auxiliary to finance n.e.c.",
      label: "[66199]Activities auxiliary to finance n.e.c.",
    },
    {
      value: "[66211]Insurance adjusting service",
      label: "[66211]Insurance adjusting service",
    },
    {
      value: "[66212]Takaful adjusting service",
      label: "[66212]Takaful adjusting service",
    },
    {
      value: "[66221]Insurance agents",
      label: "[66221]Insurance agents",
    },
    {
      value: "[66222]Takaful agents",
      label: "[66222]Takaful agents",
    },
    {
      value: "[66223]Insurance brokers",
      label: "[66223]Insurance brokers",
    },
    {
      value: "[66224]Takaful brokers",
      label: "[66224]Takaful brokers",
    },
    {
      value: "[66290]Other activities auxiliary to insurance, takaful and pension funding",
      label: "[66290]Other activities auxiliary to insurance, takaful and pension funding",
    },
    {
      value: "[66301]Management of pension funds",
      label: "[66301]Management of pension funds",
    },
    {
      value: "[66302]Assets/portfolio management",
      label: "[66302]Assets/portfolio management",
    },
    {
      value: "[66303]Unit trust management companies",
      label: "[66303]Unit trust management companies",
    },
    {
      value: "[68101]Buying, selling, renting and operating of self-owned or leased real estate – residential buildings",
      label: "[68101]Buying, selling, renting and operating of self-owned or leased real estate – residential buildings",
    },
    {
      value: "[68102]Buying, selling, renting and operating of self-owned or leased real estate – non-residential buildings",
      label: "[68102]Buying, selling, renting and operating of self-owned or leased real estate – non-residential buildings",
    },
    {
      value: "[68103]Buying, selling, renting and operating of self-owned or leased real estate – land",
      label: "[68103]Buying, selling, renting and operating of self-owned or leased real estate – land",
    },
    {
      value: "[68104]Development of building projects for own operation, i.e. for renting of space in these buildings",
      label: "[68104]Development of building projects for own operation, i.e. for renting of space in these buildings",
    },
    {
      value: "[68109]Real estate activities with own or leased property n.e.c.",
      label: "[68109]Real estate activities with own or leased property n.e.c.",
    },
    {
      value: "[68201]Activities of real estate agents and brokers for buying, selling and renting of real estate",
      label: "[68201]Activities of real estate agents and brokers for buying, selling and renting of real estate",
    },
    {
      value: "[68202]Management of real estate on a fee or contract basis",
      label: "[68202]Management of real estate on a fee or contract basis",
    },
    {
      value: "[68203]Appraisal services for real estate",
      label: "[68203]Appraisal services for real estate",
    },
    {
      value: "[68209]Real estate activities on a fee or contract basis n.e.c.",
      label: "[68209]Real estate activities on a fee or contract basis n.e.c.",
    },
    {
      value: "[69100]Legal activities",
      label: "[69100]Legal activities",
    },
    {
      value: "[69200]Accounting, bookkeeping and auditing activities; tax consultancy",
      label: "[69200]Accounting, bookkeeping and auditing activities; tax consultancy",
    },
    {
      value: "[70100]Activities of head offices",
      label: "[70100]Activities of head offices",
    },
    {
      value: "[70201]Business management consultancy services",
      label: "[70201]Business management consultancy services",
    },
    {
      value: "[70202]Human resource consultancy services",
      label: "[70202]Human resource consultancy services",
    },
    {
      value: "[70203]Consultancy services in public relation and communications",
      label: "[70203]Consultancy services in public relation and communications",
    },
    {
      value: "[70209]Other management consultancy activities n.e.c",
      label: "[70209]Other management consultancy activities n.e.c",
    },
    {
      value: "[71101]Architectural services",
      label: "[71101]Architectural services",
    },
    {
      value: "[71102]Engineering services",
      label: "[71102]Engineering services",
    },
    {
      value: "[71103]Land surveying services",
      label: "[71103]Land surveying services",
    },
    {
      value: "[71109]Other architectural and engineering activities and related technical consultancy n.e.c.",
      label: "[71109]Other architectural and engineering activities and related technical consultancy n.e.c.",
    },
    {
      value: "[71200]Technical testing and analysis",
      label: "[71200]Technical testing and analysis",
    },
    {
      value: "[72101]Research and development on natural sciences",
      label: "[72101]Research and development on natural sciences",
    },
    {
      value: "[72102]Research and development on engineering and technology",
      label: "[72102]Research and development on engineering and technology",
    },
    {
      value: "[72103]Research and development on medical sciences",
      label: "[72103]Research and development on medical sciences",
    },
    {
      value: "[72104]Research and development on biotechnology",
      label: "[72104]Research and development on biotechnology",
    },
    {
      value: "[72105]Research and development on agricultural sciences",
      label: "[72105]Research and development on agricultural sciences",
    },
    {
      value: "[72106]Research and development on Information Communication Technology (ICT)",
      label: "[72106]Research and development on Information Communication Technology (ICT)",
    },
    {
      value: "[72109]Research and development on other natural science and engineering n.e.c.",
      label: "[72109]Research and development on other natural science and engineering n.e.c.",
    },
    {
      value: "[72201]Research and development on social sciences",
      label: "[72201]Research and development on social sciences",
    },
    {
      value: "[72202]Research and development on humanities",
      label: "[72202]Research and development on humanities",
    },
    {
      value: "[72209]Research and development of other social sciences and humanities n.e.c.",
      label: "[72209]Research and development of other social sciences and humanities n.e.c.",
    },
    {
      value: "[73100]Advertising",
      label: "[73100]Advertising",
    },
    {
      value: "[73200]Market research and public opinion polling",
      label: "[73200]Market research and public opinion polling",
    },
    {
      value: "[74101]Activities of interior decorators",
      label: "[74101]Activities of interior decorators",
    },
    {
      value: "[74102]Services of graphic designers",
      label: "[74102]Services of graphic designers",
    },
    {
      value: "[74103]Fashion design services",
      label: "[74103]Fashion design services",
    },
    {
      value: "[74109]Specialized design activities n.e.c.",
      label: "[74109]Specialized design activities n.e.c.",
    },
    {
      value: "[74200]Photographic activities",
      label: "[74200]Photographic activities",
    },
    {
      value: "[74901]Translation and interpretation activities",
      label: "[74901]Translation and interpretation activities",
    },
    {
      value: "[74902]Business brokerage activities",
      label: "[74902]Business brokerage activities",
    },
    {
      value: "[74903]Security consulting",
      label: "[74903]Security consulting",
    },
    {
      value: "[74904]Activities of quantity surveyors",
      label: "[74904]Activities of quantity surveyors",
    },
    {
      value: "[74905]Activities of consultants other than architecture, engineering and management consultants",
      label: "[74905]Activities of consultants other than architecture, engineering and management consultants",
    },
    {
      value: "[74909]Any other professional, scientific and technical activities n.e.c.",
      label: "[74909]Any other professional, scientific and technical activities n.e.c.",
    },
    {
      value: "[75000]VETERINARY ACTIVITIES",
      label: "[75000]VETERINARY ACTIVITIES",
    },
    {
      value: "[77101]Renting and operational leasing of passenger cars (without driver)",
      label: "[77101]Renting and operational leasing of passenger cars (without driver)",
    },
    {
      value: "[77102]Renting and operational leasing of trucks, utility trailers and recreational vehicles",
      label: "[77102]Renting and operational leasing of trucks, utility trailers and recreational vehicles",
    },
    {
      value: "[77211]Renting and leasing of pleasure boats, canoes, sailboats",
      label: "[77211]Renting and leasing of pleasure boats, canoes, sailboats",
    },
    {
      value: "[77212]Renting and leasing of bicycles",
      label: "[77212]Renting and leasing of bicycles",
    },
    {
      value: "[77213]Renting and leasing of beach chairs and umbrellas",
      label: "[77213]Renting and leasing of beach chairs and umbrellas",
    },
    {
      value: "[77219]Renting and leasing of other sports equipment n.e.c.",
      label: "[77219]Renting and leasing of other sports equipment n.e.c.",
    },
    {
      value: "[77220]Renting of video tapes, records, CDs, DVDs",
      label: "[77220]Renting of video tapes, records, CDs, DVDs",
    },
    {
      value: "[77291]Renting and leasing of textiles, wearing apparel and footwear",
      label: "[77291]Renting and leasing of textiles, wearing apparel and footwear",
    },
    {
      value: "[77292]Renting and leasing of furniture, pottery and glass, kitchen and tableware, electrical appliances and house wares",
      label: "[77292]Renting and leasing of furniture, pottery and glass, kitchen and tableware, electrical appliances and house wares",
    },
    {
      value: "[77293]Renting and leasing of jewellery, musical instruments, scenery and costumes",
      label: "[77293]Renting and leasing of jewellery, musical instruments, scenery and costumes",
    },
    {
      value: "[77294]Renting and leasing of books, journals and magazines",
      label: "[77294]Renting and leasing of books, journals and magazines",
    },
    {
      value: "[77295]Renting and leasing of machinery and equipment used by amateurs or as a hobby",
      label: "[77295]Renting and leasing of machinery and equipment used by amateurs or as a hobby",
    },
    {
      value: "[77296]Renting of flowers and plants",
      label: "[77296]Renting of flowers and plants",
    },
    {
      value: "[77297]Renting and leasing of electronic equipment for household use",
      label: "[77297]Renting and leasing of electronic equipment for household use",
    },
    {
      value: "[77299]Renting and leasing of other personal and household goods n.e.c.",
      label: "[77299]Renting and leasing of other personal and household goods n.e.c.",
    },
    {
      value:
        "[77301]Renting and operational leasing, without operator, of other machinery and equipment that are generally used as capital goods by industries",
      label:
        "[77301]Renting and operational leasing, without operator, of other machinery and equipment that are generally used as capital goods by industries",
    },
    {
      value: "[77302]Renting and operational leasing of land-transport equipment (other than motor vehicles) without drivers",
      label: "[77302]Renting and operational leasing of land-transport equipment (other than motor vehicles) without drivers",
    },
    {
      value: "[77303]Renting and operational leasing of water-transport equipment without operator",
      label: "[77303]Renting and operational leasing of water-transport equipment without operator",
    },
    {
      value: "[77304]Renting and operational leasing of air transport equipment without operator",
      label: "[77304]Renting and operational leasing of air transport equipment without operator",
    },
    {
      value: "[77305]Renting and operational leasing of agricultural and forestry machinery and equipment without operator",
      label: "[77305]Renting and operational leasing of agricultural and forestry machinery and equipment without operator",
    },
    {
      value: "[77306]Renting and operational leasing of construction and civil-engineering machinery and equipment without operator",
      label: "[77306]Renting and operational leasing of construction and civil-engineering machinery and equipment without operator",
    },
    {
      value: "[77307]Rental and operational leasing of office machinery and equipment without operator",
      label: "[77307]Rental and operational leasing of office machinery and equipment without operator",
    },
    {
      value: "[77309]Renting and leasing of other machinery, equipment and tangible goods n.e.c.",
      label: "[77309]Renting and leasing of other machinery, equipment and tangible goods n.e.c.",
    },
    {
      value: "[77400]Leasing of intellectual property and similar products, except copyrighted works",
      label: "[77400]Leasing of intellectual property and similar products, except copyrighted works",
    },
    {
      value: "[78100]Activities of employment placement agencies",
      label: "[78100]Activities of employment placement agencies",
    },
    {
      value: "[78200]Temporary employment agency activities",
      label: "[78200]Temporary employment agency activities",
    },
    {
      value: "[78300]Provision of human resources for client businesses",
      label: "[78300]Provision of human resources for client businesses",
    },
    {
      value: "[79110]Travel agency activities",
      label: "[79110]Travel agency activities",
    },
    {
      value: "[79120]Tour operator activities",
      label: "[79120]Tour operator activities",
    },
    {
      value: "[79900]Other reservation service and related activities",
      label: "[79900]Other reservation service and related activities",
    },
    {
      value: "[80100]Private security activities",
      label: "[80100]Private security activities",
    },
    {
      value: "[80200]Security systems service activities",
      label: "[80200]Security systems service activities",
    },
    {
      value: "[80300]Investigation and detective activities",
      label: "[80300]Investigation and detective activities",
    },
    {
      value: "[81100]Combined facilities support activities",
      label: "[81100]Combined facilities support activities",
    },
    {
      value: "[81210]General cleaning of buildings",
      label: "[81210]General cleaning of buildings",
    },
    {
      value: "[81291]Cleaning of buildings of all types",
      label: "[81291]Cleaning of buildings of all types",
    },
    {
      value: "[81292]Swimming pool cleaning and maintenance services",
      label: "[81292]Swimming pool cleaning and maintenance services",
    },
    {
      value: "[81293]Cleaning of industrial machinery",
      label: "[81293]Cleaning of industrial machinery",
    },
    {
      value: "[81294]Cleaning of trains, buses, planes",
      label: "[81294]Cleaning of trains, buses, planes",
    },
    {
      value: "[81295]Cleaning of pest control services not in connection with agriculture",
      label: "[81295]Cleaning of pest control services not in connection with agriculture",
    },
    {
      value: "[81296]Disinfecting and exterminating activities",
      label: "[81296]Disinfecting and exterminating activities",
    },
    {
      value: "[81297]Cleaning of sea tankers",
      label: "[81297]Cleaning of sea tankers",
    },
    {
      value: "[81299]Other building and industrial cleaning activities, n.e.c.",
      label: "[81299]Other building and industrial cleaning activities, n.e.c.",
    },
    {
      value: "[81300]Landscape care and maintenance service activities",
      label: "[81300]Landscape care and maintenance service activities",
    },
    {
      value: "[82110]Combined office administrative service activities",
      label: "[82110]Combined office administrative service activities",
    },
    {
      value: "[82191]Document preparation, editing and/or proofreading",
      label: "[82191]Document preparation, editing and/or proofreading",
    },
    {
      value: "[82192]Typing, word processing or desktop publishing",
      label: "[82192]Typing, word processing or desktop publishing",
    },
    {
      value: "[82193]Secretarial support services",
      label: "[82193]Secretarial support services",
    },
    {
      value: "[82194]Transcription of documents and other secretarial services",
      label: "[82194]Transcription of documents and other secretarial services",
    },
    {
      value: "[82195]Provision of mailbox rental and other postal and mailing services",
      label: "[82195]Provision of mailbox rental and other postal and mailing services",
    },
    {
      value: "[82196]Photocopying, duplicating, blueprinting",
      label: "[82196]Photocopying, duplicating, blueprinting",
    },
    {
      value: "[82199]Photocopying, document preparation and other specialized office support activities n.e.c.",
      label: "[82199]Photocopying, document preparation and other specialized office support activities n.e.c.",
    },
    {
      value: "[82200]Activities of call centres",
      label: "[82200]Activities of call centres",
    },
    {
      value: "[82301]Organization, promotions and/or management of event",
      label: "[82301]Organization, promotions and/or management of event",
    },
    {
      value: "[82302]Meeting, incentive, convention, exhibition (MICE)",
      label: "[82302]Meeting, incentive, convention, exhibition (MICE)",
    },
    {
      value: "[82910]Activities of collection agencies and credit bureaus",
      label: "[82910]Activities of collection agencies and credit bureaus",
    },
    {
      value: "[82920]Packaging activities on a fee or contract basis, whether or not these involve an automated process",
      label: "[82920]Packaging activities on a fee or contract basis, whether or not these involve an automated process",
    },
    {
      value: "[82990]Other business support service activities n.e.c.",
      label: "[82990]Other business support service activities n.e.c.",
    },
    {
      value: "[84111]General (overall) public administration activities",
      label: "[84111]General (overall) public administration activities",
    },
    {
      value: "[84112]Ancillary service activities for the government as a whole",
      label: "[84112]Ancillary service activities for the government as a whole",
    },
    {
      value: "[84121]Administrative educational services",
      label: "[84121]Administrative educational services",
    },
    {
      value: "[84122]Administrative health care services",
      label: "[84122]Administrative health care services",
    },
    {
      value: "[84123]Administrative housing and local government services",
      label: "[84123]Administrative housing and local government services",
    },
    {
      value: "[84124]Administrative recreational, cultural, arts and sports services",
      label: "[84124]Administrative recreational, cultural, arts and sports services",
    },
    {
      value: "[84125]Administrative religious affairs services",
      label: "[84125]Administrative religious affairs services",
    },
    {
      value: "[84126]Administrative welfare services",
      label: "[84126]Administrative welfare services",
    },
    {
      value: "[84129]Other community and social affairs services",
      label: "[84129]Other community and social affairs services",
    },
    {
      value: "[84131]Domestic and international trade affairs",
      label: "[84131]Domestic and international trade affairs",
    },
    {
      value: "[84132]Agriculture and rural development affairs",
      label: "[84132]Agriculture and rural development affairs",
    },
    {
      value: "[84133]Primary industries affairs",
      label: "[84133]Primary industries affairs",
    },
    {
      value: "[84134]Public works affairs",
      label: "[84134]Public works affairs",
    },
    {
      value: "[84135]Transport affairs",
      label: "[84135]Transport affairs",
    },
    {
      value: "[84136]Energy, telecommunication and postal affairs",
      label: "[84136]Energy, telecommunication and postal affairs",
    },
    {
      value: "[84137]Tourism affairs",
      label: "[84137]Tourism affairs",
    },
    {
      value: "[84138]Human resource affairs",
      label: "[84138]Human resource affairs",
    },
    {
      value: "[84139]Other regulation of and contribution to more efficient operation of businesses n.e.c.",
      label: "[84139]Other regulation of and contribution to more efficient operation of businesses n.e.c.",
    },
    {
      value: "[84210]Foreign affairs",
      label: "[84210]Foreign affairs",
    },
    {
      value: "[84220]Military and civil defence services",
      label: "[84220]Military and civil defence services",
    },
    {
      value: "[84231]Police service",
      label: "[84231]Police service",
    },
    {
      value: "[84232]Prison service",
      label: "[84232]Prison service",
    },
    {
      value: "[84233]Immigration service",
      label: "[84233]Immigration service",
    },
    {
      value: "[84234]National registration service",
      label: "[84234]National registration service",
    },
    {
      value: "[84235]Judiciary and legal service",
      label: "[84235]Judiciary and legal service",
    },
    {
      value: "[84236]Firefighting and fire prevention",
      label: "[84236]Firefighting and fire prevention",
    },
    {
      value: "[84239]Other public order and safety affairs related services",
      label: "[84239]Other public order and safety affairs related services",
    },
    {
      value: "[84300]Compulsory social security activities e.g. SOCSO",
      label: "[84300]Compulsory social security activities e.g. SOCSO",
    },
    {
      value: "[85101]Pre-primary education (Public)",
      label: "[85101]Pre-primary education (Public)",
    },
    {
      value: "[85102]Pre-primary education (Private)",
      label: "[85102]Pre-primary education (Private)",
    },
    {
      value: "[85103]Primary education (Public)",
      label: "[85103]Primary education (Public)",
    },
    {
      value: "[85104]Primary education (Private)",
      label: "[85104]Primary education (Private)",
    },
    {
      value: "[85211]General school secondary education (Public)",
      label: "[85211]General school secondary education (Public)",
    },
    {
      value: "[85212]General school secondary education (Private)",
      label: "[85212]General school secondary education (Private)",
    },
    {
      value: "[85221]Technical and vocational education below the level of higher education (Public)",
      label: "[85221]Technical and vocational education below the level of higher education (Public)",
    },
    {
      value: "[85222]Technical and vocational education below the level of higher education (Private)",
      label: "[85222]Technical and vocational education below the level of higher education (Private)",
    },
    {
      value: "[85301]College and university education (Public)",
      label: "[85301]College and university education (Public)",
    },
    {
      value: "[85302]College and university education (Private)",
      label: "[85302]College and university education (Private)",
    },
    {
      value: "[85411]Sports instruction",
      label: "[85411]Sports instruction",
    },
    {
      value: "[85412]Martial arts instruction",
      label: "[85412]Martial arts instruction",
    },
    {
      value: "[85419]Any other sports and recreation education n.e.c",
      label: "[85419]Any other sports and recreation education n.e.c",
    },
    {
      value: "[85421]Music and dancing school",
      label: "[85421]Music and dancing school",
    },
    {
      value: "[85429]Any other cultural education n.e.c.",
      label: "[85429]Any other cultural education n.e.c.",
    },
    {
      value: "[85491]Tuition centre",
      label: "[85491]Tuition centre",
    },
    {
      value: "[85492]Driving school",
      label: "[85492]Driving school",
    },
    {
      value: "[85493]Religious instruction",
      label: "[85493]Religious instruction",
    },
    {
      value: "[85494]Computer training",
      label: "[85494]Computer training",
    },
    {
      value: "[85499]Others education n.e.c",
      label: "[85499]Others education n.e.c",
    },
    {
      value: "[85500]Educational support services for provision of non-instructional services",
      label: "[85500]Educational support services for provision of non-instructional services",
    },
    {
      value: "[86101]Hospital activities",
      label: "[86101]Hospital activities",
    },
    {
      value: "[86102]Maternity home services (outside hospital)",
      label: "[86102]Maternity home services (outside hospital)",
    },
    {
      value: "[86201]General medical services",
      label: "[86201]General medical services",
    },
    {
      value: "[86202]Specialized medical services",
      label: "[86202]Specialized medical services",
    },
    {
      value: "[86203]Dental services",
      label: "[86203]Dental services",
    },
    {
      value: "[86901]Dialysis Centres",
      label: "[86901]Dialysis Centres",
    },
    {
      value: "[86902]Medical laboratories",
      label: "[86902]Medical laboratories",
    },
    {
      value: "[86903]Physiotherapy and occupational therapy service",
      label: "[86903]Physiotherapy and occupational therapy service",
    },
    {
      value: "[86904]Acupuncture services",
      label: "[86904]Acupuncture services",
    },
    {
      value: "[86905]Herbalist and homeopathy services",
      label: "[86905]Herbalist and homeopathy services",
    },
    {
      value: "[86906]Ambulance services",
      label: "[86906]Ambulance services",
    },
    {
      value: "[86909]Other human health services n.e.c.",
      label: "[86909]Other human health services n.e.c.",
    },
    {
      value: "[87101]Homes for the elderly with nursing care",
      label: "[87101]Homes for the elderly with nursing care",
    },
    {
      value: "[87102]Nursing homes",
      label: "[87102]Nursing homes",
    },
    {
      value: "[87103]Palliative or hospices",
      label: "[87103]Palliative or hospices",
    },
    {
      value: "[87201]Drug rehabilitation centres",
      label: "[87201]Drug rehabilitation centres",
    },
    {
      value: "[87209]Other residential care activities for mental retardation n.e.c.",
      label: "[87209]Other residential care activities for mental retardation n.e.c.",
    },
    {
      value: "[87300]Residential care activities for the elderly and disabled",
      label: "[87300]Residential care activities for the elderly and disabled",
    },
    {
      value: "[87901]Orphanages",
      label: "[87901]Orphanages",
    },
    {
      value: "[87902]Welfare homes services",
      label: "[87902]Welfare homes services",
    },
    {
      value: "[87909]Other residential care activities n.e.c.",
      label: "[87909]Other residential care activities n.e.c.",
    },
    {
      value: "[88101]Day-care activities for the elderly or for handicapped adults",
      label: "[88101]Day-care activities for the elderly or for handicapped adults",
    },
    {
      value: "[88109]Others social work activities without accommodation for the elderly and disabled",
      label: "[88109]Others social work activities without accommodation for the elderly and disabled",
    },
    {
      value: "[88901]Counselling service",
      label: "[88901]Counselling service",
    },
    {
      value: "[88902]Child day-care activities",
      label: "[88902]Child day-care activities",
    },
    {
      value: "[88909]Other social work activities without accommodation n.e.c.",
      label: "[88909]Other social work activities without accommodation n.e.c.",
    },
    {
      value: "[90001]Theatrical producer, singer group band and orchestra entertainment services",
      label: "[90001]Theatrical producer, singer group band and orchestra entertainment services",
    },
    {
      value: "[90002]Operation of concert and theatre halls and other arts facilities",
      label: "[90002]Operation of concert and theatre halls and other arts facilities",
    },
    {
      value: "[90003]Activities of sculptors, painters, cartoonists, engravers, etchers",
      label: "[90003]Activities of sculptors, painters, cartoonists, engravers, etchers",
    },
    {
      value: "[90004]Activities of individual writers, for all subjects",
      label: "[90004]Activities of individual writers, for all subjects",
    },
    {
      value: "[90005]Activities of independent journalists",
      label: "[90005]Activities of independent journalists",
    },
    {
      value: "[90006]Restoring of works of art such as painting",
      label: "[90006]Restoring of works of art such as painting",
    },
    {
      value: "[90007]Activities of producers or entrepreneurs of arts live events, with or without facilities",
      label: "[90007]Activities of producers or entrepreneurs of arts live events, with or without facilities",
    },
    {
      value: "[90009]Creative, arts and entertainment activities n.e.c.",
      label: "[90009]Creative, arts and entertainment activities n.e.c.",
    },
    {
      value: "[91011]Documentation and information activities of libraries of all kinds",
      label: "[91011]Documentation and information activities of libraries of all kinds",
    },
    {
      value: "[91012]Stock photo libraries and services",
      label: "[91012]Stock photo libraries and services",
    },
    {
      value: "[91021]Operation of museums of all kinds",
      label: "[91021]Operation of museums of all kinds",
    },
    {
      value: "[91022]Operation of historical sites and buildings",
      label: "[91022]Operation of historical sites and buildings",
    },
    {
      value: "[91031]Operation of botanical and zoological gardens",
      label: "[91031]Operation of botanical and zoological gardens",
    },
    {
      value: "[91032]Operation of nature reserves, including wildlife preservation",
      label: "[91032]Operation of nature reserves, including wildlife preservation",
    },
    {
      value: "[92000]GAMBLING AND BETTING ACTIVITIES",
      label: "[92000]GAMBLING AND BETTING ACTIVITIES",
    },
    {
      value: "[93111]Football, hockey, cricket, baseball, badminton, futsal, paintball",
      label: "[93111]Football, hockey, cricket, baseball, badminton, futsal, paintball",
    },
    {
      value: "[93112]Racetracks for auto",
      label: "[93112]Racetracks for auto",
    },
    {
      value: "[93113]Equestrian clubs",
      label: "[93113]Equestrian clubs",
    },
    {
      value: "[93114]Swimming pools and stadiums, ice-skating arenas",
      label: "[93114]Swimming pools and stadiums, ice-skating arenas",
    },
    {
      value: "[93115]Track and field stadium",
      label: "[93115]Track and field stadium",
    },
    {
      value: "[93116]Golf courses",
      label: "[93116]Golf courses",
    },
    {
      value: "[93117]Bowling centre",
      label: "[93117]Bowling centre",
    },
    {
      value: "[93118]Fitness centres",
      label: "[93118]Fitness centres",
    },
    {
      value: "[93119]Organization and operation of outdoor or indoor sports events for professionals or amateurs by organizations with own facilities",
      label: "[93119]Organization and operation of outdoor or indoor sports events for professionals or amateurs by organizations with own facilities",
    },
    {
      value: "[93120]The operation of sports clubs such as football club, bowling club, swimming club",
      label: "[93120]The operation of sports clubs such as football club, bowling club, swimming club",
    },
    {
      value: "[93191]Activities of producers or promoters of sports events, with or without facilities",
      label: "[93191]Activities of producers or promoters of sports events, with or without facilities",
    },
    {
      value: "[93192]Activities of sports leagues and regulating bodies",
      label: "[93192]Activities of sports leagues and regulating bodies",
    },
    {
      value: "[93193]Activities of related to promotion of sporting events",
      label: "[93193]Activities of related to promotion of sporting events",
    },
    {
      value: "[93199]Other sports activities n.e.c.",
      label: "[93199]Other sports activities n.e.c.",
    },
    {
      value: "[93210]Activities of amusement parks and theme parks",
      label: "[93210]Activities of amusement parks and theme parks",
    },
    {
      value: "[93291]Activities of recreation parks and beaches",
      label: "[93291]Activities of recreation parks and beaches",
    },
    {
      value: "[93292]Operation of recreational transport facilities",
      label: "[93292]Operation of recreational transport facilities",
    },
    {
      value: "[93293]Renting of leisure and pleasure equipment as an integral part of recreational facilities",
      label: "[93293]Renting of leisure and pleasure equipment as an integral part of recreational facilities",
    },
    {
      value: "[93294]Operation of fairs and shows of a recreational nature",
      label: "[93294]Operation of fairs and shows of a recreational nature",
    },
    {
      value: "[93295]Operation of discotheques and dance floors",
      label: "[93295]Operation of discotheques and dance floors",
    },
    {
      value: "[93296]Activities of producers or entrepreneurs of live events other than arts or sports events, with or without facilities",
      label: "[93296]Activities of producers or entrepreneurs of live events other than arts or sports events, with or without facilities",
    },
    {
      value: "[93297]Cyber Café/Internet Centre",
      label: "[93297]Cyber Café/Internet Centre",
    },
    {
      value: "[93299]Any other amusement and recreation activities n.e.c.",
      label: "[93299]Any other amusement and recreation activities n.e.c.",
    },
    {
      value: "[94110]Activities of business and employers membership organizations",
      label: "[94110]Activities of business and employers membership organizations",
    },
    {
      value: "[94120]Activities of professional membership organizations",
      label: "[94120]Activities of professional membership organizations",
    },
    {
      value: "[94200]Activities of trade unions",
      label: "[94200]Activities of trade unions",
    },
    {
      value: "[94910]Activities of religious organizations",
      label: "[94910]Activities of religious organizations",
    },
    {
      value: "[94920]Activities of political organizations",
      label: "[94920]Activities of political organizations",
    },
    {
      value: "[94990]Activities of other membership organizations n.e.c.",
      label: "[94990]Activities of other membership organizations n.e.c.",
    },
    {
      value: "[95111]Repair of electronic equipment",
      label: "[95111]Repair of electronic equipment",
    },
    {
      value: "[95112]Repair and maintenance of computer terminals",
      label: "[95112]Repair and maintenance of computer terminals",
    },
    {
      value: "[95113]Repair and maintenance of hand-held computers (PDA’s)",
      label: "[95113]Repair and maintenance of hand-held computers (PDA’s)",
    },
    {
      value: "[95121]Repair and maintenance of cordless telephones",
      label: "[95121]Repair and maintenance of cordless telephones",
    },
    {
      value: "[95122]Repair and maintenance of cellular phones",
      label: "[95122]Repair and maintenance of cellular phones",
    },
    {
      value: "[95123]Repair and maintenance of carrier equipment modems",
      label: "[95123]Repair and maintenance of carrier equipment modems",
    },
    {
      value: "[95124]Repair and maintenance of fax machines",
      label: "[95124]Repair and maintenance of fax machines",
    },
    {
      value: "[95125]Repair and maintenance of communications transmission equipment",
      label: "[95125]Repair and maintenance of communications transmission equipment",
    },
    {
      value: "[95126]Repair and maintenance of two-way radios",
      label: "[95126]Repair and maintenance of two-way radios",
    },
    {
      value: "[95127]Repair and maintenance of commercial TV and video cameras",
      label: "[95127]Repair and maintenance of commercial TV and video cameras",
    },
    {
      value: "[95211]Repair and maintenance of television, radio receivers",
      label: "[95211]Repair and maintenance of television, radio receivers",
    },
    {
      value: "[95212]Repair and maintenance of VCR/DVD/VCD",
      label: "[95212]Repair and maintenance of VCR/DVD/VCD",
    },
    {
      value: "[95213]Repair and maintenance of CD players",
      label: "[95213]Repair and maintenance of CD players",
    },
    {
      value: "[95214]Repair and maintenance of household-type video cameras",
      label: "[95214]Repair and maintenance of household-type video cameras",
    },
    {
      value: "[95221]Repair and servicing of household appliances",
      label: "[95221]Repair and servicing of household appliances",
    },
    {
      value: "[95222]Repair and servicing of home and garden equipment",
      label: "[95222]Repair and servicing of home and garden equipment",
    },
    {
      value: "[95230]Repair of footwear and leather goods",
      label: "[95230]Repair of footwear and leather goods",
    },
    {
      value: "[95240]Repair of furniture and home furnishings",
      label: "[95240]Repair of furniture and home furnishings",
    },
    {
      value: "[95291]Repair of bicycles",
      label: "[95291]Repair of bicycles",
    },
    {
      value: "[95292]Repair and alteration of clothing",
      label: "[95292]Repair and alteration of clothing",
    },
    {
      value: "[95293]Repair and alteration of jewellery",
      label: "[95293]Repair and alteration of jewellery",
    },
    {
      value: "[95294]Repair of watches, clocks and their parts",
      label: "[95294]Repair of watches, clocks and their parts",
    },
    {
      value: "[95295]Repair of sporting goods",
      label: "[95295]Repair of sporting goods",
    },
    {
      value: "[95296]Repair of musical instruments",
      label: "[95296]Repair of musical instruments",
    },
    {
      value: "[95299]Repair of other personal and household goods n.e.c.",
      label: "[95299]Repair of other personal and household goods n.e.c.",
    },
    {
      value: "[96011]Laundering and dry-cleaning, pressing",
      label: "[96011]Laundering and dry-cleaning, pressing",
    },
    {
      value: "[96012]Carpet and rug shampooing, and drapery and curtain cleaning, whether on clients’ premises or not",
      label: "[96012]Carpet and rug shampooing, and drapery and curtain cleaning, whether on clients’ premises or not",
    },
    {
      value: "[96013]Provision of linens, work uniforms and related items by laundries",
      label: "[96013]Provision of linens, work uniforms and related items by laundries",
    },
    {
      value: "[96014]Diaper supply services",
      label: "[96014]Diaper supply services",
    },
    {
      value: "[96020]Hairdressing and other beauty treatment",
      label: "[96020]Hairdressing and other beauty treatment",
    },
    {
      value: "[96031]Preparing the dead for burial or cremation and embalming and morticians’ services",
      label: "[96031]Preparing the dead for burial or cremation and embalming and morticians’ services",
    },
    {
      value: "[96032]Providing burial or cremation services",
      label: "[96032]Providing burial or cremation services",
    },
    {
      value: "[96033]Rental of equipped space in funeral parlours",
      label: "[96033]Rental of equipped space in funeral parlours",
    },
    {
      value: "[96034]Rental or sale of graves",
      label: "[96034]Rental or sale of graves",
    },
    {
      value: "[96035]Maintenance of graves and mausoleums",
      label: "[96035]Maintenance of graves and mausoleums",
    },
    {
      value: "[96091]Activities of sauna, steam baths, massage salons",
      label: "[96091]Activities of sauna, steam baths, massage salons",
    },
    {
      value: "[96092]Astrological and spiritualists’ activities",
      label: "[96092]Astrological and spiritualists’ activities",
    },
    {
      value: "[96093]Social activities such as escort services, dating services, services of marriage bureaux",
      label: "[96093]Social activities such as escort services, dating services, services of marriage bureaux",
    },
    {
      value: "[96094]Pet care services",
      label: "[96094]Pet care services",
    },
    {
      value: "[96095]Genealogical organizations",
      label: "[96095]Genealogical organizations",
    },
    {
      value: "[96096]Shoe shiners, porters, valet car parkers",
      label: "[96096]Shoe shiners, porters, valet car parkers",
    },
    {
      value: "[96097]Concession operation of coin-operated personal service machines",
      label: "[96097]Concession operation of coin-operated personal service machines",
    },
    {
      value: "[96099]Other service activities n.e.c.",
      label: "[96099]Other service activities n.e.c.",
    },
    {
      value: "[97000]Activities of households as employers of domestic personnel",
      label: "[97000]Activities of households as employers of domestic personnel",
    },
    {
      value: "[98100]Undifferentiated goods-producing activities of private households for own use",
      label: "[98100]Undifferentiated goods-producing activities of private households for own use",
    },
    {
      value: "[98200]Undifferentiated service-producing activities of private households for own use",
      label: "[98200]Undifferentiated service-producing activities of private households for own use",
    },
    {
      value: "[99000]Activities of extraterritorial organization and bodies",
      label: "[99000]Activities of extraterritorial organization and bodies",
    },
  ],
};
